/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum GetShopSkinsSortBy {
  PriceDesc = "price_desc",
  PriceAsc = "price_asc",
}

export interface GameStatsResponse {
  /**
   * Total number of case openings
   * @example 12345
   */
  caseOpenings: number;
  /**
   * Total number of contracts
   * @example 678
   */
  contracts: number;
  /**
   * Total number of upgrades
   * @example 910
   */
  upgrades: number;
  /**
   * Total number of case battles
   * @example 42
   */
  battles: number;
}

export interface Partner {
  /** Partner ID */
  id: string;
  /** User ID */
  userId: string;
  /** Partner referral code */
  partnerCode: string;
  /** Commission in rubles */
  registrationCommission: number;
  /** Commission rate (0.15 = 15%) */
  depositCommissionRate: number;
  /** Current balance in rubles */
  balance: number;
  /** Total earned in rubles */
  totalEarned: number;
  /** Total withdrawn in rubles */
  totalWithdrawn: number;
  status: PartnerStatusEnum;
  /**
   * Creation date
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date
   * @format date-time
   */
  updatedAt: string;
  /** Total users (direct + referrals) */
  totalUsers?: number;
  /** Total profit from all users in rubles */
  totalProfit?: number;
  user?: object;
}

export interface PartnerTransferInfo {
  /** Current partner balance in rubles */
  balance: number;
  status: PartnerTransferInfoStatusEnum;
  /** Credits credited per ruble transferred */
  creditsPerRuble: number;
  /** Minimum transfer amount in rubles */
  minTransferRubles: number;
}

export interface TransferPartnerBalance {
  /**
   * Amount to transfer from the partner balance, in whole rubles
   * @min 1
   * @example 500
   */
  amountRubles: number;
}

export interface TransferPartnerBalanceResponse {
  /** Transferred amount in rubles */
  amountRubles: number;
  /** Credits added to the partner account balance */
  credits: number;
  /** Partner balance after the transfer, in rubles */
  partnerBalance: number;
}

export interface PartnerDailyStats {
  /** Date (YYYY-MM-DD) */
  date: string;
  /** Number of registrations */
  registrationCount: number;
  /** Profit from registrations in rubles */
  registrationProfit: number;
  /** Profit from deposits in rubles */
  depositProfit: number;
  /** Total profit in rubles */
  totalProfit: number;
}

export interface ListPartnerDailyStatsResponse {
  stats: PartnerDailyStats[];
  /** Total number of records */
  total: number;
  /** Current page number */
  page: number;
  /** Number of records per page */
  limit: number;
}

export interface PartnerWithdrawal {
  /** Withdrawal ID */
  id: string;
  /** Partner ID */
  partnerId: string;
  /** Amount in rubles. Negative = withdrawal, Positive = deposit */
  amount: number;
  comment?: string;
  /**
   * Creation date
   * @format date-time
   */
  createdAt: string;
  partner?: Partner;
}

export interface ListPartnerWithdrawalsResponse {
  withdrawals: PartnerWithdrawal[];
  /** Total number of records */
  total: number;
  /** Current page number */
  page: number;
  /** Number of records per page */
  limit: number;
}

export interface PartnerTransaction {
  /** Transaction ID */
  id: string;
  /** Partner ID */
  partnerId: string;
  type: PartnerTransactionTypeEnum;
  /** Amount in rubles */
  amount: number;
  /** Balance before transaction in rubles */
  balanceBefore: number;
  /** Balance after transaction in rubles */
  balanceAfter: number;
  referredUserId?: string;
  referredUser?: object;
  metadata?: object;
  /**
   * Creation date
   * @format date-time
   */
  createdAt: string;
}

export interface ListPartnerTransactionsResponse {
  transactions: PartnerTransaction[];
  /** Total number of records */
  total: number;
  /** Current page number */
  page: number;
  /** Number of records per page */
  limit: number;
}

export type StartParam = object;

export interface PublicConfigResponse {
  /**
   * Yandex Metrika counter ID
   * @example 106798999
   */
  yandexMetrikaCounterId: number | null;
  /**
   * Whether Ya Mode is enabled
   * @example false
   */
  yaModeEnabled: boolean;
  /**
   * Meta (Facebook) Pixel ID
   * @example "986321990805045"
   */
  metaPixelId: string | null;
  /**
   * Whether Turnstile captcha verification is enabled
   * @example true
   */
  turnstileEnabled: boolean;
}

export interface BasicHealth {
  /** @example "ok" */
  status: BasicHealthStatusEnum;
  /** @example "2024-01-15T12:00:00.000Z" */
  timestamp: string;
  /** @example 123.45 */
  uptime: number;
}

export interface DependencyCheck {
  /** @example "ok" */
  status: DependencyCheckStatusEnum;
  /** @example 5 */
  latency?: number;
}

export interface DependencyChecks {
  database: DependencyCheck;
  redis: DependencyCheck;
}

export interface ReadinessCheck {
  /** @example "ok" */
  status: ReadinessCheckStatusEnum;
  /** @example "2024-01-15T12:00:00.000Z" */
  timestamp: string;
  checks: DependencyChecks;
}

export interface HealthCheck {
  /** @example "ok" */
  status: HealthCheckStatusEnum;
  /** @example "2024-01-15T12:00:00.000Z" */
  timestamp: string;
}

export interface RegisterUser {
  /**
   * Referral code from the inviter
   * @example "123456789"
   */
  referralCode?: string;
  /**
   * Start parameter from Telegram (startapp or bot start parameter)
   * @example "ref_123456789"
   */
  startParam?: string;
  /**
   * Yandex Metrica Client ID
   * @example "1234567890123456789"
   */
  yaClientId?: string;
  /** Account ids previously seen on this device */
  u?: string[];
}

export interface RegisterResponse {
  /**
   * Indicates if the registration was successful
   * @example true
   */
  success: boolean;
  /**
   * The unique identifier of the created user
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  userId: string;
  /**
   * Whether this is the first registration (new user) or an existing user login
   * @example true
   */
  isNewUser: boolean;
}

export interface UserProfileResponse {
  /**
   * Unique user identifier
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * User first name
   * @example "John"
   */
  firstName?: string;
  /**
   * User last name
   * @example "Doe"
   */
  lastName?: string;
  /**
   * User full name (computed)
   * @example "John Doe"
   */
  fullName: string;
  /**
   * Current credit balance
   * @example 25000
   */
  balanceInCredits: number;
  /**
   * ID of the user who referred this user
   * @example "b2c3d4e5-f6g7-8901-bcde-f23456789012"
   */
  referrerId?: string;
  /**
   * ISO 3166-1 alpha-2 country code
   * @example "US"
   */
  countryCode?: string;
  /**
   * User language preference
   * @example "ru"
   */
  languageCode?: string;
  /**
   * Whether case opening animations are enabled
   * @example true
   */
  animationsEnabled: boolean;
  /**
   * Whether notifications are enabled
   * @example true
   */
  notificationsEnabled: boolean;
  /**
   * Steam trade URL
   * @example "https://steamcommunity.com/tradeoffer/new/?partner=123456789&token=AbCdEfGh"
   */
  steamTradeUrl?: string;
  /**
   * Whether user has linked a Steam account
   * @example false
   */
  isSteamLinked: boolean;
  /**
   * Whether user has a linked Telegram identity (registered via Telegram)
   * @example true
   */
  hasTelegramIdentity: boolean;
  /**
   * Whether skins exchange feature is enabled for this user
   * @example false
   */
  skinsExchangeEnabled: boolean;
  /**
   * Whether case battles are restricted to skinExchangeEnabled users only
   * @example true
   */
  caseBattlesRestrictedMode: boolean;
  /**
   * Whether Russian Roulette is restricted to skinExchangeEnabled users only
   * @example true
   */
  rouletteRestrictedMode: boolean;
  /**
   * Whether user has opened at least one case
   * @example false
   */
  hasOpenedCases: boolean;
  /**
   * Whether user has made at least one successful payment
   * @example false
   */
  hasPayments: boolean;
  /**
   * Whether the withdrawal flow must present a Turnstile captcha for this user
   * @example true
   */
  withdrawalCaptchaRequired: boolean;
  /**
   * Account creation timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
  /**
   * Last account update timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  updatedAt: string;
  /**
   * Last time the trade link (partner ID) was changed
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  lastTradeLinkChangedAt?: string;
}

export interface TopInventoryItem {
  /**
   * Inventory item ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  inventoryItemId: string;
  /**
   * Item details
   * @example {"hashName":"AWP | Dragon Lore (Factory New)","name":"AWP | Dragon Lore","imageUrl":"https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLA...","rarityColor":"#eb4b4b","rarityName":"Covert","weapon":"AWP","category":"Rifle","statTrak":false,"souvenir":false}
   */
  item: object;
  /**
   * Price when the item was acquired (in credits)
   * @example 625000
   */
  acquiredPriceInCredits: number;
  /**
   * Price when the item was acquired (in rubles)
   * @example 2500
   */
  acquiredPriceInRubles: number;
  /**
   * Price when the item was acquired (in USD)
   * @example 27.78
   */
  acquiredPriceInUsd?: number;
  /**
   * When the item was acquired
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  acquiredAt: string;
  /**
   * Source of the item (e.g., CASE, UPGRADE, CONTRACT)
   * @example "CASE"
   */
  source: string;
}

export interface CaseOpeningStats {
  /**
   * Case ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  caseId: string;
  /**
   * Case name
   * @example "AWP Case"
   */
  caseName: string;
  /**
   * Case image URL
   * @example "https://example.com/cases/awp-case.png"
   */
  caseImageUrl: string;
  /**
   * Number of times this case was opened by the user
   * @example 45
   */
  openingsCount: number;
}

export interface Presence {
  /**
   * Whether the user is currently online
   * @example true
   */
  online: boolean;
  /**
   * What the user is currently doing (null when offline)
   * @example "opening_case"
   */
  activity?: PresenceActivityEnum;
  /**
   * When the user was last seen (ISO, null while online or if never tracked)
   * @example "2026-06-28T10:30:00.000Z"
   */
  lastSeenAt?: string | null;
}

export interface ProfileStatsResponse {
  /**
   * Full name of the user
   * @example "John Doe"
   */
  fullName: string;
  /**
   * Registration date
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
  /**
   * User level
   * @example 15
   */
  level: number;
  /**
   * Total number of cases opened by the user
   * @example 142
   */
  totalCaseOpenings: number;
  /**
   * Total value of items received from case openings (in credits)
   * @example 28750
   */
  totalItemsValueCredits: number;
  /**
   * Number of friends referred by the user
   * @example 12
   */
  referralsCount: number;
  /**
   * Total number of upgrades performed by the user
   * @example 25
   */
  totalUpgrades: number;
  /**
   * Total number of contracts executed by the user
   * @example 18
   */
  totalContracts: number;
  /**
   * Total number of Rush Mid matches the user played
   * @example 7
   */
  totalRushMidGames: number;
  /**
   * Total number of case battles the user participated in
   * @example 42
   */
  totalCaseBattles: number;
  /** Top 3 most expensive items ever acquired by the user */
  topItems: TopInventoryItem[];
  /** Aggregated statistics of case openings (grouped by case) */
  caseOpeningsStats: CaseOpeningStats[];
  /**
   * User rank position based on XP (null if excluded from rating)
   * @example 1247
   */
  xpRank?: number | null;
  /** Active SHOT BAND membership — drives the profile aura/badge */
  bandMember: boolean;
  /** Online presence and current activity of the user */
  presence: Presence;
}

export interface Referral {
  /**
   * Unique identifier of the referred user
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Username of the referred user
   * @example "johndoe"
   */
  username: string | null;
  /**
   * First name of the referred user
   * @example "John"
   */
  firstName: string | null;
  /**
   * Last name of the referred user
   * @example "Doe"
   */
  lastName: string | null;
  /**
   * Display name (computed from firstName, lastName, or username)
   * @example "John Doe"
   */
  fullName: string;
  /**
   * Credits awarded for this referral
   * @example 500
   */
  creditsAwarded: number;
  /**
   * Indicates if this is a bonus referral
   * @example false
   */
  isBonus: boolean;
  /**
   * Whether the referral has been activated (first deposit or withdrawal)
   * @example true
   */
  activated: boolean;
  /**
   * Date when the user was referred and registered
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  registeredAt: string;
}

export interface PaginationMeta {
  /**
   * Total number of items
   * @example 100
   */
  totalItems: number;
  /**
   * Number of items on current page
   * @example 20
   */
  itemCount: number;
  /**
   * Number of items per page
   * @example 20
   */
  itemsPerPage: number;
  /**
   * Total number of pages
   * @example 5
   */
  totalPages: number;
  /**
   * Current page number
   * @example 1
   */
  currentPage: number;
}

export interface PaginatedReferralsResponse {
  /** List of referred users */
  referrals: Referral[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface ReferralStatsResponse {
  /**
   * Total number of referred users
   * @example 8
   */
  totalReferrals: number;
  /**
   * Total credits earned from referrals (base bonuses + 10th friend bonuses + deposit percentages)
   * @example 5500
   */
  totalEarned: number;
  /**
   * Progress towards next referral bonus (0-9). Every 10th valid referral gives a bonus.
   * @min 0
   * @max 9
   * @example 3
   */
  progressToBonus: number;
  /**
   * Credits paid for the next activated friend (raised during the contest)
   * @example 6000
   */
  rewardCredits: number;
}

export interface SavePreparedInlineMessageButton {
  /** Button text */
  text: string;
  /** Button URL */
  url: string;
}

export interface SavePreparedInlineMessage {
  /** Image URL for the inline message */
  imageUrl?: string;
  /** Caption text for the image */
  caption?: string;
  /** Description of the message */
  description?: string;
  /** MPEG4 GIF URL for animated inline messages */
  gifUrl?: string;
  /** Thumbnail URL for GIF inline messages */
  thumbnailUrl?: string;
  /** Message text for article-type inline messages */
  messageText?: string;
  /** Title for article-type inline messages */
  title?: string;
  /** Inline keyboard button */
  button?: SavePreparedInlineMessageButton;
}

export interface SavePreparedInlineMessageResponse {
  /** Prepared inline message ID */
  preparedMessageId: string;
}

export interface HealthCheckResponse {
  /**
   * Service health status
   * @example "ok"
   */
  status: string;
  /**
   * Current timestamp
   * @example "2024-01-15T10:30:00.000Z"
   */
  timestamp: string;
}

export interface ComebackBonus {
  /** @example "f47ac10b-58cc-4372-a567-0e02b2c3d479" */
  id: string;
  /** @example "days_7" */
  type: ComebackBonusTypeEnum;
  /** @example 500 */
  amount: number;
  /**
   * @format date-time
   * @example "2024-01-20T12:00:00Z"
   */
  expiresAt: string;
  /** @example true */
  canClaim: boolean;
}

export interface ComebackBonusResponse {
  bonuses: ComebackBonus[];
}

export interface SubscriptionChannel {
  /**
   * Channel ID
   * @example "c47e8c4e-4b6e-4f86-8c7e-c4e34b6e3f86"
   */
  id: string;
  /**
   * Telegram channel ID (starts with -100)
   * @example "-1001234567890"
   */
  channelId: string;
  /**
   * Channel username without @
   * @example "csshot_channel"
   */
  channelUsername: string;
  /**
   * Link to the channel
   * @example "https://t.me/csshot_channel"
   */
  channelLink: string;
  /**
   * Channel description
   * @example "Official SHOT channel"
   */
  description?: string;
  /**
   * Bonus amount in credits for subscribing
   * @example 500
   */
  bonusAmount: number;
  /**
   * Whether the user is subscribed to this channel
   * @example true
   */
  isSubscribed: boolean;
  /**
   * Whether the bonus has been awarded for this channel
   * @example true
   */
  bonusAwarded: boolean;
  /**
   * Date when user subscribed
   * @format date-time
   * @example "2024-01-15T12:00:00Z"
   */
  subscribedAt?: string;
}

export interface SubscriptionChannelsResponse {
  /** List of available subscription channels */
  channels: SubscriptionChannel[];
  /**
   * Total number of channels user is subscribed to
   * @example 2
   */
  totalSubscribed: number;
  /**
   * Total amount of bonuses awarded
   * @example 1000
   */
  totalBonusesAwarded: number;
}

export interface UserBoostStatus {
  /**
   * Boost status
   * @example "ACTIVE"
   */
  status: UserBoostStatusStatusEnum;
  /**
   * Whether the user can claim the daily reward
   * @example true
   */
  canClaimReward: boolean;
  /**
   * Next reward available timestamp
   * @example "2024-01-16T10:30:00.000Z"
   */
  nextRewardAvailableAt?: string;
  /**
   * Total number of rewards claimed
   * @example 5
   */
  totalRewardsClaimed: number;
  /**
   * Total credits earned from this boost
   * @example 500
   */
  totalCreditsEarned: number;
}

export interface BoostChannelWithStatus {
  /**
   * Channel ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Telegram channel ID
   * @example "@csshot_channel"
   */
  channelId: string;
  /**
   * Channel username for display
   * @example "SHOT Channel"
   */
  channelUsername: string;
  /**
   * Channel link
   * @example "https://t.me/csshot_channel"
   */
  channelLink: string;
  /**
   * Channel description
   * @example "Boost our channel for daily rewards"
   */
  description?: string;
  /**
   * Daily reward amount
   * @example 100
   */
  dailyRewardAmount: number;
  /** User boost status (null if not boosted) */
  userBoost?: UserBoostStatus;
}

export interface BoostChannelsStatusResponse {
  /** List of boost channels with user status */
  channels: BoostChannelWithStatus[];
}

export interface ReferralBonusProgressResponse {
  /**
   * Progress towards next referral bonus (0-9). Every 10th valid referral gives a bonus.
   * @min 0
   * @max 9
   * @example 3
   */
  progressToBonus: number;
}

export interface UsernameTaskStatus {
  /** Whether task is active */
  isActive: boolean;
  /** Whether user can claim daily reward */
  canClaimReward: boolean;
  /**
   * Last validation timestamp
   * @format date-time
   */
  lastValidatedAt: string | null;
  /**
   * Last bonus claim timestamp
   * @format date-time
   */
  lastBonusClaimedAt: string | null;
  /** Total bonuses claimed */
  totalBonusesClaimed: number;
  /** Total credits earned from this task */
  totalCreditsEarned: number;
  /** Current streak days */
  streakDays: number;
  /**
   * When next reward will be available
   * @format date-time
   */
  nextRewardAvailable: string | null;
  /** Next reward amount in credits */
  nextRewardAmount: number;
  /** Whether maximum reward has been reached */
  maxRewardReached: boolean;
  /** Bot username to add to lastName */
  botUsername: string;
}

export interface BioTaskStatus {
  /** Whether task is active */
  isActive: boolean;
  /** Whether user can claim daily reward */
  canClaimReward: boolean;
  /**
   * Last validation timestamp
   * @format date-time
   */
  lastValidatedAt: string | null;
  /**
   * Last bonus claim timestamp
   * @format date-time
   */
  lastBonusClaimedAt: string | null;
  /** Total bonuses claimed */
  totalBonusesClaimed: number;
  /** Total credits earned from this task */
  totalCreditsEarned: number;
  /** Current streak days */
  streakDays: number;
  /**
   * When next reward will be available
   * @format date-time
   */
  nextRewardAvailable: string | null;
  /** Next reward amount in credits */
  nextRewardAmount: number;
  /** Whether maximum reward has been reached */
  maxRewardReached: boolean;
  /** Referral link to add to bio */
  referralLink: string;
}

export interface ProfileTaskStatusResponse {
  /** Username in lastName task status */
  usernameTask: UsernameTaskStatus;
  /** Referral link in bio task status */
  bioTask: BioTaskStatus;
}

export interface StreakMilestone {
  /** День streak */
  day: number;
  /** Сумма бонуса в кредитах */
  amount: number;
}

export interface DailyBonusStatusResponse {
  /** Можно ли получить бонус сейчас */
  canClaim: boolean;
  /** Текущий streak (дни подряд) */
  currentStreak: number;
  /** Максимальный streak всех времен */
  maxStreak: number;
  /** Общее количество полученных бонусов */
  totalBonusesClaimed: number;
  /** Общее количество заработанных кредитов */
  totalCreditsEarned: number;
  /** Время до следующего бонуса в миллисекундах */
  timeUntilNextBonus: number;
  /** Время до следующего бонуса (форматированное) */
  timeUntilNextFormatted: string;
  /** Сумма следующего бонуса в кредитах */
  nextBonusAmount: number;
  /** Описание следующего бонуса */
  nextBonusDescription: string;
  /** Вехи streak */
  streakMilestones: StreakMilestone[];
  /**
   * Время последнего получения бонуса
   * @format date-time
   */
  lastClaimedAt: string | null;
}

export interface ItemResponse {
  /** Unique hash name from Steam */
  hashName: string;
  /** Name of the item */
  name: string;
  /** Rarity ID */
  rarityId?: string;
  /** Rarity name */
  rarityName?: string;
  /** Rarity color */
  rarityColor?: string;
  /** Weapon name */
  weapon?: string;
  /** Category name */
  category?: string;
  /** Wear name */
  wear?: string;
  /** Image URL */
  imageUrl?: string;
  /** Whether item has StatTrak */
  statTrak: boolean;
  /** Whether item is Souvenir */
  souvenir: boolean;
  /** Price in rubles */
  priceInRubles?: number;
  /** Price in USD */
  priceInUsd?: number;
  /** Price on Steam market in USD */
  steamPrice?: number | null;
  /** Item type (e.g., "sticker", "skin") */
  type?: string;
  /** SkinViewer3D payload for in-browser 3D rendering. Null = no 3D available. */
  viewerData?: object | null;
}

export interface RecentInventoryItem {
  /**
   * Inventory item ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * User ID who owns the item
   * @example "b2c3d4e5-f6g7-8901-bcde-f23456789012"
   */
  userId: string;
  /**
   * Telegram ID of user who owns the item
   * @example "123456789"
   */
  userTelegramId: string;
  /**
   * Price when the item was acquired (in credits)
   * @example 2500
   */
  acquiredPriceInCredits: number;
  /**
   * Source of the item
   * @example "CASE_OPENING"
   */
  source: RecentInventoryItemSourceEnum;
  /**
   * ID of the source (e.g., case opening ID)
   * @example "c3d4e5f6-g7h8-9012-cdef-g34567890123"
   */
  sourceId?: string;
  /**
   * When the item was acquired
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  acquiredAt: string;
  /** Item details */
  item: ItemResponse;
}

export interface TopRecentDropsResponse {
  /** List of top recent drops from the last 24 hours, sorted by price (descending) */
  items: RecentInventoryItem[];
}

export interface RecentItemsResponse {
  /** List of recent inventory items */
  items: RecentInventoryItem[];
}

export interface PrizeItem {
  name: string;
  imageUrl: string;
  price: number;
  rarityColor: string | null;
}

export interface DrawParticipant {
  /** Participant ID */
  id: string;
  /** User ID */
  userId: string;
  /** User first name */
  firstName: string | null;
  /** User last name */
  lastName: string | null;
  /**
   * User level
   * @example 5
   */
  level: number;
  /** Number of tickets owned by this participant */
  ticketsCount: number;
  /**
   * Time when user joined the draw
   * @format date-time
   */
  joinedAt: string;
}

export interface ActiveDraw {
  id: string;
  type: string;
  prizeItem: PrizeItem;
  /** @format date-time */
  completionTime: string;
  /** Total number of unique participants */
  totalParticipants: number;
  /** Total number of tickets (including multiple tickets from same user) */
  totalTickets: number;
  /** Whether current user is participating */
  userParticipating: boolean;
  /** Number of tickets current user owns (null if not participating) */
  userTicketsCount: number | null;
  /** Current user win chance in percentage (null if not participating) */
  userWinChance: number | null;
  /** Entry price in credits (null for free draws) */
  entryPrice: number | null;
  /** Last 3 participants who joined the draw */
  recentParticipants: DrawParticipant[];
}

export interface ActiveDrawsResponse {
  depositDraw: ActiveDraw | null;
  referralDraw: ActiveDraw | null;
  paid5000Draw: ActiveDraw | null;
  paid10000Draw: ActiveDraw | null;
  paid25000Draw: ActiveDraw | null;
}

export interface ActivePromocodeBuffResponse {
  /**
   * Promocode buff ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Promocode that was activated
   * @example "BONUS20"
   */
  promocodeCode: string;
  /**
   * Bonus percentage
   * @example 20
   */
  bonusPercentage: number;
  /**
   * Buff type
   * @example "time_limited"
   */
  type: ActivePromocodeBuffResponseTypeEnum;
  /**
   * Expiration date (for time limited buffs)
   * @example "2024-12-31T23:59:59.000Z"
   */
  expiresAt?: string;
  /**
   * Remaining usages (for usage limited buffs)
   * @example 3
   */
  remainingUsages?: number;
  /**
   * Buff activation date
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
  /**
   * Whether buff is valid (not expired, has usages left)
   * @example true
   */
  isValid: boolean;
}

export interface GlobalPromocodeBuffResponse {
  /**
   * Whether global promocode buff is active
   * @example true
   */
  isActive: boolean;
  /**
   * Bonus percentage
   * @example 50
   */
  bonusPercentage: number;
  /**
   * Buff start date
   * @example "2025-11-10T00:00:00.000Z"
   */
  startDate: string;
  /**
   * Buff end date
   * @example "2025-11-17T23:59:59.999Z"
   */
  endDate: string;
}

export interface AuctionItem {
  /** Item hash name */
  hashName: string;
  /** Item display name */
  name: string;
  /** Item image URL */
  imageUrl: string | null;
  /** Item rarity name */
  rarityName: string | null;
  /** Item rarity color */
  rarityColor: string | null;
  /** Item condition/wear */
  condition: string | null;
}

export interface ActiveAuction {
  /** Auction ID */
  id: string;
  /** Item details */
  item: AuctionItem;
  /** Current highest bid in credits */
  currentBid: number;
  /** Minimum bid step in credits */
  minBidStep: number;
  /** Auction status */
  status: ActiveAuctionStatusEnum;
  /**
   * Auction start time
   * @format date-time
   */
  startTime: string | null;
  /**
   * Auction end time
   * @format date-time
   */
  endTime: string | null;
  /** Time remaining in milliseconds */
  timeRemaining: number;
  /** Number of bids placed */
  bidCount: number;
}

export interface ActiveAuctionsResponse {
  /** List of active auctions */
  auctions: ActiveAuction[];
}

export interface DailyGiveawayCase {
  id: string;
  name: string;
  imageUrl: string;
}

export interface DailyGiveawayPrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityName: string | null;
  rarityColor: string | null;
  /** Prize value in credits */
  price: number;
  /** Prize price on Steam market in USD */
  steamPrice: number | null;
}

export interface DailyGiveawayRound {
  id: string;
  /** Round end (Moscow midnight) as ISO string */
  endAt: string;
  participantsCount: number;
}

export interface DailyGiveawayLeader {
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
}

export interface DailyGiveawayMe {
  rank: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
}

export interface DailyGiveawayPublic {
  id: string;
  sortOrder: number;
  /** Scoring mode */
  type: DailyGiveawayPublicTypeEnum;
  case: DailyGiveawayCase;
  prize: DailyGiveawayPrize;
  round: DailyGiveawayRound | null;
  leader: DailyGiveawayLeader | null;
  me: DailyGiveawayMe | null;
}

export interface DailyGiveawaysResponse {
  giveaways: DailyGiveawayPublic[];
}

export interface XpStatusResponse {
  /**
   * Current user level
   * @example 5
   */
  level: number;
  /**
   * Total XP accumulated
   * @example 1250
   */
  totalXp: number;
  /**
   * XP progress in current level
   * @example 75
   */
  currentLevelXp: number;
  /**
   * XP needed to reach next level
   * @example 175
   */
  xpToNextLevel: number;
  /**
   * Progress percentage in current level
   * @example 30
   */
  progressPercent: number;
  /**
   * Whether user is at max level
   * @example false
   */
  isMaxLevel: boolean;
  /**
   * User rank position based on XP
   * @example 1247
   */
  xpRank?: number;
}

export interface BandRateMilestone {
  /** Level that unlocks the next shown cashback step */
  level: number;
  /** Cashback percent at that level */
  ratePct: number;
}

export interface BandMechanicRate {
  /** Mechanic key: CASE, CASE_BATTLE, RUSH_MID, ROULETTE, UPGRADE, CONTRACT */
  mechanic: string;
  /** Effective cashback percent on this mechanic (level curve × multiplier) */
  ratePct: number;
}

export interface BandStatusResponse {
  isMember: boolean;
  /** @format date-time */
  bandExpiresAt?: string | null;
  bonusBalance: number;
  bandTickets: number;
  ticketPriceCredits: number;
  /** Sparks accruing in the current cycle, not yet matured */
  pendingCashbackCredits: number;
  /** Matured sparks waiting for the claim button */
  claimableCashbackCredits: number;
  /** @format date-time */
  nextAccrualAt?: string | null;
  /** Cashback percent the current level earns, before mechanic multipliers */
  currentRatePct: number;
  level: number;
  /** Next level milestone and its rate, null at the top milestone */
  nextMilestone?: BandRateMilestone | null;
  /** Per-mechanic effective rates; differ from currentRatePct only while a multiplier is active */
  mechanicRates: BandMechanicRate[];
  /** Admin toggle: show the club promo block on the home screen */
  homePromoEnabled: boolean;
}

export interface BandMembersPreviewResponse {
  /** Active members right now */
  memberCount: number;
  /** Freshest member ids — the promo renders their avatars */
  recentMemberIds: string[];
}

export interface HomeSnapshot {
  comebackBonus?: ComebackBonusResponse | null;
  subscriptionChannels?: SubscriptionChannelsResponse | null;
  boostChannels?: BoostChannelsStatusResponse | null;
  referralBonusProgress?: ReferralBonusProgressResponse | null;
  profileTasks?: ProfileTaskStatusResponse | null;
  dailyBonus?: DailyBonusStatusResponse | null;
  topRecentDrops?: TopRecentDropsResponse | null;
  recentDrops?: RecentItemsResponse | null;
  draws?: ActiveDrawsResponse | null;
  activeBuff?: ActivePromocodeBuffResponse | null;
  globalBuff?: GlobalPromocodeBuffResponse | null;
  auctions?: ActiveAuctionsResponse | null;
  dailyGiveaways?: DailyGiveawaysResponse | null;
  profile?: UserProfileResponse | null;
  xpStatus?: XpStatusResponse | null;
  bandStatus?: BandStatusResponse | null;
  bandMembersPreview?: BandMembersPreviewResponse | null;
  /** Секции, чей источник ответил ошибкой */
  failedSections: string[];
}

export interface AuctionItemDetails {
  /** Item hash name */
  hashName: string;
  /** Item display name */
  name: string;
  /** Item image URL */
  imageUrl: string | null;
  /** Item rarity name */
  rarityName: string | null;
  /** Item rarity color */
  rarityColor: string | null;
  /** Item condition/wear */
  condition: string | null;
  /** Item market price in rubles */
  price: number;
}

export interface AuctionBidder {
  /** Bidder user ID */
  id: string;
  /** Bidder first name */
  firstName: string | null;
}

export interface AuctionBid {
  /** Bid ID */
  id: string;
  /** Bidder information */
  bidder: AuctionBidder;
  /** Bid amount in credits */
  amount: number;
  /**
   * Bid placement time
   * @format date-time
   */
  createdAt: string;
  /** Whether this is the winning bid */
  isWinning: boolean;
}

export interface AuctionDetailsResponse {
  /** Auction ID */
  id: string;
  /** Item details */
  item: AuctionItemDetails;
  /** Starting price in credits */
  startPrice: number;
  /** Current highest bid in credits */
  currentBid: number;
  /** Minimum bid step in credits */
  minBidStep: number;
  /**
   * Auction start time
   * @format date-time
   */
  startTime: string;
  /**
   * Auction end time
   * @format date-time
   */
  endTime: string;
  /** Time remaining in milliseconds */
  timeRemaining: number;
  /** Auction status */
  status: string;
  /** Whether auction is currently active */
  isActive: boolean;
  /** Winner information (only if auction is completed) */
  winner: AuctionBidder | null;
  /** List of all bids */
  bids: AuctionBid[];
}

export interface Bidder {
  /** User ID */
  id: string;
  /** First name */
  firstName: string | null;
}

export interface Bid {
  /** Bid ID */
  id: string;
  /** Bidder information */
  bidder: Bidder;
  /** Bid amount in credits */
  amount: number;
  /**
   * Bid creation timestamp
   * @format date-time
   */
  createdAt: string;
  /** Whether this is the winning bid */
  isWinning: boolean;
}

export interface PaginatedBidsResponse {
  /** List of bids */
  bids: Bid[];
  /** Total number of bids */
  totalCount: number;
  /** Current page number */
  page: number;
  /** Total number of pages */
  totalPages: number;
  /** Whether there are more pages */
  hasMore: boolean;
}

export interface PlaceBid {
  /**
   * Bid amount in credits
   * @min 1
   * @example 1000
   */
  amount: number;
}

export interface ExecuteContract {
  /**
   * Array of user inventory item IDs to use in the contract
   * @maxItems 10
   * @minItems 3
   * @example ["uuid1","uuid2","uuid3"]
   */
  inputItemIds: string[];
}

export interface ContractOutputItem {
  /** Output item ID */
  id: string;
  /** Output item hash name */
  hashName: string;
  /** Output item display name */
  name: string;
  /** Output item value in credits */
  value: number;
  /** Output item image URL */
  imageUrl: string;
  /** Output item rarity name */
  rarityName?: string;
  /** Output item rarity color */
  rarityColor?: string;
  /** Item price on Steam market in USD */
  steamPrice?: number | null;
  /** SkinViewer3D payload for in-browser 3D rendering. Null = no 3D available. */
  viewerData?: object | null;
}

export interface ContractResult {
  /** Contract ID */
  contractId: string;
  /** Output item details */
  outputItem: ContractOutputItem;
  /** Profit or loss in credits (positive = profit, negative = loss) */
  profitLoss: number;
  /** Total value of input items in credits */
  totalInputValue: number;
}

export interface ContractPreview {
  /** Minimum possible output value in credits */
  minValue: number;
  /** Maximum possible output value in credits */
  maxValue: number;
  /** Total input value in credits */
  totalInputValue: number;
}

export interface ContractHistoryInputItem {
  /** Input item ID */
  id: string;
  /** Input item display name */
  name: string;
  /** Input item value in credits */
  value: number;
  /** Input item image URL */
  imageUrl: string;
}

export interface ContractHistoryOutputItem {
  /** Output item ID */
  id: string;
  /** Output item display name */
  name: string;
  /** Output item value in credits */
  value: number;
  /** Output item image URL */
  imageUrl: string;
}

export interface ContractHistoryItem {
  /** Contract ID */
  id: string;
  /** Input items used in the contract */
  inputItems: ContractHistoryInputItem[];
  /** Total value of input items in credits */
  inputTotalValue: number;
  /** Output item received */
  outputItem: ContractHistoryOutputItem;
  /** Profit or loss in credits (positive = profit, negative = loss) */
  profitLoss: number;
  /**
   * Contract creation date
   * @format date-time
   */
  createdAt: string;
}

export interface ContractHistory {
  /** List of contract history items */
  contracts: ContractHistoryItem[];
  /** Total number of contracts */
  totalCount: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface CalculateProbability {
  /**
   * Source item ID from user inventory
   * @example "user-inventory-item-123"
   */
  sourceItemId: string;
  /**
   * Target item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  targetItemId: string;
}

export interface UpgradeProbabilityResponse {
  /**
   * Whether the upgrade is available
   * @example true
   */
  isAvailable: boolean;
  /**
   * Calculated probability (0-1)
   * @example 0.25
   */
  probability: number;
  /**
   * Upgrade coefficient
   * @example 4
   */
  coefficient: number;
  /**
   * Source item price in credits
   * @example 1250
   */
  sourcePrice: number;
  /**
   * Target item price in credits
   * @example 5000
   */
  targetPrice: number;
  /**
   * Reason why upgrade is not available
   * @example "Probability too low"
   */
  reason?: string;
}

export interface PerformItemUpgrade {
  /**
   * Source inventory item ID
   * @example "user-inventory-item-123"
   */
  sourceItemId: string;
  /**
   * Target item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  targetItemId: string;
}

export interface UpgradeResult {
  /**
   * Unique upgrade ID
   * @example "upgrade-uuid-123"
   */
  upgradeId: string;
  /**
   * Whether the upgrade was successful
   * @example true
   */
  isSuccess: boolean;
  /**
   * Probability that was used
   * @example 0.25
   */
  probability: number;
  /**
   * Coefficient that was used
   * @example 4
   */
  coefficient: number;
  /**
   * Result item hash name if successful
   * @example "AK-47 | Redline (Field-Tested)"
   */
  resultItemId?: string;
  /** SkinViewer3D payload for in-browser 3D rendering of the target item. Null = no 3D available. */
  viewerData?: object | null;
}

export interface UpgradeHistoryItem {
  /**
   * Upgrade ID
   * @example "upgrade-uuid-123"
   */
  id: string;
  /**
   * Source item ID
   * @example "source-item-123"
   */
  sourceItemId: string;
  /**
   * Source item name
   * @example "Glock-18 | Water Elemental"
   */
  sourceItemName: string;
  /**
   * Source item image URL
   * @example "https://example.com/glock-water-elemental.png"
   */
  sourceItemImage: string;
  /**
   * Target item ID
   * @example "AK-47 | Redline (Field-Tested)"
   */
  targetItemId: string;
  /**
   * Target item name
   * @example "AK-47 | Redline"
   */
  targetItemName: string;
  /**
   * Target item image URL
   * @example "https://example.com/ak47-redline.png"
   */
  targetItemImage: string;
  /**
   * Target item price at the time of upgrade
   * @example 5000
   */
  targetItemPrice: number;
  /**
   * Probability that was used
   * @example 0.25
   */
  probability: number;
  /**
   * Coefficient that was used
   * @example 4
   */
  coefficient: number;
  /**
   * Whether the upgrade was successful
   * @example true
   */
  isSuccess: boolean;
  /**
   * Result item ID if successful
   * @example "result-item-456"
   */
  resultItemId?: string;
  /**
   * When the upgrade was performed
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
}

export interface UpgradeHistoryResponse {
  /** List of upgrade history items */
  items: UpgradeHistoryItem[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface AvailableUpgradeTargetItem {
  /** Steam market hash name of the item */
  hashName: string;
  /** Display name of the item */
  name: string;
  /** Item category */
  category: string;
  /** URL of the item image */
  imageUrl: string;
  /** Price of the item in credits */
  price: number;
  /** Price in USD */
  priceInUsd?: number;
  /** Item price on Steam market in USD */
  steamPrice?: number | null;
  /** Probability of successful upgrade (0-1) */
  probability: number;
  /** Coefficient of the upgrade */
  coefficient: number;
  /** Rarity color of the item */
  rarityColor: string;
  /** Rarity name of the item */
  rarityName?: string;
  /** Whether the item has StatTrak */
  statTrak: boolean;
  /** Whether the item is Souvenir */
  souvenir: boolean;
}

export interface AvailableUpgradeTargetsResponse {
  /** Paginated available upgrade targets */
  items: AvailableUpgradeTargetItem[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface ActivatePromocode {
  /**
   * Promocode to activate
   * @minLength 3
   * @maxLength 50
   * @example "BONUS20"
   */
  code: string;
}

export interface PromocodeHistoryItem {
  /**
   * Usage record ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Promocode that was used
   * @example "BONUS20"
   */
  promocodeCode: string;
  /**
   * Bonus percentage that was applied
   * @example 20
   */
  bonusPercentage: number;
  /**
   * Date when promocode was used
   * @example "2024-01-15T10:30:00.000Z"
   */
  usedAt: string;
}

export interface PromocodeHistoryResponse {
  /** List of used promocodes */
  history: PromocodeHistoryItem[];
}

export interface WheelSegment {
  /** Bonus percentage for this segment */
  percentage: number;
}

export interface ActiveWheelBuff {
  /** Bonus percentage */
  bonusPercentage: number;
  /** Buff expiration date */
  expiresAt: string;
}

export interface WheelStatusResponse {
  /** Number of available wheel spins */
  availableSpins: number;
  /** Wheel segments */
  segments: WheelSegment[];
  /** Whether user has active wheel buff */
  hasActiveWheelBuff: boolean;
  /** Whether user has any active promocode (wheel or regular) */
  hasActivePromo: boolean;
  /** Active wheel buff details */
  activeWheelBuff?: ActiveWheelBuff;
}

export interface DeactivatedPromo {
  /** Bonus percentage of the deactivated promo */
  bonusPercentage: number;
}

export interface SpinWheelResponse {
  /** Won bonus percentage */
  bonusPercentage: number;
  /** Created buff ID */
  buffId: string;
  /** Buff expiration date */
  expiresAt: string;
  /** Remaining wheel spins after this spin */
  remainingSpins: number;
  /** Info about deactivated promo if one was active */
  deactivatedPromo?: DeactivatedPromo;
}

export interface ActivateProfileTask {
  /**
   * Type of profile task to activate
   * @example "USERNAME_IN_LASTNAME"
   */
  taskType: ActivateProfileTaskTaskTypeEnum;
}

export interface ClaimProfileTaskReward {
  /**
   * Type of profile task to claim reward for
   * @example "USERNAME_IN_LASTNAME"
   */
  taskType: ClaimProfileTaskRewardTaskTypeEnum;
}

export interface ShopItem {
  hashName: string;
  name: string;
  imageUrl: string;
  priceInCredits: number;
  priceInRubles: number;
  /** Price in USD */
  priceInUsd?: number;
  volume: number;
  category: string | null;
  weapon: string | null;
  type: string | null;
  statTrak: boolean;
  rarity: string | null;
  rarityColor: string | null;
  /** Price in Telegram Stars with commission */
  priceInStars: number;
  /** Price in RUB with Wata.pro SBP commission */
  priceInRub: number;
  /** Price in UZS with NOROS P2P commission */
  priceInUzs: number;
}

export interface GetShopItemsResponse {
  items: ShopItem[];
  meta: PaginationMeta;
}

export interface ShopSkin {
  /**
   * Skin name
   * @example "Asiimov"
   */
  skinName: string;
  /**
   * Image URL
   * @example "https://..."
   */
  imageUrl: string;
  /**
   * Rarity color hex
   * @example "#eb4b4b"
   */
  rarityColor: string;
  /**
   * Rarity name
   * @example "Covert"
   */
  rarityName: string;
  /**
   * Minimum price in credits
   * @example 50000
   */
  minPriceInCredits: number;
  /**
   * Number of available items for this skin
   * @example 5
   */
  itemsCount: number;
}

export interface GetShopSkinsResponse {
  /** List of skins */
  skins: ShopSkin[];
}

export interface CreateShopPurchaseInvoice {
  /** Hash name of the item to purchase */
  itemHashName: string;
  /** Payment provider */
  provider: CreateShopPurchaseInvoiceProviderEnum;
  /** Payment currency (defaults to RUB) */
  currency?: CreateShopPurchaseInvoiceCurrencyEnum;
  /** Return URL after payment completion */
  returnUrl?: string;
}

export interface CreateShopPurchaseInvoiceResponse {
  /** Payment ID */
  paymentId: string;
  /** Invoice URL for payment */
  invoiceUrl: string;
  /** Payment amount in provider currency */
  amount: number;
  /** Payment currency */
  currency: string;
  /** Item name */
  itemName: string;
  /** Item image URL */
  itemImageUrl: string;
  /**
   * Invoice expiration date
   * @format date-time
   */
  expiresAt?: string;
}

export interface UserShopPurchase {
  id: string;
  itemHashName: string;
  itemName: string;
  itemImageUrl: string;
  itemRarity?: string;
  itemRarityColor?: string;
  priceInCredits: number;
  priceInRubles: number;
  status: UserShopPurchaseStatusEnum;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  completedAt?: string;
}

export interface UserShopPurchasesResponse {
  purchases: UserShopPurchase[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface CaseOpening {
  /**
   * Unique case opening ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Case ID that was opened
   * @example "case_123"
   */
  caseId: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  caseName: string;
  /**
   * Case price at the time of opening (in credits)
   * @example 1000
   */
  casePriceInCredits: number;
  /** Full dropped item information */
  droppedItem: ItemResponse;
  /**
   * Item price at the time of dropping (in credits, may differ from current price)
   * @example 5000
   */
  droppedItemPriceInCredits: number;
  /**
   * Date when case was opened
   * @example "2024-01-15T10:30:00.000Z"
   */
  openedAt: string;
}

export interface PaginatedCaseOpeningsResponse {
  /** List of case openings */
  openings: CaseOpening[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface CaseOpeningDetailsItem {
  /**
   * Item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
  /**
   * Item display name
   * @example "AK-47 | Redline"
   */
  displayName: string;
  /**
   * Item rarity
   * @example "Covert"
   */
  rarity: string;
  /**
   * Item rarity color
   * @example "#eb4b4b"
   */
  rarityColor: string;
  /**
   * Item image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/default_generated/weapon_ak47_cu_ak47_cobra_light_large.png"
   */
  imageUrl: string;
  /**
   * Item price in credits
   * @example 5000
   */
  priceInCredits: number;
  /**
   * Item price on Steam market in USD
   * @example 41.41
   */
  steamPrice: number | null;
  /**
   * Item wear condition
   * @example "Field-Tested"
   */
  condition?: string;
  /**
   * Weapon type
   * @example "AK-47"
   */
  weapon?: string;
  /**
   * Item category
   * @example "Rifle"
   */
  category?: string;
}

export interface CaseOpeningDetailsResponse {
  /**
   * Case opening ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Case ID
   * @example "case_123"
   */
  caseId: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  caseName: string;
  /**
   * Case price at time of opening (in credits)
   * @example 1000
   */
  casePriceInCredits: number;
  /**
   * Case image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/weapon_cases/crate_community_1.png"
   */
  caseImageUrl: string;
  /** Dropped item details */
  droppedItem: CaseOpeningDetailsItem;
  /**
   * Inventory item ID for the dropped item
   * @example "inv_123456"
   */
  inventoryItemId: string;
  /**
   * User balance after opening (in credits)
   * @example 25000
   */
  balanceAfterInCredits: number;
  /**
   * Date when case was opened
   * @example "2024-01-15T10:30:00Z"
   */
  openedAt: string;
}

export interface CaseResponse {
  /**
   * Unique case identifier
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  name: string;
  /**
   * Case price in credits
   * @example 1000
   */
  priceInCredits: number;
  /**
   * Case image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/weapon_cases/crate_community_1.png"
   */
  imageUrl: string;
  /**
   * Base64-encoded 16x16 placeholder image for instant loading (LQIP)
   * @example "data:image/jpeg;base64,/9j/4AAQSkZJRg..."
   */
  imagePlaceholder: string | null;
  /**
   * Whether the case is active
   * @example true
   */
  isActive: boolean;
  /**
   * Sort order for display
   * @example 1
   */
  sortOrder: number;
  /**
   * Total number of openings
   * @example 1500
   */
  openingsCount: number;
  /**
   * Whether the case is marked as new
   * @example false
   */
  isNew: boolean;
  /**
   * XP reward for opening this case
   * @example 15
   */
  xpReward: number;
  /**
   * Currency spent to open this case — credits, or SHOT BAND bonus balance
   * @example "credits"
   */
  openCurrency: CaseResponseOpenCurrencyEnum;
}

export interface CaseItem {
  /**
   * Item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
  /**
   * Item display name
   * @example "AK-47 | Redline"
   */
  name: string;
  /**
   * Item rarity
   * @example "Covert"
   */
  rarity: string;
  /**
   * Item rarity color
   * @example "#eb4b4b"
   */
  rarityColor: string;
  /**
   * Item image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/default_generated/weapon_ak47_cu_ak47_cobra_light_large.png"
   */
  imageUrl: string;
  /**
   * Item price in credits
   * @example 5000
   */
  priceInCredits: number;
  /**
   * Item price in USD
   * @example 55.5
   */
  priceInUsd?: number;
  /**
   * Item price on Steam market in USD
   * @example 41.41
   */
  steamPrice: number | null;
  /**
   * Drop probability (0-1)
   * @example 0.025
   */
  probability: number;
  /**
   * Drop chance as a display percent, rounded to 2 decimals, floored at 0.01%
   * @example 2.5
   */
  chancePercent: number;
  /**
   * Item wear condition
   * @example "Field-Tested"
   */
  wear?: string;
}

export interface CaseDetailsResponse {
  /**
   * Unique case identifier
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  name: string;
  /**
   * Case price in credits
   * @example 1000
   */
  priceInCredits: number;
  /**
   * Case image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/weapon_cases/crate_community_1.png"
   */
  imageUrl: string;
  /**
   * Base64-encoded 16x16 placeholder image for instant loading (LQIP)
   * @example "data:image/jpeg;base64,/9j/4AAQSkZJRg..."
   */
  imagePlaceholder: string | null;
  /**
   * Whether the case is active
   * @example true
   */
  isActive: boolean;
  /**
   * Sort order for display
   * @example 1
   */
  sortOrder: number;
  /**
   * Total number of openings
   * @example 1500
   */
  openingsCount: number;
  /** Items that can be dropped from this case */
  items: CaseItem[];
  /**
   * XP reward for opening this case
   * @example 15
   */
  xpReward: number;
  /**
   * Currency spent to open this case — credits, or SHOT BAND bonus balance
   * @example "credits"
   */
  openCurrency: CaseDetailsResponseOpenCurrencyEnum;
}

export interface CaseItemResponse {
  /**
   * Item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
  /**
   * Item display name
   * @example "AK-47 | Redline"
   */
  name: string;
  /**
   * Item rarity
   * @example "Covert"
   */
  rarity: string;
  /**
   * Item rarity color
   * @example "#eb4b4b"
   */
  rarityColor: string;
  /**
   * Item image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/default_generated/weapon_ak47_cu_ak47_cobra_light_large.png"
   */
  imageUrl: string;
  /**
   * Item price in credits
   * @example 5000
   */
  priceInCredits: number;
  /**
   * Item price in USD
   * @example 55.5
   */
  priceInUsd?: number;
  /**
   * Item price on Steam market in USD
   * @example 41.41
   */
  steamPrice: number | null;
  /**
   * Item wear condition
   * @example "Field-Tested"
   */
  wear?: string;
  /**
   * Item weapon type
   * @example "AK-47"
   */
  weapon?: string;
  /**
   * Item category
   * @example "Rifle"
   */
  category?: string;
  /**
   * StatTrak™ variant
   * @example false
   */
  statTrak: boolean;
  /**
   * Souvenir variant
   * @example false
   */
  souvenir: boolean;
}

export interface CaseItemDrop {
  /**
   * Id of the user who unboxed the item
   * @example "f3a1b2c4-5d6e-4f70-8a91-2b3c4d5e6f70"
   */
  userId: string;
  /**
   * Display name of that user
   * @example "Иван"
   */
  userName: string;
  /**
   * When the case was opened
   * @format date-time
   * @example "2026-07-30T10:15:00.000Z"
   */
  openedAt: string;
}

export interface CaseItemDropsResponse {
  /** Most recent drops of this item from this case, newest first */
  drops: CaseItemDrop[];
}

export interface OpenCaseRequest {
  /**
   * Number of cases to open in a single request (defaults to 1)
   * @min 1
   * @max 10
   * @default 1
   * @example 1
   */
  count?: number;
}

export interface DroppedItem {
  /**
   * Item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
  /**
   * Item display name
   * @example "AK-47 | Redline"
   */
  displayName: string;
  /**
   * Item rarity
   * @example "Covert"
   */
  rarity: string;
  /**
   * Item rarity color
   * @example "#eb4b4b"
   */
  rarityColor: string;
  /**
   * Item image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/default_generated/weapon_ak47_cu_ak47_cobra_light_large.png"
   */
  imageUrl: string;
  /**
   * Item price in credits
   * @example 5000
   */
  priceInCredits: number;
  /**
   * Item price on Steam market in USD
   * @example 41.41
   */
  steamPrice: number | null;
  /**
   * Item wear condition
   * @example "Field-Tested"
   */
  condition?: string;
  /**
   * Weapon type
   * @example "AK-47"
   */
  weapon?: string;
  /**
   * Item category
   * @example "Rifle"
   */
  category?: string;
  /** SkinViewer3D payload for in-browser 3D rendering. Null = no 3D available. */
  viewerData?: object | null;
}

export interface OpenCaseResponse {
  /**
   * Case opening ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  openingId: string;
  /** Dropped item details */
  droppedItem: DroppedItem;
  /**
   * Inventory item ID for the dropped item
   * @example "inv_123456"
   */
  inventoryItemId: string;
  /**
   * User balance after opening
   * @example 25000
   */
  balanceAfter: number;
  /**
   * Whether the drop qualifies as a big win (item >= 125000 credits AND item > casePrice * 3.5)
   * @example false
   */
  isBigWin: boolean;
}

export interface InventoryItemOwner {
  /** User ID */
  userId: string;
  /** User first name */
  firstName?: string;
  /**
   * User level
   * @example 5
   */
  level: number;
}

export interface UserInventoryItemResponse {
  /** Inventory item ID */
  id: string;
  /** User ID who owns this item */
  userId: string;
  /** Owner of the item */
  owner: InventoryItemOwner;
  /** Price in credits when acquired */
  acquiredPriceInCredits: number;
  /** Price in rubles when acquired */
  acquiredPriceInRubles: number;
  /** Source of the item */
  source: UserInventoryItemResponseSourceEnum;
  /** Source ID (case opening, battle, etc) */
  sourceId?: string;
  /** Upgrade win chance (0–100) when the item came from an upgrade */
  upgradePercent?: number | null;
  /** Current status of the item */
  status: UserInventoryItemResponseStatusEnum;
  /**
   * Date when item was acquired
   * @format date-time
   */
  acquiredAt: string;
  /** Item details */
  item: ItemResponse;
}

export interface PaginatedInventoryResponse {
  /** List of inventory items */
  items: UserInventoryItemResponse[];
  /** Whether more items exist beyond this page */
  hasMore: boolean;
}

export interface SellItemResponse {
  /** Amount of credits received from selling the item */
  amountInCredits: number;
}

export interface SellAllItemsResponse {
  /** Number of items sold */
  soldCount: number;
  /** Total amount of credits received from selling all items */
  totalAmountInCredits: number;
}

export interface SellItems {
  /** Inventory item ids to sell */
  itemIds: string[];
}

export interface WithdrawItem {
  /** Cloudflare Turnstile token proving the withdrawal was requested by a human */
  captchaToken?: string;
  /** Why the widget produced no token; absent on requests that did not go through the UI */
  captchaFailReason?: WithdrawItemCaptchaFailReasonEnum;
}

export interface WithdrawItemResponse {
  /**
   * Whether the withdrawal was successful
   * @example true
   */
  success: boolean;
  /**
   * Steam trade offer ID
   * @example "1234567890"
   */
  tradeId?: string;
  /**
   * Trade price in cents (for Steam trade API)
   * @example 1500
   */
  tradePrice?: number;
  /** Error code if withdrawal failed */
  errorCode?: WithdrawItemResponseErrorCodeEnum;
}

export interface TradeStatusResponse {
  /**
   * Current trade status
   * @example "pending"
   */
  status: TradeStatusResponseStatusEnum;
  /**
   * Status message
   * @example "Trade is pending confirmation"
   */
  message: string;
  /**
   * Steam trade offer ID
   * @example "1234567890"
   */
  tradeId?: string;
  /**
   * Updated at timestamp
   * @example "2024-01-15T10:30:00.000Z"
   */
  updatedAt: string;
}

export interface UpdateTradeLink {
  /**
   * Steam trade URL
   * @example "https://steamcommunity.com/tradeoffer/new/?partner=123456789&token=AbCdEfGh"
   */
  tradeUrl: string;
}

export interface UpdateTradeLinkResponse {
  /**
   * Whether the update was successful
   * @example true
   */
  success: boolean;
  /**
   * Success message
   * @example "Trade link updated successfully"
   */
  message: string;
}

export interface CreateInvoice {
  /** Payment provider */
  provider: CreateInvoiceProviderEnum;
  /** Specific amount to pay (optional for flexible payments) */
  amount?: number;
  /** Minimum amount for flexible payments */
  minAmount?: number;
  /** Maximum amount for flexible payments */
  maxAmount?: number;
  /** Allow user to specify custom amount */
  allowFlexibleAmount?: boolean;
  /** Return URL after payment */
  returnUrl?: string;
  /** Additional metadata (Steam ID, Trade URL for skins, etc.) */
  metadata?: object;
}

export interface PaymentResponse {
  id: string;
  invoiceUrl: string;
  amount?: number;
  currency: PaymentResponseCurrencyEnum;
  status: PaymentResponseStatusEnum;
  /** @format date-time */
  expiresAt?: string;
  /** Provider-specific metadata */
  providerMetadata?: object;
}

export interface PaymentSettingsResponse {
  /**
   * Whether skin exchange is enabled for this user
   * @example true
   */
  skinsExchangeEnabled: boolean;
  /**
   * Payment providers currently enabled for this user (globally on + not blocked + skin-exchange-gate passes)
   * @example ["NOROS_P2P","WATAPRO_SBP","TELEGRAM_STARS"]
   */
  enabledProviders: string[];
}

export interface PaymentProviderPackage {
  credits: number;
  amount: number;
  currency: PaymentProviderPackageCurrencyEnum;
  bonus: Record<string, any>;
}

export interface PaymentProvider {
  id: PaymentProviderIdEnum;
  kind: PaymentProviderKindEnum;
  currency: PaymentProviderCurrencyEnum;
  packages: PaymentProviderPackage[];
}

export interface PaymentProvidersResponse {
  providers: PaymentProvider[];
}

export interface ClickCardResponse {
  id: string;
  /** Mask Click returns on verify */
  maskedPan?: string | null;
  phoneNumber?: string | null;
  isVerified: boolean;
}

export interface ClickCardListResponse {
  cards: ClickCardResponse[];
}

export interface BindClickCard {
  /**
   * Card number, 16 digits
   * @example "8600123412341234"
   */
  cardNumber: string;
  /**
   * Expiry date, MMYY
   * @example "0526"
   */
  expireDate: string;
}

export interface BindClickCardResponse {
  cardId: string;
  /** Masked number the SMS went to */
  phoneNumber?: string | null;
}

export interface VerifyClickCard {
  /** SMS code Click sent to the card holder */
  smsCode: string;
}

export interface PayWithClickCard {
  /** Amount in UZS */
  amount: number;
}

export interface PayWithClickCardResponse {
  /** Our payment id; credits land on the Click callback */
  paymentId: string;
  clickPaymentId?: number | null;
}

export interface UpdateAnimationSetting {
  /**
   * Whether case opening animations are enabled
   * @example true
   */
  animationsEnabled: boolean;
}

export interface UpdateAnimationSettingResponse {
  /**
   * Whether the update was successful
   * @example true
   */
  success: boolean;
  /**
   * Success message
   * @example "Animation setting updated successfully"
   */
  message: string;
}

export interface ToggleNotifications {
  /**
   * Enable or disable notifications
   * @example true
   */
  enabled: boolean;
}

export interface ToggleNotificationsResponse {
  /**
   * Current state of notifications
   * @example true
   */
  enabled: boolean;
}

export interface UpdateLanguage {
  /**
   * Language code
   * @example "ru"
   */
  languageCode: UpdateLanguageLanguageCodeEnum;
}

export interface UpdateLanguageResponse {
  /**
   * Updated language code
   * @example "ru"
   */
  languageCode: string;
}

export interface NextBonusInfo {
  /** Сумма следующего бонуса в кредитах */
  amount: number;
  /** Описание следующего бонуса */
  description: string;
}

export interface ClaimDailyBonusResponse {
  /** Количество полученных кредитов */
  creditsEarned: number;
  /** Новый streak */
  newStreak: number;
  /** Новый баланс пользователя */
  newBalance: number;
  /** Описание полученного бонуса */
  description: string;
  /** Информация о следующем бонусе */
  nextBonusInfo: NextBonusInfo;
}

export interface ClaimComebackBonusResponse {
  /** @example 500 */
  amount: number;
  /** @example 1500 */
  newBalance: number;
}

export interface OnboardingTaskConfig {
  /**
   * Task identifier
   * @example "dailyLogin"
   */
  key: string;
  /**
   * Reward amount in credits
   * @example 50
   */
  reward: number;
}

export interface OnboardingReferralConfig {
  /**
   * Credits when a friend starts playing
   * @example 2000
   */
  friendStartReward: number;
  /**
   * Credits for every Nth referral milestone
   * @example 4000
   */
  milestoneReward: number;
  /**
   * Referral milestone interval (every N friends)
   * @example 10
   */
  milestoneInterval: number;
  /**
   * Percentage of friend deposit as bonus (0.05 = 5%)
   * @example 0.05
   */
  depositBonusRate: number;
}

export interface OnboardingCaseConfig {
  /**
   * Minimum case price in credits
   * @example 500
   */
  minPriceCredits: number;
  /**
   * Minimum case price in rubles
   * @example 2
   */
  minPriceRubles: number | null;
}

export interface OnboardingConfigResponse {
  /** Task rewards for onboarding display */
  tasks: OnboardingTaskConfig[];
  /** Referral bonus configuration */
  referral: OnboardingReferralConfig;
  /** Cheapest case pricing */
  cheapestCase: OnboardingCaseConfig;
}

export interface ActivateBoostResponse {
  /**
   * User boost ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Boost status
   * @example "PENDING"
   */
  status: ActivateBoostResponseStatusEnum;
  /**
   * Next reward available timestamp (24 hours after activation)
   * @example "2024-01-16T10:30:00.000Z"
   */
  nextRewardAvailableAt: string;
  /**
   * Message for the user
   * @example "Boost activated! Your first reward will be available in 24 hours."
   */
  message: string;
}

export interface ClaimBoostRewardResponse {
  /**
   * Credits earned from the reward
   * @example 100
   */
  creditsEarned: number;
  /**
   * New user balance after claiming
   * @example 1500
   */
  newBalance: number;
  /**
   * Total rewards claimed for this boost
   * @example 5
   */
  totalRewardsClaimed: number;
  /**
   * Total credits earned from this boost
   * @example 500
   */
  totalCreditsEarned: number;
  /**
   * Next reward available timestamp
   * @example "2024-01-17T10:30:00.000Z"
   */
  nextRewardAvailableAt?: string;
}

export interface ChickenTickResponse {
  /** ID активного спавна для отображения (null если курицы нет) */
  spawnId: string | null;
  /** Тип курицы: regular — обычная, cyber — кибер-курица для участников SHOT BAND */
  kind: ChickenTickResponseKindEnum;
  /** Награда за клейм этой курицы в кредитах */
  amount: number | null;
}

export interface ClaimChickenReward {
  /** ID of the chicken spawn to claim */
  spawnId: string;
}

export interface ClaimChickenRewardResponse {
  /** Количество полученных кредитов */
  creditsEarned: number;
  /** Новый баланс пользователя */
  newBalance: number;
  /** Сколько раз сегодня ещё можно получить награду */
  remainingToday: number;
}

export interface XpTransactionItem {
  /** Transaction ID */
  id: string;
  /** Transaction type */
  type: XpTransactionItemTypeEnum;
  /**
   * XP amount (positive or negative)
   * @example 50
   */
  amount: number;
  /**
   * XP before transaction
   * @example 1200
   */
  xpBefore: number;
  /**
   * XP after transaction
   * @example 1250
   */
  xpAfter: number;
  /**
   * Level before transaction
   * @example 5
   */
  levelBefore: number;
  /**
   * Level after transaction
   * @example 5
   */
  levelAfter: number;
  /** Description */
  description?: string;
  /** Additional metadata */
  metadata?: object;
  /**
   * Transaction timestamp
   * @format date-time
   */
  createdAt: string;
}

export interface XpHistoryMeta {
  /**
   * Current page
   * @example 1
   */
  page: number;
  /**
   * Items per page
   * @example 20
   */
  limit: number;
  /**
   * Total items count
   * @example 100
   */
  total: number;
  /**
   * Total pages
   * @example 5
   */
  totalPages: number;
}

export interface XpHistoryResponse {
  /** XP transactions */
  transactions: XpTransactionItem[];
  /** Pagination metadata */
  meta: XpHistoryMeta;
}

export interface LevelInfoItem {
  /**
   * Level number
   * @example 5
   */
  level: number;
  /**
   * XP required for this level
   * @example 250
   */
  xpRequired: number;
  /**
   * Total XP required to reach this level
   * @example 1000
   */
  totalXpRequired: number;
}

export interface XpRewardsConfig {
  /**
   * XP for daily login
   * @example 50
   */
  dailyLogin: number;
  /**
   * XP for weekly streak completion
   * @example 200
   */
  weeklyStreak: number;
  /**
   * XP for referral invite
   * @example 30
   */
  referralInvite: number;
  /**
   * XP for referral deposit
   * @example 20
   */
  referralDeposit: number;
  /**
   * XP for contract
   * @example 40
   */
  contract: number;
  /**
   * XP for successful upgrade
   * @example 30
   */
  upgradeSuccess: number;
  /**
   * XP for failed upgrade
   * @example 5
   */
  upgradeFail: number;
  /**
   * XP for draw participation
   * @example 10
   */
  drawParticipation: number;
  /**
   * XP for draw win
   * @example 200
   */
  drawWin: number;
  /**
   * XP for case battle win
   * @example 30
   */
  caseBattleWin: number;
  /**
   * XP for case battle loss
   * @example 5
   */
  caseBattleLose: number;
}

export interface CaseXpTier {
  /**
   * Maximum price in RUB for this tier
   * @example 50
   */
  maxPriceRub: number;
  /**
   * XP multiplier for this tier
   * @example 0.5
   */
  multiplier: number;
}

export interface DepositMultiplier {
  /**
   * Minimum credits for this multiplier
   * @example 625000
   */
  minCredits: number;
  /**
   * XP multiplier value
   * @example 1.25
   */
  multiplier: number;
}

export interface CaseXpGroup {
  /**
   * Group name (cheap, medium, expensive)
   * @example "medium"
   */
  name: string;
  /**
   * Minimum XP for cases in this group
   * @example 30
   */
  minXp: number;
  /**
   * Maximum XP for cases in this group
   * @example 80
   */
  maxXp: number;
}

export interface KeyLevel {
  /**
   * Key level number
   * @example 10
   */
  level: number;
  /**
   * Total XP required to reach this level
   * @example 13912
   */
  xpRequired: number;
  /**
   * Bonus credits awarded for reaching this level
   * @example 24500
   */
  bonus: number;
}

export interface XpConfigResponse {
  /** Level table */
  levels: LevelInfoItem[];
  /**
   * Maximum level
   * @example 100
   */
  maxLevel: number;
  /** XP rewards configuration */
  rewards: XpRewardsConfig;
  /** Case XP tiers with progressive multipliers */
  caseXpTiers: CaseXpTier[];
  /** Deposit XP multipliers based on amount */
  depositMultipliers: DepositMultiplier[];
  /** Case XP groups by price tier */
  caseXpGroups: CaseXpGroup[];
  /** Key levels with bonus rewards */
  keyLevels: KeyLevel[];
}

export interface LevelBonusStatusItem {
  /**
   * Level number
   * @example 5
   */
  level: number;
  /**
   * Bonus amount in credits
   * @example 3500
   */
  bonus: number;
  /**
   * XP required to reach this level
   * @example 2830
   */
  xpRequired: number;
  /**
   * Whether user has reached this level
   * @example true
   */
  isUnlocked: boolean;
  /**
   * Whether bonus has been claimed
   * @example false
   */
  isClaimed: boolean;
  /**
   * Whether bonus is forfeit (unavailable)
   * @example false
   */
  isForfeit: boolean;
  /**
   * Whether bonus can be claimed now
   * @example true
   */
  canClaim: boolean;
}

export interface LevelBonusesStatusResponse {
  /** List of all key level bonuses */
  bonuses: LevelBonusStatusItem[];
  /**
   * Number of bonuses available to claim
   * @example 2
   */
  claimableBonusesCount: number;
  /**
   * Total credits available to claim
   * @example 4000
   */
  totalClaimableCredits: number;
}

export interface ClaimLevelBonusResponse {
  /**
   * Level for which bonus was claimed
   * @example 5
   */
  level: number;
  /**
   * Credits earned from the bonus
   * @example 3500
   */
  creditsEarned: number;
  /**
   * New user balance after claiming
   * @example 15000
   */
  newBalance: number;
}

export interface XpLeaderboardEntry {
  /** User ID */
  userId: string;
  /** First name */
  firstName: string | null;
  /** Last name */
  lastName: string | null;
  /**
   * Total XP
   * @example 5000
   */
  totalXp: number;
  /**
   * User level
   * @example 10
   */
  level: number;
  /**
   * XP rank position
   * @example 42
   */
  xpRank: number;
}

export interface XpLeaderboardResponse {
  /** Leaderboard entries */
  entries: XpLeaderboardEntry[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface XpLeaderboardNeighborsResponse {
  /** Neighboring users in the leaderboard (up to 7 users: 3 above + current + 3 below) */
  entries: XpLeaderboardEntry[];
  /**
   * Current user rank position (null if excluded from rating)
   * @example 42
   */
  currentUserRank: number | null;
}

export interface DrawWinnerUser {
  id: string;
  firstName: string | null;
  lastName: string | null;
  /**
   * User level
   * @example 5
   */
  level: number;
}

export interface DrawWinner {
  id: string;
  type: string;
  prizeItemName: string;
  prizeItemImage: string;
  prizeItemPrice: number;
  winner: DrawWinnerUser;
  /** @format date-time */
  completedAt: string;
}

export interface DrawParticipants {
  /** List of participants */
  participants: DrawParticipant[];
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
  /** Total number of pages */
  totalPages: number;
  /** Total number of participants */
  total: number;
}

export interface BuyDrawEntry {
  /**
   * Type of draw to participate in
   * @example "paid_5000"
   */
  drawType: BuyDrawEntryDrawTypeEnum;
}

export interface GiveawayWinner {
  id: string;
  firstName: string | null;
  lastName: string | null;
  /** @example 5 */
  level: number;
}

export interface GiveawayWonItem {
  inventoryItemId: string;
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
  priceInCredits: number;
}

export interface GiveawayCaseItemDetail {
  hashName: string;
  name: string;
  priceInRubles: number;
  priceInCredits: number;
  priceInUsd?: number;
  imageUrl: string | null;
  rarityName: string | null;
  rarityColor: string | null;
  weapon: string | null;
  category: string | null;
  wear: string | null;
  statTrak: boolean;
  souvenir: boolean;
  volume: number;
}

export interface GiveawayCaseItem {
  id: string;
  itemHashName: string;
  probability: number;
  item: GiveawayCaseItemDetail;
}

export interface GiveawayCase {
  id: string;
  name: string;
  priceInCredits: number;
  imageUrl: string;
  imagePlaceholder: string | null;
  isActive: boolean;
  sortOrder: number;
  openingsCount: number;
  items: GiveawayCaseItem[];
}

export interface GiveawayDetailsResponse {
  id: string;
  type: GiveawayDetailsResponseTypeEnum;
  status: GiveawayDetailsResponseStatusEnum;
  requiredParticipants: number | null;
  durationMinutes: number | null;
  /** @format date-time */
  expiresAt: string;
  /** @format date-time */
  createdAt: string;
  participantsCount: number;
  userParticipating: boolean;
  winner: GiveawayWinner | null;
  wonItem: GiveawayWonItem | null;
  case: GiveawayCase;
}

export interface GiveawayParticipant {
  id: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  /** @example 5 */
  level: number;
  /** @format date-time */
  joinedAt: string;
}

export interface GiveawayParticipantsResponse {
  participants: GiveawayParticipant[];
  total: number;
  page: number;
  limit: number;
}

export interface JoinGiveawayResponse {
  success: boolean;
}

export interface DailyGiveawayDetailResponse {
  id: string;
  sortOrder: number;
  /** Scoring mode */
  type: DailyGiveawayDetailResponseTypeEnum;
  case: DailyGiveawayCase;
  prize: DailyGiveawayPrize;
  round: DailyGiveawayRound | null;
  me: DailyGiveawayMe | null;
}

export interface DailyGiveawayLeaderboardEntry {
  rank: number;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
}

export interface DailyGiveawayLeaderboardPage {
  /** Scoring mode */
  type: DailyGiveawayLeaderboardPageTypeEnum;
  entries: DailyGiveawayLeaderboardEntry[];
  total: number;
  hasMore: boolean;
}

export interface DailyGiveawayWinnerPrize {
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface DailyGiveawayWinner {
  localDate: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
  prize: DailyGiveawayWinnerPrize;
}

export interface DailyGiveawayWinnersPage {
  /** Scoring mode */
  type: DailyGiveawayWinnersPageTypeEnum;
  winners: DailyGiveawayWinner[];
  total: number;
  hasMore: boolean;
}

export interface ReferralContestPrizeItem {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
  /** Catalogue price in credits */
  price: number;
  /** Steam market price in USD */
  steamPrice: number | null;
}

export interface ReferralContestPrize {
  place: number;
  /** Credit payout, null when the place takes an item */
  credits: number | null;
  item: ReferralContestPrizeItem | null;
}

export interface ReferralContestEntry {
  rank: number;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  /** Activated referrals invited inside the contest window */
  activatedCount: number;
}

export interface ReferralContestMe {
  /** Null while the user has no activated referrals yet */
  rank: number | null;
  activatedCount: number;
}

export interface ReferralContestLeaderboardResponse {
  status: ReferralContestLeaderboardResponseStatusEnum;
  /**
   * Contest window start (ISO, 1 Aug 2026 00:00 MSK)
   * @format date-time
   */
  startsAt: string;
  /**
   * Contest window end, exclusive (ISO, 1 Sep 2026 00:00 MSK)
   * @format date-time
   */
  endsAt: string;
  totalParticipants: number;
  prizes: ReferralContestPrize[];
  /** One page of the board, 20 entries */
  entries: ReferralContestEntry[];
  /** Another page follows this one */
  hasMore: boolean;
  me: ReferralContestMe | null;
}

export interface CentrifugoTokenResponse {
  /**
   * JWT token for Centrifugo connection
   * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
   */
  token: string;
  /**
   * Channel prefix for environment separation (e.g., dev, prod)
   * @example "prod"
   */
  channelPrefix: string;
}

export interface HeartbeatRequest {
  /**
   * What the user is currently doing
   * @example "opening_case"
   */
  activity: HeartbeatRequestActivityEnum;
}

export interface HeartbeatResponse {
  /**
   * Heartbeat accepted
   * @example true
   */
  ok: boolean;
}

export interface OnlineCountResponse {
  /**
   * Number of online users
   * @example 42
   */
  online: number;
}

export interface CreateCaseBattleRequest {
  /**
   * Maximum number of players (2-4)
   * @min 2
   * @max 4
   */
  maxPlayers: number;
  /** Array of case IDs for each round */
  caseIds: string[];
}

export interface CreateCaseBattleResponse {
  battleId: string;
}

export interface CaseBattleRoundResponse {
  id: string;
  roundNumber: number;
  caseId: string;
  caseName: string;
  caseImageUrl: string;
  /** Base64 16x16 placeholder image */
  caseImagePlaceholder?: string;
  casePriceInCredits: number;
}

export interface CaseBattleParticipantResponse {
  id: string;
  slot: number;
  userId: string;
  firstName?: string;
  /**
   * Player level
   * @default 1
   */
  level?: number;
  totalDroppedValue: number;
}

export interface CaseBattleListItemResponse {
  id: string;
  creatorId: string;
  status: CaseBattleListItemResponseStatusEnum;
  maxPlayers: number;
  currentPlayers: number;
  totalCost: number;
  rounds: CaseBattleRoundResponse[];
  participants: CaseBattleParticipantResponse[];
  createdAt: string;
}

export interface UserActiveBattlesCountResponse {
  /** Current number of active battles */
  count: number;
  /** Maximum allowed active battles */
  limit: number;
  /** Whether user can create/join more battles */
  canCreate: boolean;
}

export interface CaseBattleHistoryItemResponse {
  id: string;
  creatorId: string;
  status: CaseBattleHistoryItemResponseStatusEnum;
  maxPlayers: number;
  currentPlayers: number;
  totalCost: number;
  rounds: CaseBattleRoundResponse[];
  participants: CaseBattleParticipantResponse[];
  createdAt: string;
  winnerId?: string;
  isTie: boolean;
  completedAt?: string;
}

export interface CaseBattleHistoryPaginatedResponse {
  items: CaseBattleHistoryItemResponse[];
  /** Whether more battles exist beyond this page */
  hasMore: boolean;
}

export interface CaseBattleRoundResultResponse {
  participantId: string;
  droppedItemHashName: string;
  droppedItemPrice: number;
  inventoryItemId?: string;
  rarityColor?: string;
  /** Item price on Steam market in USD */
  steamPrice?: number | null;
}

export interface CaseBattleRoundDetailResponse {
  id: string;
  roundNumber: number;
  caseId: string;
  caseName: string;
  caseImageUrl: string;
  /** Base64 16x16 placeholder image */
  caseImagePlaceholder?: string;
  casePriceInCredits: number;
  status: CaseBattleRoundDetailResponseStatusEnum;
  results: CaseBattleRoundResultResponse[];
}

export interface CaseBattleParticipantDetailResponse {
  id: string;
  slot: number;
  userId: string;
  firstName?: string;
  /**
   * Player level
   * @default 1
   */
  level?: number;
  totalDroppedValue: number;
  joinedAt: string;
}

export interface CaseBattleDetailsResponse {
  id: string;
  creatorId: string;
  status: CaseBattleDetailsResponseStatusEnum;
  maxPlayers: number;
  totalCost: number;
  winnerId?: string;
  isTie: boolean;
  tiedPlayerIds: string[];
  rounds: CaseBattleRoundDetailResponse[];
  participants: CaseBattleParticipantDetailResponse[];
  createdAt: string;
  startedAt?: string;
  completedAt?: string;
}

export interface RushMidConfigResponse {
  /** true = show the «Скоро» tease and refuse entry (launch gate or per-user restriction) */
  comingSoon: boolean;
  /** true = deploy drain: lobby shows the updating banner, match-prep actions are rejected, live matches play out */
  maintenance: boolean;
  /** ticket tiers that currently accept new entries */
  activeTickets: number[];
}

export interface CreateOpenGameRequest {
  /** Entry ticket / stake */
  ticket: CreateOpenGameRequestTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: CreateOpenGameRequestModeEnum;
  /** Side to fight on */
  side: CreateOpenGameRequestSideEnum;
  /** Match mode: 'ranked' (default, public + listed) or 'bots' (practice — no stake, rating, rewards, drops or listing) */
  matchMode?: CreateOpenGameRequestMatchModeEnum;
}

export interface RushMidOpenSeat {
  userId: string;
  name: string;
  /** app-wide XP level */
  level: number;
  /** ELO for this game's mode; absent when the player is unrated in this mode */
  rating?: number;
  /** dense per-game party index (1, 2, …); absent for a solo */
  partyGroup?: number;
}

export interface RushMidOpenSeatsGrid {
  /** `mode` slots, null while free */
  t: (RushMidOpenSeat | null)[];
  /** `mode` slots, null while free */
  ct: (RushMidOpenSeat | null)[];
}

export interface RushMidLoadout {
  /** Weapon class */
  weapon: RushMidLoadoutWeaponEnum;
  /** Whole-vest armor tier */
  armor: RushMidLoadoutArmorEnum;
  /** Carries one grenade */
  grenade: boolean;
  /** Carries one smoke (denies the gunfight for a round) */
  smoke: boolean;
  /** Carries one medkit (single-use self heal) */
  medkit: boolean;
  /** Carries one flashbang (blinds an enemy cluster — team mode only) */
  flash: boolean;
}

export interface RushMidBuyRosterEntry {
  index: number;
  name: string;
  isBot: boolean;
  /** chosen loadout, or null while a real teammate is still picking (always null for enemies) */
  loadout?: RushMidLoadout | null;
  /** ELO rating for this mode (absent for bots) */
  rating?: number;
  /** absent for bots */
  userId?: string;
}

export interface RushMidPublicFighter {
  id: string;
  team: RushMidPublicFighterTeamEnum;
  hp: number;
  maxHp: number;
  armor: number;
  hasGrenade: boolean;
  hasSmoke: boolean;
  hasMedkit: boolean;
  hasFlash: boolean;
  alive: boolean;
  /** Current shooting stance */
  stance: RushMidPublicFighterStanceEnum;
}

export interface RushMidPayout {
  pot: number;
  prize: number;
  won: boolean;
  /** Draw — both teams wiped; stake refunded, net 0 */
  draw: boolean;
  survived: boolean;
  share: number;
  net: number;
}

export interface RushMidScoreEntry {
  fighterId: string;
  name: string;
  team: RushMidScoreEntryTeamEnum;
  kills: number;
  /** contribution points = dealt damage + credited utility (smoke/flash/medkit) */
  pts: number;
  alive: boolean;
  /** winning-side fighter with the most contribution points (== the reward MVP) */
  mvp: boolean;
  /** net coin result for this seat (share − stake): + on a win, − on a loss, 0 for a draw/bot — same figure as the history screen */
  payout: number;
  /** ELO change this match (real players only) */
  ratingDelta?: number;
}

export interface RushMidSnapshot {
  /** Current Rush Mid phase for this user */
  status: RushMidSnapshotStatusEnum;
  /** Active / finished match id */
  matchId?: string;
  /** Monotonic write counter of the match row — apply only strictly newer snapshots of the same match */
  stateVersion?: number;
  /** The user's side preference ('any' = either team) */
  side?: RushMidSnapshotSideEnum;
  /** Team size (1/2/5) */
  mode?: number;
  /** Entry ticket / stake */
  ticket?: number;
  /** OPEN: the side the caller is seated on */
  yourSide?: RushMidSnapshotYourSideEnum;
  /** OPEN: per-side seat grid */
  seats?: RushMidOpenSeatsGrid;
  /** OPEN: ISO deadline when free slots get bot-filled and the match starts — absent when the global bot-fill toggle is off */
  botFillAt?: string;
  /** BUYING: same-side teammates */
  allies?: RushMidBuyRosterEntry[];
  /** BUYING: opposing-side players (no loadout — buys hidden) */
  enemies?: RushMidBuyRosterEntry[];
  /** BUYING: epoch ms the buy window closes */
  buyDeadline?: number;
  /** PLAYING/OVER: the round about to be played (or final round) */
  round?: number;
  /** PLAYING/OVER: fighter placements + names (FighterInit[]) */
  inits?: Record<string, any>[];
  /** PLAYING/OVER: current fighter snapshot */
  fighters?: RushMidPublicFighter[];
  /** PLAYING/OVER: events of the round that just resolved ([] before the first resolve) — RoundEvent[] */
  lastEvents?: Record<string, any>[];
  /** PLAYING/OVER: each fighter's resolved action for lastEvents, keyed by fighter id — { kind, stance? } (Record<string, RushMidRoundAction>) */
  lastActions?: Record<string, Record<string, any>>;
  /** PLAYING: epoch ms to choose the next action */
  roundDeadline?: number;
  /** PLAYING/OVER: the user's fighter id (`${side}${index}`) */
  yourFighterId?: string | null;
  /** PLAYING: whether this user already submitted an action this round */
  yourActionSubmitted?: boolean;
  /** OVER: winning side (null = mutual wipe) */
  winner?: RushMidSnapshotWinnerEnum;
  /** OVER: this user's payout */
  payout?: RushMidPayout;
  /** OVER: end-of-match scoreboard */
  scoreboard?: RushMidScoreEntry[];
  /** OVER: provably-fair reveal */
  serverSeed?: string;
  /** OVER: provably-fair reveal */
  serverSeedHash?: string;
  /** OVER: provably-fair reveal */
  clientSeed?: string;
}

export interface OpenGame {
  matchId: string;
  /** Entry ticket / stake */
  ticket: OpenGameTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: OpenGameModeEnum;
  /** the arena rolled at creation (mirage/dust2/inferno/nuke) — cards show its cover */
  map: string;
  createdAt: string;
  /** per-side seat grid */
  seats: RushMidOpenSeatsGrid;
  /** ISO deadline when free slots get bot-filled and the match starts — absent when the global bot-fill toggle is off */
  botFillAt?: string;
  /** whether the caller's unit may sit down — false while the newbie grace fences this lobby off. Absent on the Centrifugo payload (one broadcast for every viewer, so no unit to judge) */
  joinable?: boolean;
  /** why the join is blocked */
  joinBlockedReason?: OpenGameJoinBlockedReasonEnum;
  /** ISO instant the block lifts — the card counts down to it */
  joinableAt?: string;
}

export interface OpenGamesListResponse {
  games: OpenGame[];
}

export interface LiveGame {
  matchId: string;
  /** Entry ticket / stake */
  ticket: LiveGameTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: LiveGameModeEnum;
  /** the arena rolled at creation (mirage/dust2/inferno/nuke) — cards show its cover */
  map: string;
  /** the round currently being fought (for the «раунд N» badge) */
  round: number;
  /** per-side seat grid */
  seats: RushMidOpenSeatsGrid;
}

export interface LiveGamesListResponse {
  games: LiveGame[];
}

export interface RushMidSpectateView {
  /** Watched match phase */
  status: RushMidSpectateViewStatusEnum;
  matchId: string;
  /** Monotonic write counter of the match row — apply only strictly newer views */
  stateVersion?: number;
  /** Team size (1/2/5) */
  mode: number;
  /** Entry ticket / stake */
  ticket: number;
  /** battle map */
  map: RushMidSpectateViewMapEnum;
  /** PLAYING/OVER: the round about to be played (or final round) */
  round: number;
  /** fighter placements + names (FighterInit[]) */
  inits: Record<string, any>[];
  /** current fighter snapshot */
  fighters: RushMidPublicFighter[];
  /** events of the round that just resolved ([] before the first resolve) — RoundEvent[] */
  lastEvents: Record<string, any>[];
  /** each fighter's resolved action for lastEvents, keyed by fighter id — { kind, stance? } */
  lastActions?: Record<string, Record<string, any>>;
  /** PLAYING: epoch ms to the next round resolve */
  roundDeadline?: number;
  /** OVER: winning side (null = mutual wipe) */
  winner?: RushMidSpectateViewWinnerEnum;
  /** OVER: end-of-match scoreboard */
  scoreboard?: RushMidScoreEntry[];
  /** OVER: provably-fair reveal */
  serverSeed?: string;
  /** OVER: provably-fair reveal */
  serverSeedHash?: string;
  /** OVER: provably-fair reveal */
  clientSeed?: string;
}

export interface JoinOpenGameRequest {
  /** Side to join */
  side: JoinOpenGameRequestSideEnum;
}

export interface PartyJoinRequest {
  /** Secret party code (case-insensitive) */
  code: string;
}

export interface PartyConfigRequest {
  /** Team size (must be >= party size) */
  mode: PartyConfigRequestModeEnum;
  /** Entry ticket / stake */
  ticket: PartyConfigRequestTicketEnum;
  /** Side the whole party fights on ('any' = whichever team has room) */
  side: PartyConfigRequestSideEnum;
  /** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
  matchMode?: PartyConfigRequestMatchModeEnum;
}

export interface PartyKickRequest {
  /** userId of the member to remove (leader-only) */
  userId: string;
}

export interface PartyReadyRequest {
  /** ready confirmation (leader starts once every member is ready) */
  ready: boolean;
}

export interface SubmitLoadoutRequest {
  /** Player loadout for this match */
  loadout: RushMidLoadout;
  /** true = "to battle" (ready to start); false = just save this selection (buy window stays open) */
  ready: boolean;
}

export interface SubmitActionRequest {
  /** The round this action is for; rejected if the match has already advanced past it */
  round?: number;
  /** Action kind for this round */
  kind: SubmitActionRequestKindEnum;
  /** Shooting stance (for kind=shoot) */
  stance?: SubmitActionRequestStanceEnum;
  /** Enemy fighter id to shoot/knife (`${side}${index}`); omit for a random enemy */
  shootTargetId?: string;
  /** Enemy fighter id to throw a grenade at (consumes the grenade) */
  grenadeTargetId?: string;
  /** Enemy fighter id to smoke out of the gunfight (consumes the smoke); omit for a random enemy */
  smokeTargetId?: string;
  /** Enemy fighter id to flash (blinds it + nearby enemies; consumes the flashbang); omit for a random enemy */
  flashTargetId?: string;
}

export interface RushMidHistorySeat {
  /** Player id — null for a bot seat */
  userId: string | null;
  /** Display name (empty for bots) */
  name: string;
  /** Bot-filled seat (rendered with the generic avatar) */
  bot: boolean;
}

export interface RushMidHistoryTeams {
  /** T-side final roster (length = mode) */
  t: RushMidHistorySeat[];
  /** CT-side final roster (length = mode) */
  ct: RushMidHistorySeat[];
}

export interface RushMidHistoryItem {
  id: string;
  /** Match id — open the detail / replay screen with this */
  matchId: string;
  mode: number;
  /** Entry ticket (stake) — shown in the card header */
  ticket: number;
  /** Arena the match was played on — drives the card cover */
  map: string;
  /** Net credit change (payout - stake) */
  net: number;
  won: boolean;
  /** Draw (both teams wiped) — stake refunded, net 0 */
  draw: boolean;
  /** Both sides' final rosters for the card VS strip */
  teams: RushMidHistoryTeams;
  createdAt: string;
}

export interface RushMidHistoryResponse {
  items: RushMidHistoryItem[];
  total: number;
}

export interface RushMidRatingEntry {
  /** Leaderboard rank (1-based) */
  rank: number;
  userId: string;
  /** Display name (joined from the user) */
  name: string;
  /** ELO rating for this mode */
  rating: number;
  /** Matches played in this mode */
  played: number;
  wins: number;
  losses: number;
  /** Win rate %, one decimal */
  winrate: number;
  /** Cumulative net coins earned in this mode */
  coins: number;
  /** Cumulative kills in this mode */
  kills: number;
  /** Cumulative deaths in this mode */
  deaths: number;
}

export interface RushMidRatingResponse {
  /** The caller's own rating in this mode, or null if unrated */
  you: RushMidRatingEntry | null;
  /** Top players in this mode */
  top: RushMidRatingEntry[];
}

export interface RushMidWeaponSkinOption {
  /** catalog name, also the sprite file `wpn_<name>.webp` */
  name: string;
  /** ak / m4 / awp / lmg */
  weaponKey: string;
  /** shown to the player */
  title: string;
  /** milspec / restricted / classified / covert */
  rarity: string;
  /** how the skin is earned */
  unlock: RushMidWeaponSkinOptionUnlockEnum;
  /** average ELO that opens an `elo` skin */
  minElo: number | null;
  /** may the player wear it right now */
  owned: boolean;
  /** ELO still to climb, or null when already open / not ELO-gated */
  eloToUnlock: number | null;
}

export interface RushMidSkinsResponse {
  /** saved T-side skin (e.g. `t3`), or null */
  t: string | null;
  /** saved CT-side skin (e.g. `ct7`), or null */
  ct: string | null;
  /** weapon skin per class (ak/m4/awp/lmg) → skin name */
  weapons: Record<string, string>;
  /** whether the weapon-skin block is open to this player (skinsExchangeEnabled) */
  weaponSkinsEnabled: boolean;
  /** enabled weapon-skin catalog, locked rows included */
  weaponCatalog: RushMidWeaponSkinOption[];
  /** weighted average ELO across modes — what the thresholds compare to */
  avgElo: number;
  /** weapon skins granted outright by an admin */
  grants: string[];
  /** last ticket the user searched with */
  ticket: number | null;
  /** last mode (1/2/5) */
  mode: number | null;
  /** last side ('t'/'ct'/'any') */
  side: string | null;
  /** last match mode ('ranked'/'bots') */
  matchMode: string | null;
}

export interface JoinMatchmakingRequest {
  /** Entry ticket / stake */
  ticket: JoinMatchmakingRequestTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: JoinMatchmakingRequestModeEnum;
  /** Side to fight on ('any' = whichever team has room) */
  side: JoinMatchmakingRequestSideEnum;
  /** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
  matchMode?: JoinMatchmakingRequestMatchModeEnum;
}

export interface SetRushMidSkinRequest {
  /** side the skin belongs to */
  side: SetRushMidSkinRequestSideEnum;
  /** skin file-prefix (e.g. `t3` / `ct7`); must match the side */
  skin: string;
}

export interface SetRushMidWeaponSkinRequest {
  /** weapon key the skin belongs to */
  weaponKey: SetRushMidWeaponSkinRequestWeaponKeyEnum;
  /** catalog skin name, or null for the stock weapon */
  skin: string | null;
}

export interface RushMidDrop {
  itemHashName: string;
  name: string;
  image: string | null;
  /** rarity label from the catalog, for the ItemCard pass gradient */
  rarity?: string;
  rarityColor?: string;
  /** the item's credit value frozen at settlement time */
  priceCredits: number;
}

export interface RushMidMatchDetail {
  id: string;
  mode: number;
  /** entry ticket / stake */
  stake: number;
  /** battle map */
  map: RushMidMatchDetailMapEnum;
  winner: RushMidMatchDetailWinnerEnum;
  createdAt: string;
  /** the requesting user's fighter id */
  yourFighterId: string | null;
  scoreboard: RushMidScoreEntry[];
  payout: RushMidPayout;
  /** the skin this viewer received in that match (null for losers, draws and old matches) */
  drop: RushMidDrop | null;
  serverSeed: string;
  serverSeedHash: string;
  clientSeed: string;
  /** Replay: { inits: FighterInit[], rounds: RoundEvent[][] } */
  replay: Record<string, any>;
}

export interface RushMidReplay {
  id: string;
  mode: number;
  /** entry ticket / stake */
  stake: number;
  /** battle map */
  map: RushMidReplayMapEnum;
  winner: RushMidReplayWinnerEnum;
  createdAt: string;
  scoreboard: RushMidScoreEntry[];
  /** Replay: { inits: FighterInit[], rounds: RoundEvent[][] } */
  replay: Record<string, any>;
}

export interface RouletteGameSeat {
  /** Seated player id (avatar is fetched by id) */
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Player level */
  level: number;
}

export interface RouletteOpenGame {
  /** Match id — join this specific game via POST games/:id/join */
  matchId: string;
  /** Entry ticket of this game (one of the presets) */
  stake: number;
  /** Seats in this game — the house is full at this many players */
  maxSeats: number;
  /** Bullets loaded in the 8-chamber drum of this game */
  bullets: number;
  /** Seats already taken */
  seatsTaken: number;
  /** OPEN lobby still collecting players, or a full house counting down to the start */
  status: RouletteOpenGameStatusEnum;
  /** Seated players (for avatar/name previews) */
  seats: RouletteGameSeat[];
  /** ISO deadline — OPEN lobby TTL (cancel) or COUNTDOWN start; null only in transient states */
  phaseDeadline: string | null;
}

export interface RouletteGames {
  /** Ticket presets a game may be created with */
  presets: number[];
  /** Every live game (OPEN + COUNTDOWN), oldest first */
  games: RouletteOpenGame[];
}

export interface RouletteCreateGameRequest {
  /** Entry ticket — one of the presets */
  stake: RouletteCreateGameRequestStakeEnum;
  /**
   * Seats in the game
   * @min 2
   * @max 4
   */
  seats: number;
  /**
   * Bullets loaded in the 8-chamber drum
   * @min 1
   * @max 4
   */
  bullets: number;
}

export interface RouletteState {
  /** The caller's current roulette status */
  status: RouletteStateStatusEnum;
  /** Match id seated in (status = match) — the lobby, countdown or live match */
  matchId?: string;
  /** The seated match's status (present only with status = match). Seats deactivate on finish, so this only ever carries a LIVE status (OPEN/COUNTDOWN/ACTIVE) — the client always follows it in. */
  matchStatus?: RouletteStateMatchStatusEnum;
}

export interface RoulettePrizeItem {
  /** Inventory row granted to the winner */
  inventoryItemId: string;
  /** Market hash name — the item key */
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityName: string | null;
  rarityColor: string | null;
  /** Price in credits at the moment of the grant */
  price: number;
}

export interface RoulettePrize {
  /** The skin the winner took — the prize is always an item */
  item: RoulettePrizeItem;
  /** Payout minus the skin price. Positive = the small gap stays with the house on top of the rake; negative = the skin cost a touch MORE than the payout and the house covered the overage. */
  shortfall: number;
}

export interface RouletteLastSkip {
  /** Chamber the drum stood on when the shooter skipped (0-based) */
  chamber: number;
  /** Drum positions that held a bullet in the ABANDONED round — the resolved layout (rotation applied). A skip reshuffles the drum, so this leaks nothing about the current round; it is the reveal of the round just dodged. */
  revealedBullets: number[];
  /** Whether the skipped chamber itself was loaded — the near-miss («did I dodge a bullet?») */
  activeWasLoaded: boolean;
}

export interface RouletteLastShot {
  /** Chamber under the hammer when the shot landed (0-based) — the fired/spent chamber */
  chamber: number;
  /** The fired round's REAL bullet positions (rotation applied) — so the client draws the spent case exactly where the shot happened, and any other loaded chambers at their true spots. The round is over (reloaded/finished), so this leaks nothing about the live round. */
  revealedBullets: number[];
}

export interface RouletteSeat {
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Avatar URL, when available */
  avatar?: string;
  status: RouletteSeatStatusEnum;
}

export interface RouletteMatch {
  id: string;
  status: RouletteMatchStatusEnum;
  /** Entry ticket of this game */
  stake: number;
  /** Seats in this game — the house was full at this many players */
  maxSeats: number;
  /** Total credits in the pot */
  pot: number;
  /** Projected prize value shown in-game — the winner's skin worth: the FULL-house pot (every seat filled, whatever has actually joined so far) minus the rake, plus any skip-buys. Render as-is; the client does not recompute it. */
  prizeValue: number;
  /** SHA-256 hash of the (still secret, unless FINISHED/CANCELLED) server seed */
  seedHash: string;
  /** Current round number */
  round: number;
  /** Chamber position the drum is currently on (0-based) */
  chamberPos: number;
  /** Bullets loaded per round — a count */
  bulletsCount: number;
  /** The current charge's PUBLIC bullet pattern — the chamber indices loaded before the secret rotation. Empty until the match is ACTIVE. A hit fires when the drum stops on a rotated pattern chamber; the rotation offset stays secret until the match ends. */
  pattern: number[];
  /** Current shooter — null once the match is over */
  shooterId?: string | null;
  /** The ALIVE players in the exact order they will shoot, starting from the current shooter (element 0 === shooterId). Server-owned turn sequence — the client renders the seat row in this order and never computes it. Dead players are excluded. Empty until the match is ACTIVE. */
  turnOrder: string[];
  /** ISO deadline of the current phase — null once the match is over */
  stepDeadline?: string | null;
  /** Credits cost of a skip in this game (half the ticket) */
  skipCost: number;
  /** The caller's remaining skips this match (0 when not seated or the match is over) */
  mySkipsLeft: number;
  /** Everything this caller has actually paid into this match: the entry they were seated at plus every skip they bought (skips are half the ticket each). Server-computed because the client never sees the whole match — a spectator, a re-entry or a late join would each add up to a different number. Null when the caller has no seat in this match (spectator, or they left an OPEN lobby and were refunded); 0 on a CANCELLED match, where the entry was refunded and no skip can have happened. */
  mySpent?: number | null;
  /** Winner — set once FINISHED */
  winnerUserId?: string | null;
  /** Winner payout (pot minus rake) — set once FINISHED */
  payout?: number | null;
  /** What the winner actually received — a skin worth the payout. Set once FINISHED */
  prize?: RoulettePrize | null;
  /** The most recent skip's reveal — the abandoned round's resolved bullet layout and whether the skipped chamber was loaded. Safe to show (a skip reshuffles the drum, so it says nothing about the current round). Null when no skip has happened yet or after the next pull clears it. */
  lastSkip?: RouletteLastSkip | null;
  /** The most recent shot's reveal — the fired round's REAL bullet layout and the spent chamber, so the client draws the shot exactly where it happened (not on the pre-rotation public pattern). The round is over, so this leaks nothing about the live round. Null until a shot lands or after the next pull clears it. */
  lastShot?: RouletteLastShot | null;
  seats: RouletteSeat[];
}

export interface RouletteHistoryOpponent {
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Player level */
  level: number;
}

export interface RouletteHistoryPrize {
  /** The skin I took — present only on a match I won */
  item: RoulettePrizeItem;
}

export interface RouletteHistoryItem {
  matchId: string;
  /** ISO timestamp the match settled */
  finishedAt: string;
  status: RouletteHistoryItemStatusEnum;
  /** Entry ticket of this game */
  stake: number;
  /** Seats in this game */
  maxSeats: number;
  /** Bullets loaded per round */
  bulletsCount: number;
  /** Total credits in the pot */
  pot: number;
  /** Whether I won this match */
  iWon: boolean;
  /** Who won — one of the seated players (me or an opponent); null only for CANCELLED */
  winnerUserId: string | null;
  /** The other seated players (me excluded) */
  opponents: RouletteHistoryOpponent[];
  /** The winner’s prize skin — shown on every finished row; null only for CANCELLED */
  prize: RouletteHistoryPrize | null;
}

export interface RouletteHistoryResponse {
  /** My finished/cancelled matches, newest first */
  items: RouletteHistoryItem[];
  /** Pass as `cursor` to fetch the next page — null once there are no more matches */
  nextCursor: string | null;
}

export interface RouletteFeedPlayer {
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Player level */
  level: number;
}

export interface RouletteFeedPrize {
  /** The skin the winner took */
  item: RoulettePrizeItem;
}

export interface RouletteFeedItem {
  matchId: string;
  /** ISO timestamp the match settled */
  finishedAt: string;
  /** Entry ticket of this game */
  stake: number;
  /** Seats in this game */
  maxSeats: number;
  /** Bullets loaded per round */
  bulletsCount: number;
  /** Who won */
  winner: RouletteFeedPlayer;
  /** Every seated player, winner included */
  players: RouletteFeedPlayer[];
  /** The skin the winner took */
  prize: RouletteFeedPrize;
}

export interface RouletteFeedResponse {
  /** Every player's finished matches, newest first */
  items: RouletteFeedItem[];
  /** Pass as `cursor` to fetch the next page — null once there are no more matches */
  nextCursor: string | null;
}

export interface RouletteFairnessEvent {
  step: number;
  type: RouletteFairnessEventTypeEnum;
  shooterId?: string;
  chamber?: number;
  round: number;
}

export interface RouletteBulletLayout {
  /** Drum-shuffle index (1-based; a shuffle happens on match start, every reload and every skip) */
  shuffle: number;
  /** PUBLIC bullet pattern for this shuffle — chamber indices loaded before rotation */
  pattern: number[];
  /** Secret drum rotation for this shuffle — a hit fires when chamber (chamberPos + offset) mod 8 is in the pattern */
  offset: number;
}

export interface RoulettePrizeDraw {
  /** Which rung produced the candidates: 'band' = skins priced in [payout × 0.85, payout], 'below' = the nearest-below skins with no floor, 'cheapest' = the single cheapest tradable skin (above the payout, the house covers the difference) */
  poolLevel: RoulettePrizeDrawPoolLevelEnum;
  /** Size of the candidate band — tradable skins (volume > 20) of that rung, ordered by price DESC then hashName ASC */
  candidateCount: number;
  /** Index of the drawn item in that band — recompute it as drawInt(serverSeed, `{matchId}:prize`, candidateCount) */
  drawnIndex: number;
  /** Market hash name of the drawn item */
  hashName: string;
}

export interface RouletteFairness {
  /** SHA-256 hash of the server seed — published up front, always visible */
  seedHash: string;
  /** The server seed itself — revealed only once the match is FINISHED/CANCELLED */
  serverSeed?: string;
  /** Full event log — revealed only once FINISHED/CANCELLED */
  log?: RouletteFairnessEvent[];
  /** Every drum load of the match — revealed only once FINISHED/CANCELLED */
  bulletLayouts?: RouletteBulletLayout[];
  /** How the prize skin was drawn — revealed once FINISHED */
  prizeDraw?: RoulettePrizeDraw;
}

export interface RushRafflePrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  /** Item rarity label (e.g. Classified) */
  rarityName: string | null;
  /** Item rarity color hex — drives the card gradient */
  rarityColor: string | null;
  /** Prize value in credits */
  priceCredits: number;
  /** Prize price on Steam market in USD */
  steamPriceUsd: number | null;
}

export interface RushRaffleRoundListItem {
  roundId: string;
  /** Entry ticket (stake) tier this round belongs to */
  ticket: number;
  prize: RushRafflePrize;
  /** Round end as ISO string */
  endsAt: string;
  totalTickets: number;
  participantsCount: number;
  /** Caller's ticket count in this round (0 if not participating) */
  myTickets: number;
}

export interface RushRaffleRoundsResponse {
  /** Today's active rounds, ticket ASC */
  rounds: RushRaffleRoundListItem[];
}

export interface RushRaffleParticipant {
  /** Participant user id (avatar + profile link) */
  userId: string;
  name: string;
  tickets: number;
  /** tickets / totalTickets * 100, rounded to 1 decimal */
  sharePct: number;
}

export interface RushRaffleWinner {
  name: string;
  tickets: number;
}

export interface RushRaffleRoundDetail {
  roundId: string;
  /** Entry ticket (stake) tier this round belongs to */
  ticket: number;
  prize: RushRafflePrize;
  /** Round end as ISO string */
  endsAt: string;
  totalTickets: number;
  participantsCount: number;
  /** Caller's ticket count in this round (0 if not participating) */
  myTickets: number;
  status: RushRaffleRoundDetailStatusEnum;
  /** Top-50 by tickets */
  participants: RushRaffleParticipant[];
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
  /** Set once the round is COMPLETED */
  winner: RushRaffleWinner | null;
}

export interface RushRaffleWinnerPrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface RushRaffleWinnerEntry {
  roundId: string;
  /** Entry ticket (stake) tier this round belongs to */
  ticket: number;
  /** Calendar day this round ran, format YYYY-MM-DD */
  localDate: string;
  prize: RushRaffleWinnerPrize;
  /** Winner user id (avatar + profile link) */
  winnerId: string;
  winnerName: string;
  winnerTickets: number;
  totalTickets: number;
}

export interface RushRaffleWinnersResponse {
  /** Completed rounds from the last 14 days, newest first */
  winners: RushRaffleWinnerEntry[];
}

export interface RushRaffleTicketBreakdown {
  base: number;
  mvp: number;
  multiKill: number;
  oneHp: number;
  clutch: number;
  total: number;
}

export interface RushRaffleMatchAward {
  tickets: number;
  breakdown: RushRaffleTicketBreakdown;
}

export interface BandTicketProviderPrice {
  /** Payment provider id */
  provider: string;
  /** Exact charge in the provider currency — same math as the invoice */
  amount: number;
  currency: string;
}

export interface BandTicketPricesResponse {
  ticketPriceCredits: number;
  prices: BandTicketProviderPrice[];
}

export interface CreateBandTicketInvoice {
  provider: CreateBandTicketInvoiceProviderEnum;
  returnUrl?: string;
}

export interface BandTicketInvoiceResponse {
  paymentId: string;
  invoiceUrl: string;
  amount: number;
  currency: string;
  /** @format date-time */
  expiresAt?: string;
}

export interface PayBandTicketWithClickCard {
  /** Bound Click card to charge the SHOT BAND price to */
  cardId: string;
}

export interface PayBandTicketWithClickCardResponse {
  paymentId: string;
  /** 'pending' until Click's callback lands and membership switches on */
  status: PayBandTicketWithClickCardResponseStatusEnum;
}

export interface ClaimBandCashbackResponse {
  /** Sparks credited by this claim; 0 when nothing was claimable */
  creditedCredits: number;
  bonusBalance: number;
}

export interface BandFreeCaseState {
  caseId: string;
  /** Day turnover in coins that unlocks a free open of this case */
  requiredWager: number;
  /** Today's turnover already reached the threshold */
  unlocked: boolean;
  /** Today's free open of this case is already spent */
  claimedToday: boolean;
}

export interface BandFreeCasesResponse {
  /** Member's wager turnover for the current Moscow day, in coins */
  wageredToday: number;
  /**
   * Moscow midnight when progress and claims reset
   * @format date-time
   */
  resetsAt: string;
  cases: BandFreeCaseState[];
}

export interface BandQuest {
  questId: string;
  slot: BandQuestSlotEnum;
  tickets: number;
  progress: number;
  target: number;
  completed: boolean;
  claimed: boolean;
}

export interface BandQuestsResponse {
  quests: BandQuest[];
  /** Consecutive Moscow days with at least one completed quest */
  streakDays: number;
  /** True for non-members: quests are shown but cannot progress */
  locked: boolean;
}

export interface BandRafflePrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  /** Item rarity label (e.g. Covert) */
  rarityName: string | null;
  /** Item rarity color hex — drives the card gradient */
  rarityColor: string | null;
  /** Prize value in credits */
  priceCredits: number;
  /** Prize price on Steam market in USD */
  steamPriceUsd: number | null;
}

export interface BandRaffleCurrentRound {
  roundId: string;
  prize: BandRafflePrize;
  /** Round start as ISO string — Moscow Monday 00:00 */
  startsAt: string;
  /** Round end as ISO string — next Moscow Monday 00:00 */
  endsAt: string;
  /** Tickets invested by everyone so far */
  totalTickets: number;
  participantsCount: number;
  /** Caller's tickets invested into this round (0 if not participating) */
  myTickets: number;
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
}

export interface BandRaffleRoundResponse {
  /** null between rounds — no week is open yet */
  round: BandRaffleCurrentRound | null;
  /** Caller's uninvested raffle ticket balance */
  ticketBalance: number;
  /** Whether the caller holds an active SHOT BAND membership */
  isMember: boolean;
}

export interface InvestBandRaffleTickets {
  /**
   * How many tickets to invest — cannot be taken back
   * @min 1
   */
  tickets: number;
}

export interface InvestBandRaffleTicketsResponse {
  roundId: string;
  /** Caller's tickets in the round after the investment */
  myTickets: number;
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
  totalTickets: number;
  participantsCount: number;
  /** Caller's remaining uninvested ticket balance */
  ticketBalance: number;
}

export interface BandRaffleParticipant {
  /** Participant user id (avatar + profile link) */
  userId: string;
  name: string;
  tickets: number;
  /** tickets / totalTickets * 100, rounded to 1 decimal */
  sharePct: number;
}

export interface BandRaffleWinner {
  name: string;
  tickets: number;
}

export interface BandRaffleRoundDetail {
  roundId: string;
  /** Monday of the Moscow week this round covers, YYYY-MM-DD */
  localWeekStart: string;
  prize: BandRafflePrize;
  /** Round start as ISO string */
  startsAt: string;
  /** Round end as ISO string */
  endsAt: string;
  totalTickets: number;
  participantsCount: number;
  /** Caller's tickets in this round (0 if not participating) */
  myTickets: number;
  status: BandRaffleRoundDetailStatusEnum;
  /** Top-50 by tickets */
  participants: BandRaffleParticipant[];
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
  /** Set once the round is COMPLETED */
  winner: BandRaffleWinner | null;
}

export interface BandRaffleWinnerPrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface BandRaffleWinnerEntry {
  roundId: string;
  /** Monday of the Moscow week this round ran, YYYY-MM-DD */
  localWeekStart: string;
  prize: BandRaffleWinnerPrize;
  /** Winner user id (avatar + profile link) */
  winnerId: string;
  winnerName: string;
  winnerTickets: number;
  totalTickets: number;
}

export interface BandRaffleWinnersResponse {
  /** Completed rounds from the last 30 days, newest first */
  winners: BandRaffleWinnerEntry[];
}

export interface BandRaceRound {
  id: string;
  /** @format date-time */
  endAt: string;
  participantsCount: number;
}

export interface BandRacePrize {
  hashName: string;
  name: string;
  imageUrl?: string | null;
  rarityName?: string | null;
  rarityColor?: string | null;
  /** Prize value in credits */
  price: number;
  /** Prize price on Steam market in USD */
  steamPriceUsd: number | null;
}

export interface BandRaceMe {
  /** 1-based place in the current round */
  rank: number;
  /** My wagered credits inside the round window */
  wageredSum: number;
}

export interface BandRaceDetailsResponse {
  /** null — race is off today */
  round?: BandRaceRound | null;
  prize?: BandRacePrize | null;
  /** null — no wagers today */
  me?: BandRaceMe | null;
}

export interface BandRaceLeaderboardEntry {
  rank: number;
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  /** Wagered credits inside the round window */
  wageredSum: number;
}

export interface BandRaceLeaderboardResponse {
  entries: BandRaceLeaderboardEntry[];
  total: number;
  hasMore: boolean;
}

export interface BandRaceWinner {
  roundId: string;
  /** Moscow day of the round, YYYY-MM-DD */
  localDate: string;
  winnerUserId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  wageredSum: number;
  prize?: BandRacePrize | null;
}

export interface BandRaceWinnersResponse {
  winners: BandRaceWinner[];
  total: number;
  hasMore: boolean;
}

export interface LocalizedText {
  title: string;
  description: string;
}

export interface AchievementI18N {
  ru: LocalizedText;
  en: LocalizedText;
  uz: LocalizedText;
  fa: LocalizedText;
}

export interface CatalogReward {
  /** XP reward at unlock time */
  xp?: number;
  /** Coin reward at unlock time */
  credits?: number;
}

export interface CatalogItem {
  key: string;
  category: string;
  /** UI tab the rule belongs to (cases, upgrades, ...) */
  uiTab: string;
  /** Full per-locale title+description map; client picks display locale */
  i18n: AchievementI18N;
  /** Asset filename under /achievements/*.png */
  iconFile: string;
  /** Threshold for progress rules; null for synthetic-event one-shots */
  threshold: number | null;
  reward: CatalogReward;
  /** True when rule is hidden until unlocked (drives reveal animation client-side) */
  secret: boolean;
}

export interface CatalogResponse {
  items: CatalogItem[];
}

export interface AchievementProgress {
  value: number;
  threshold: number;
}

export interface MergedAchievement {
  key: string;
  category: string;
  uiTab: string;
  i18n: AchievementI18N;
  iconFile: string;
  threshold: number | null;
  reward: CatalogReward;
  /** Whether this unlock's bonus was actually credited (false = claimable later) */
  rewardClaimed: boolean;
  secret: boolean;
  /** ISO timestamp when this user unlocked the rule; null if still locked */
  unlockedAt: string | null;
  /** Progress snapshot for progress-typed rules; null otherwise */
  progress: AchievementProgress | null;
}

export interface MergedAchievementsResponse {
  items: MergedAchievement[];
}

export interface ClaimableAchievementRewards {
  /** Total claimable XP across uncredited unlocks */
  claimableXp: number;
  /** Total claimable credits across uncredited unlocks */
  claimableCoins: number;
  /** Number of uncredited unlocked achievements */
  count: number;
  /** User has a COMPLETED payment in the last 30 days */
  hasRecentPayment: boolean;
  /** Sum of credits received from ALL COMPLETED deposits ever */
  totalDepositCredits: number;
  /** Deposit credits required to claim — 100% of claimableCoins */
  requiredDeposit: number;
  /** How many more deposit credits are needed to cover the claimable bonus (0 when already covered) */
  depositShortfall: number;
  /** Claim endpoint may be called (all-time deposits cover 100% of the claimable bonus, and there is something to claim) */
  canClaim: boolean;
}

export interface ClaimAchievementRewardsResult {
  /** XP credited by this claim */
  claimedXp: number;
  /** Credits granted by this claim */
  claimedCoins: number;
  /** Number of achievements credited */
  count: number;
}

export interface AchievementStats {
  /** Total users who have unlocked this key */
  unlockedCount: number;
  /** Active-user denominator (users with activity in the last 30 days) */
  totalActiveUsers: number;
  /** unlockedCount / totalActiveUsers * 100, clamped 0..100 */
  percentage: number;
}

export interface RecentReceiver {
  /** Receiver user id (for profile link / avatar) */
  userId: string;
  /** First name */
  firstName: string | null;
  /** ISO timestamp of the unlock */
  unlockedAt: string;
}

export interface RecentReceiversResponse {
  recentUnlocks: RecentReceiver[];
  /** Total users that have unlocked this key */
  totalReceivers: number;
}

export interface SurveyAnswers {
  usagePeriod?: SurveyAnswersUsagePeriodEnum;
  playFrequency?: SurveyAnswersPlayFrequencyEnum;
  usedFeatures?: SurveyAnswersUsedFeaturesEnum[];
  /**
   * @min 1
   * @max 5
   */
  overallLike?: number;
  depositStatus?: SurveyAnswersDepositStatusEnum;
  /** @maxLength 5000 */
  bestPart?: string;
  /** @maxLength 5000 */
  worstPart?: string;
  /** @maxLength 5000 */
  oneChange?: string;
  /** @maxLength 5000 */
  competitorDescriptions?: string;
  /** @maxLength 5000 */
  shotRole?: string;
  /** @maxLength 5000 */
  usageMoment?: string;
  matchesCount?: SurveyAnswersMatchesCountEnum;
  playedModes?: SurveyAnswersPlayedModesEnum[];
  clarityFirstTime?: SurveyAnswersClarityFirstTimeEnum;
  /** @maxLength 5000 */
  unclearPoints?: string;
  /** @maxLength 5000 */
  difficulties?: string;
  /** @maxLength 5000 */
  hookedBy?: string;
  /** @maxLength 5000 */
  missingForReturn?: string;
  /** @maxItems 3 */
  pros?: string[];
  /** @maxItems 3 */
  cons?: string[];
  /** @maxLength 5000 */
  firstChange?: string;
}

export interface SubmitSurveyResponse {
  /**
   * Which survey this answers (slug). Omit for the original 'default' survey.
   * @maxLength 64
   */
  slug?: string;
  language: SubmitSurveyResponseLanguageEnum;
  answers: SurveyAnswers;
}

export interface SubmitSurveyResult {
  id: string;
  submittedAt: string;
}

export interface SurveyDraftAnswers {
  usagePeriod?: SurveyDraftAnswersUsagePeriodEnum;
  playFrequency?: SurveyDraftAnswersPlayFrequencyEnum;
  usedFeatures?: SurveyDraftAnswersUsedFeaturesEnum[];
  /**
   * @min 1
   * @max 5
   */
  overallLike?: number;
  depositStatus?: SurveyDraftAnswersDepositStatusEnum;
  /** @maxLength 5000 */
  bestPart?: string;
  /** @maxLength 5000 */
  worstPart?: string;
  /** @maxLength 5000 */
  oneChange?: string;
  /** @maxLength 5000 */
  competitorDescriptions?: string;
  /** @maxLength 5000 */
  shotRole?: string;
  /** @maxLength 5000 */
  usageMoment?: string;
  matchesCount?: SurveyDraftAnswersMatchesCountEnum;
  playedModes?: SurveyDraftAnswersPlayedModesEnum[];
  clarityFirstTime?: SurveyDraftAnswersClarityFirstTimeEnum;
  /** @maxLength 5000 */
  unclearPoints?: string;
  /** @maxLength 5000 */
  difficulties?: string;
  /** @maxLength 5000 */
  hookedBy?: string;
  /** @maxLength 5000 */
  missingForReturn?: string;
  /** @maxItems 3 */
  pros?: string[];
  /** @maxItems 3 */
  cons?: string[];
  /** @maxLength 5000 */
  firstChange?: string;
}

export interface SaveSurveyDraft {
  /**
   * Which survey this answers (slug). Omit for the original 'default' survey.
   * @maxLength 64
   */
  slug?: string;
  language: SaveSurveyDraftLanguageEnum;
  /**
   * @min 0
   * @max 11
   */
  currentStep: number;
  answers: SurveyDraftAnswers;
}

export interface SaveSurveyDraftResult {
  currentStep: number;
  completed: boolean;
}

export interface SurveyDraft {
  language: string;
  currentStep: number;
  answers: SurveyDraftAnswers;
}

export interface SurveyStatus {
  completed: boolean;
  submittedAt?: string | null;
  draft?: SurveyDraft | null;
}

export interface ReportDeviceSignal {
  /** SHA-256 hex of device fingerprint components */
  fpHash: string;
  /** Версия схемы отпечатка (1 — legacy без поля) */
  fpVersion?: number;
  /** Сырые компоненты отпечатка для серверного анализа */
  components?: object;
}

export interface TmaAuth {
  /** Telegram WebApp initData (URL-encoded query string from Telegram.WebApp.initData) */
  initData: string;
  /** Account ids previously seen on this device */
  u?: string[];
}

export interface AuthSessionResponse {
  userId: string;
  /** Auth provider — telegram | steam */
  provider: string;
  /** Provider-specific user id (telegramId or steamId, as string) */
  providerUserId: string;
}

export interface TelegramLogin {
  /** Telegram user ID */
  id: number;
  /** First name */
  first_name?: string;
  /** Last name */
  last_name?: string;
  /** Username */
  username?: string;
  /** Photo URL */
  photo_url?: string;
  /** Auth date (unix timestamp) */
  auth_date: number;
  /** Hash for verification */
  hash: string;
  /** Account ids previously seen on this device */
  u?: string[];
}

export interface WebHandoffInitResponse {
  /** Opaque single-use token. TTL 60s. Append to web URL as ?handoff=... */
  token: string;
}

export interface WebHandoffRedeem {
  /** Token returned by /api/auth/web-handoff/init */
  token: string;
}

export interface SteamLinkInitResponse {
  /** URL to redirect user to Steam for authentication */
  redirectUrl: string;
}

export interface SteamConnect {
  /** Pending Steam state token */
  state: string;
  /** Telegram user ID */
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  /** Telegram auth date */
  auth_date: number;
  /** Telegram auth hash */
  hash: string;
}

export interface SteamRegister {
  /** Pending Steam state token */
  state: string;
}

export interface LinkTelegramResponse {
  /** Whether the linking was successful */
  success: boolean;
}

export interface SupportUserSummary {
  /** False until the person writes their first message */
  hasThread: boolean;
  /** Operator answers the person has not read yet */
  unreadCount: number;
  /** False when the person may not write; writing then answers 403 with the same reason */
  canWrite: boolean;
  /** blocked — support blocked the account; payment_required — no payment yet, so no conversation may be opened */
  writeRefusal?: SupportUserSummaryWriteRefusalEnum;
  lastMessageAt?: string | null;
}

export interface SupportUserAttachment {
  /** Fetch the bytes from GET /api/users/support/attachments/{id}/content */
  id: string;
  kind: SupportUserAttachmentKindEnum;
  mimeType?: string | null;
  fileName?: string | null;
  fileSize?: number | null;
  durationSec?: number | null;
  width?: number | null;
  height?: number | null;
}

export interface SupportUserMessage {
  id: string;
  /** operator — support answered; user — the person themselves */
  author: SupportUserMessageAuthorEnum;
  kind: SupportUserMessageKindEnum;
  text?: string | null;
  /** Kind-specific data: sticker emoji/animated flag, contact phone/name, location coordinates, poll question/options */
  payload?: object | null;
  /** Messages sharing it were sent as one album */
  mediaGroupId?: string | null;
  createdAt: string;
  attachments: SupportUserAttachment[];
}

export interface SupportUserMessageList {
  /** Oldest first */
  items: SupportUserMessage[];
  /** Pass as `before` to load older messages */
  nextCursor?: string | null;
}

export interface SendSupportMessage {
  /** @maxLength 4000 */
  text: string;
}

export enum PartnerStatusEnum {
  Active = "active",
  Inactive = "inactive",
}

export enum PartnerTransferInfoStatusEnum {
  Active = "active",
  Inactive = "inactive",
}

export enum PartnerTransactionTypeEnum {
  RegistrationCommission = "registration_commission",
  DepositCommission = "deposit_commission",
  Withdrawal = "withdrawal",
  Deposit = "deposit",
}

/** @example "ok" */
export enum BasicHealthStatusEnum {
  Ok = "ok",
  Error = "error",
}

/** @example "ok" */
export enum DependencyCheckStatusEnum {
  Ok = "ok",
  Error = "error",
  Unknown = "unknown",
}

/** @example "ok" */
export enum ReadinessCheckStatusEnum {
  Ok = "ok",
  Error = "error",
}

/** @example "ok" */
export enum HealthCheckStatusEnum {
  Ok = "ok",
  Error = "error",
}

/**
 * What the user is currently doing (null when offline)
 * @example "opening_case"
 */
export enum PresenceActivityEnum {
  Browsing = "browsing",
  ViewingCases = "viewing_cases",
  OpeningCase = "opening_case",
  Upgrades = "upgrades",
  Contracts = "contracts",
  CaseBattles = "case_battles",
  Shop = "shop",
  Inventory = "inventory",
  Topup = "topup",
  Auctions = "auctions",
  Wheel = "wheel",
  Giveaway = "giveaway",
  RushMid = "rush_mid",
}

/** @example "days_7" */
export enum ComebackBonusTypeEnum {
  Days7 = "days_7",
  Days14 = "days_14",
  Days30 = "days_30",
}

/**
 * Boost status
 * @example "ACTIVE"
 */
export enum UserBoostStatusStatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
}

/**
 * Source of the item
 * @example "CASE_OPENING"
 */
export enum RecentInventoryItemSourceEnum {
  CASE_OPENING = "CASE_OPENING",
  PURCHASE = "PURCHASE",
  GIFT = "GIFT",
}

/**
 * Buff type
 * @example "time_limited"
 */
export enum ActivePromocodeBuffResponseTypeEnum {
  TimeLimited = "time_limited",
  UsageLimited = "usage_limited",
  Hybrid = "hybrid",
}

/** Auction status */
export enum ActiveAuctionStatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

/** Scoring mode */
export enum DailyGiveawayPublicTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

/**
 * Type of profile task to activate
 * @example "USERNAME_IN_LASTNAME"
 */
export enum ActivateProfileTaskTaskTypeEnum {
  USERNAME_IN_LASTNAME = "USERNAME_IN_LASTNAME",
  REFERRAL_LINK_IN_BIO = "REFERRAL_LINK_IN_BIO",
}

/**
 * Type of profile task to claim reward for
 * @example "USERNAME_IN_LASTNAME"
 */
export enum ClaimProfileTaskRewardTaskTypeEnum {
  USERNAME_IN_LASTNAME = "USERNAME_IN_LASTNAME",
  REFERRAL_LINK_IN_BIO = "REFERRAL_LINK_IN_BIO",
}

/** Payment provider */
export enum CreateShopPurchaseInvoiceProviderEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
}

/** Payment currency (defaults to RUB) */
export enum CreateShopPurchaseInvoiceCurrencyEnum {
  RUB = "RUB",
  USD = "USD",
  EUR = "EUR",
  STARS = "STARS",
  UZS = "UZS",
  AMD = "AMD",
}

export enum UserShopPurchaseStatusEnum {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/**
 * Currency spent to open this case — credits, or SHOT BAND bonus balance
 * @example "credits"
 */
export enum CaseResponseOpenCurrencyEnum {
  Credits = "credits",
  Bonus = "bonus",
}

/**
 * Currency spent to open this case — credits, or SHOT BAND bonus balance
 * @example "credits"
 */
export enum CaseDetailsResponseOpenCurrencyEnum {
  Credits = "credits",
  Bonus = "bonus",
}

/** Source of the item */
export enum UserInventoryItemResponseSourceEnum {
  CASE_OPENING = "CASE_OPENING",
  CASE_BATTLE = "CASE_BATTLE",
  ADMIN_GRANT = "ADMIN_GRANT",
  AUCTION = "AUCTION",
  CONTRACT = "CONTRACT",
  UPGRADE = "UPGRADE",
  GIFT = "GIFT",
  FROM_SHOP = "FROM_SHOP",
  DRAW = "DRAW",
  CONTEST = "CONTEST",
  DAILY_GIVEAWAY = "DAILY_GIVEAWAY",
  RUSH_MID = "RUSH_MID",
  RUSH_RAFFLE = "RUSH_RAFFLE",
  ROULETTE = "ROULETTE",
  BAND_CASE = "BAND_CASE",
  BAND_RAFFLE = "BAND_RAFFLE",
  BAND_RACE = "BAND_RACE",
}

/** Current status of the item */
export enum UserInventoryItemResponseStatusEnum {
  AVAILABLE = "AVAILABLE",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  SOLD = "SOLD",
  CONTRACT_CONSUMED = "CONTRACT_CONSUMED",
  UPGRADE_CONSUMED = "UPGRADE_CONSUMED",
}

/** Why the widget produced no token; absent on requests that did not go through the UI */
export enum WithdrawItemCaptchaFailReasonEnum {
  ScriptBlocked = "script_blocked",
  Timeout = "timeout",
  ChallengeError = "challenge_error",
}

/** Error code if withdrawal failed */
export enum WithdrawItemResponseErrorCodeEnum {
  TradeLinkError = "trade_link_error",
  TradeLinkNotConfigured = "trade_link_not_configured",
  SteamGuardHold = "steam_guard_hold",
  PrivateInventory = "private_inventory",
  InventoryFull = "inventory_full",
  ItemUnavailable = "item_unavailable",
  ProviderUnavailable = "provider_unavailable",
  WithdrawalsBlocked = "withdrawals_blocked",
  WithdrawalsDisabled = "withdrawals_disabled",
  VerificationRequired = "verification_required",
  DailyLimitExceeded = "daily_limit_exceeded",
  GeneralError = "general_error",
  CaptchaFailed = "captcha_failed",
  WithdrawalLimitExceeded = "withdrawal_limit_exceeded",
  ItemNotAvailable = "item_not_available",
}

/**
 * Current trade status
 * @example "pending"
 */
export enum TradeStatusResponseStatusEnum {
  Pending = "pending",
  Confirmed = "confirmed",
  Cancelled = "cancelled",
  Failed = "failed",
}

/** Payment provider */
export enum CreateInvoiceProviderEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
}

export enum PaymentResponseCurrencyEnum {
  RUB = "RUB",
  USD = "USD",
  EUR = "EUR",
  STARS = "STARS",
  UZS = "UZS",
  AMD = "AMD",
}

export enum PaymentResponseStatusEnum {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
  EXPIRED = "EXPIRED",
  APPEAL = "APPEAL",
}

export enum PaymentProviderPackageCurrencyEnum {
  UZS = "UZS",
  RUB = "RUB",
  EUR = "EUR",
  USD = "USD",
  STARS = "STARS",
  USDT = "USDT",
}

export enum PaymentProviderIdEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
}

export enum PaymentProviderKindEnum {
  Packages = "packages",
  Exchange = "exchange",
}

export enum PaymentProviderCurrencyEnum {
  UZS = "UZS",
  RUB = "RUB",
  EUR = "EUR",
  USD = "USD",
  STARS = "STARS",
  USDT = "USDT",
}

/**
 * Language code
 * @example "ru"
 */
export enum UpdateLanguageLanguageCodeEnum {
  En = "en",
  Ru = "ru",
  Uz = "uz",
  Fa = "fa",
}

/**
 * Boost status
 * @example "PENDING"
 */
export enum ActivateBoostResponseStatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
}

/** Тип курицы: regular — обычная, cyber — кибер-курица для участников SHOT BAND */
export enum ChickenTickResponseKindEnum {
  Regular = "regular",
  Cyber = "cyber",
}

/** Transaction type */
export enum XpTransactionItemTypeEnum {
  DailyLogin = "daily_login",
  WeeklyStreak = "weekly_streak",
  CaseOpen = "case_open",
  Deposit = "deposit",
  ReferralInvite = "referral_invite",
  ReferralDeposit = "referral_deposit",
  Contract = "contract",
  UpgradeSuccess = "upgrade_success",
  UpgradeFail = "upgrade_fail",
  DrawParticipation = "draw_participation",
  DrawWin = "draw_win",
  TelegramVote = "telegram_vote",
  CaseBattleWin = "case_battle_win",
  CaseBattleLose = "case_battle_lose",
  AdminAdjust = "admin_adjust",
  Achievement = "achievement",
}

/**
 * Type of draw to participate in
 * @example "paid_5000"
 */
export enum BuyDrawEntryDrawTypeEnum {
  Deposit = "deposit",
  Referral = "referral",
  Paid5000 = "paid_5000",
  Paid10000 = "paid_10000",
  Paid25000 = "paid_25000",
}

export enum GiveawayDetailsResponseTypeEnum {
  Participants = "participants",
  Time = "time",
}

export enum GiveawayDetailsResponseStatusEnum {
  Active = "active",
  Completed = "completed",
  Cancelled = "cancelled",
  Expired = "expired",
}

/** Scoring mode */
export enum DailyGiveawayDetailResponseTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

/** Scoring mode */
export enum DailyGiveawayLeaderboardPageTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

/** Scoring mode */
export enum DailyGiveawayWinnersPageTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

export enum ReferralContestLeaderboardResponseStatusEnum {
  Upcoming = "upcoming",
  Active = "active",
  Finished = "finished",
}

/**
 * What the user is currently doing
 * @example "opening_case"
 */
export enum HeartbeatRequestActivityEnum {
  Browsing = "browsing",
  ViewingCases = "viewing_cases",
  OpeningCase = "opening_case",
  Upgrades = "upgrades",
  Contracts = "contracts",
  CaseBattles = "case_battles",
  Shop = "shop",
  Inventory = "inventory",
  Topup = "topup",
  Auctions = "auctions",
  Wheel = "wheel",
  Giveaway = "giveaway",
  RushMid = "rush_mid",
}

export enum CaseBattleListItemResponseStatusEnum {
  WAITING = "WAITING",
  PROCESSING = "PROCESSING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum CaseBattleHistoryItemResponseStatusEnum {
  WAITING = "WAITING",
  PROCESSING = "PROCESSING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum CaseBattleRoundDetailResponseStatusEnum {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}

export enum CaseBattleDetailsResponseStatusEnum {
  WAITING = "WAITING",
  PROCESSING = "PROCESSING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

/** Entry ticket / stake */
export enum CreateOpenGameRequestTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum CreateOpenGameRequestModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Side to fight on */
export enum CreateOpenGameRequestSideEnum {
  T = "t",
  Ct = "ct",
}

/** Match mode: 'ranked' (default, public + listed) or 'bots' (practice — no stake, rating, rewards, drops or listing) */
export enum CreateOpenGameRequestMatchModeEnum {
  Ranked = "ranked",
  Bots = "bots",
}

/** Weapon class */
export enum RushMidLoadoutWeaponEnum {
  Awp = "awp",
  Rifle = "rifle",
  Lmg = "lmg",
}

/** Whole-vest armor tier */
export enum RushMidLoadoutArmorEnum {
  None = "none",
  Light = "light",
  Heavy = "heavy",
}

export enum RushMidPublicFighterTeamEnum {
  T = "t",
  Ct = "ct",
}

/** Current shooting stance */
export enum RushMidPublicFighterStanceEnum {
  Attack = "attack",
  Defense = "defense",
  Maneuver = "maneuver",
}

export enum RushMidScoreEntryTeamEnum {
  T = "t",
  Ct = "ct",
}

/** Current Rush Mid phase for this user */
export enum RushMidSnapshotStatusEnum {
  NONE = "NONE",
  OPEN = "OPEN",
  BUYING = "BUYING",
  PLAYING = "PLAYING",
  OVER = "OVER",
}

/** The user's side preference ('any' = either team) */
export enum RushMidSnapshotSideEnum {
  T = "t",
  Ct = "ct",
  Any = "any",
}

/** OPEN: the side the caller is seated on */
export enum RushMidSnapshotYourSideEnum {
  T = "t",
  Ct = "ct",
}

/** OVER: winning side (null = mutual wipe) */
export enum RushMidSnapshotWinnerEnum {
  T = "t",
  Ct = "ct",
}

/** Entry ticket / stake */
export enum OpenGameTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum OpenGameModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** why the join is blocked */
export enum OpenGameJoinBlockedReasonEnum {
  Grace = "grace",
}

/** Entry ticket / stake */
export enum LiveGameTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum LiveGameModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Watched match phase */
export enum RushMidSpectateViewStatusEnum {
  PLAYING = "PLAYING",
  OVER = "OVER",
}

/** battle map */
export enum RushMidSpectateViewMapEnum {
  Dust2 = "dust2",
  Mirage = "mirage",
  Inferno = "inferno",
  Nuke = "nuke",
}

/** OVER: winning side (null = mutual wipe) */
export enum RushMidSpectateViewWinnerEnum {
  T = "t",
  Ct = "ct",
}

/** Side to join */
export enum JoinOpenGameRequestSideEnum {
  T = "t",
  Ct = "ct",
}

/** Team size (must be >= party size) */
export enum PartyConfigRequestModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Entry ticket / stake */
export enum PartyConfigRequestTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Side the whole party fights on ('any' = whichever team has room) */
export enum PartyConfigRequestSideEnum {
  T = "t",
  Ct = "ct",
  Any = "any",
}

/** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
export enum PartyConfigRequestMatchModeEnum {
  Ranked = "ranked",
  Bots = "bots",
}

/** Action kind for this round */
export enum SubmitActionRequestKindEnum {
  Shoot = "shoot",
  Knife = "knife",
  Grenade = "grenade",
  Medkit = "medkit",
  Smoke = "smoke",
  Flash = "flash",
}

/** Shooting stance (for kind=shoot) */
export enum SubmitActionRequestStanceEnum {
  Attack = "attack",
  Defense = "defense",
  Maneuver = "maneuver",
}

/** how the skin is earned */
export enum RushMidWeaponSkinOptionUnlockEnum {
  Public = "public",
  Elo = "elo",
  Grant = "grant",
}

/** Entry ticket / stake */
export enum JoinMatchmakingRequestTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum JoinMatchmakingRequestModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Side to fight on ('any' = whichever team has room) */
export enum JoinMatchmakingRequestSideEnum {
  T = "t",
  Ct = "ct",
  Any = "any",
}

/** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
export enum JoinMatchmakingRequestMatchModeEnum {
  Ranked = "ranked",
  Bots = "bots",
}

/** side the skin belongs to */
export enum SetRushMidSkinRequestSideEnum {
  T = "t",
  Ct = "ct",
}

/** weapon key the skin belongs to */
export enum SetRushMidWeaponSkinRequestWeaponKeyEnum {
  Ak = "ak",
  M4 = "m4",
  Awp = "awp",
  Lmg = "lmg",
}

/** battle map */
export enum RushMidMatchDetailMapEnum {
  Dust2 = "dust2",
  Mirage = "mirage",
  Inferno = "inferno",
  Nuke = "nuke",
}

export enum RushMidMatchDetailWinnerEnum {
  T = "t",
  Ct = "ct",
}

/** battle map */
export enum RushMidReplayMapEnum {
  Dust2 = "dust2",
  Mirage = "mirage",
  Inferno = "inferno",
  Nuke = "nuke",
}

export enum RushMidReplayWinnerEnum {
  T = "t",
  Ct = "ct",
}

/** OPEN lobby still collecting players, or a full house counting down to the start */
export enum RouletteOpenGameStatusEnum {
  OPEN = "OPEN",
  COUNTDOWN = "COUNTDOWN",
}

/** Entry ticket — one of the presets */
export enum RouletteCreateGameRequestStakeEnum {
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value10000 = 10000,
  Value50000 = 50000,
  Value100000 = 100000,
  Value500000 = 500000,
  Value1000000 = 1000000,
}

/** The caller's current roulette status */
export enum RouletteStateStatusEnum {
  None = "none",
  Match = "match",
}

/** The seated match's status (present only with status = match). Seats deactivate on finish, so this only ever carries a LIVE status (OPEN/COUNTDOWN/ACTIVE) — the client always follows it in. */
export enum RouletteStateMatchStatusEnum {
  OPEN = "OPEN",
  COUNTDOWN = "COUNTDOWN",
  ACTIVE = "ACTIVE",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum RouletteSeatStatusEnum {
  Alive = "alive",
  Dead = "dead",
  Winner = "winner",
}

export enum RouletteMatchStatusEnum {
  OPEN = "OPEN",
  COUNTDOWN = "COUNTDOWN",
  ACTIVE = "ACTIVE",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum RouletteHistoryItemStatusEnum {
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum RouletteFairnessEventTypeEnum {
  Click = "click",
  Shot = "shot",
  Skip = "skip",
  Reload = "reload",
  Finished = "finished",
}

/** Which rung produced the candidates: 'band' = skins priced in [payout × 0.85, payout], 'below' = the nearest-below skins with no floor, 'cheapest' = the single cheapest tradable skin (above the payout, the house covers the difference) */
export enum RoulettePrizeDrawPoolLevelEnum {
  Band = "band",
  Below = "below",
  Cheapest = "cheapest",
}

export enum RushRaffleRoundDetailStatusEnum {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  EMPTY = "EMPTY",
}

export enum CreateBandTicketInvoiceProviderEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
}

/** 'pending' until Click's callback lands and membership switches on */
export enum PayBandTicketWithClickCardResponseStatusEnum {
  Completed = "completed",
  Pending = "pending",
}

export enum BandQuestSlotEnum {
  Easy = "easy",
  Medium = "medium",
  Hard = "hard",
}

export enum BandRaffleRoundDetailStatusEnum {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  EMPTY = "EMPTY",
}

export enum SurveyAnswersUsagePeriodEnum {
  LtWeek = "lt_week",
  Value14Weeks = "1_4_weeks",
  Value13Months = "1_3_months",
  Value36Months = "3_6_months",
  Gt6Months = "gt_6_months",
}

export enum SurveyAnswersPlayFrequencyEnum {
  ManyDaily = "many_daily",
  Daily = "daily",
  FewWeek = "few_week",
  Weekly = "weekly",
  Rare = "rare",
}

export enum SurveyAnswersUsedFeaturesEnum {
  Cases = "cases",
  Upgrades = "upgrades",
  Contracts = "contracts",
  Battles = "battles",
  Achievements = "achievements",
  Withdrawals = "withdrawals",
  Referral = "referral",
}

export enum SurveyAnswersDepositStatusEnum {
  Many = "many",
  Value25 = "2_5",
  Once = "once",
  Planned = "planned",
  Never = "never",
}

export enum SurveyAnswersMatchesCountEnum {
  Value1 = "1",
  Value23 = "2_3",
  Value47 = "4_7",
  Value8Plus = "8_plus",
  DontRemember = "dont_remember",
}

export enum SurveyAnswersPlayedModesEnum {
  Value1X1 = "1x1",
  Value2X2 = "2x2",
  Value5X5 = "5x5",
  Bots = "bots",
  RealPlayers = "real_players",
  Party = "party",
  LookOnly = "look_only",
}

export enum SurveyAnswersClarityFirstTimeEnum {
  Clear = "clear",
  MostlyClear = "mostly_clear",
  FiguredOut = "figured_out",
  ManyUnclear = "many_unclear",
  NothingClear = "nothing_clear",
}

export enum SubmitSurveyResponseLanguageEnum {
  Ru = "ru",
  Uz = "uz",
  En = "en",
}

export enum SurveyDraftAnswersUsagePeriodEnum {
  LtWeek = "lt_week",
  Value14Weeks = "1_4_weeks",
  Value13Months = "1_3_months",
  Value36Months = "3_6_months",
  Gt6Months = "gt_6_months",
}

export enum SurveyDraftAnswersPlayFrequencyEnum {
  ManyDaily = "many_daily",
  Daily = "daily",
  FewWeek = "few_week",
  Weekly = "weekly",
  Rare = "rare",
}

export enum SurveyDraftAnswersUsedFeaturesEnum {
  Cases = "cases",
  Upgrades = "upgrades",
  Contracts = "contracts",
  Battles = "battles",
  Achievements = "achievements",
  Withdrawals = "withdrawals",
  Referral = "referral",
}

export enum SurveyDraftAnswersDepositStatusEnum {
  Many = "many",
  Value25 = "2_5",
  Once = "once",
  Planned = "planned",
  Never = "never",
}

export enum SurveyDraftAnswersMatchesCountEnum {
  Value1 = "1",
  Value23 = "2_3",
  Value47 = "4_7",
  Value8Plus = "8_plus",
  DontRemember = "dont_remember",
}

export enum SurveyDraftAnswersPlayedModesEnum {
  Value1X1 = "1x1",
  Value2X2 = "2x2",
  Value5X5 = "5x5",
  Bots = "bots",
  RealPlayers = "real_players",
  Party = "party",
  LookOnly = "look_only",
}

export enum SurveyDraftAnswersClarityFirstTimeEnum {
  Clear = "clear",
  MostlyClear = "mostly_clear",
  FiguredOut = "figured_out",
  ManyUnclear = "many_unclear",
  NothingClear = "nothing_clear",
}

export enum SaveSurveyDraftLanguageEnum {
  Ru = "ru",
  Uz = "uz",
  En = "en",
}

/** blocked — support blocked the account; payment_required — no payment yet, so no conversation may be opened */
export enum SupportUserSummaryWriteRefusalEnum {
  Blocked = "blocked",
  PaymentRequired = "payment_required",
}

export enum SupportUserAttachmentKindEnum {
  Text = "text",
  Photo = "photo",
  Video = "video",
  VideoNote = "video_note",
  Voice = "voice",
  Audio = "audio",
  Document = "document",
  Sticker = "sticker",
  Animation = "animation",
  Contact = "contact",
  Location = "location",
  Poll = "poll",
  Other = "other",
}

/** operator — support answered; user — the person themselves */
export enum SupportUserMessageAuthorEnum {
  User = "user",
  Operator = "operator",
  System = "system",
}

export enum SupportUserMessageKindEnum {
  Text = "text",
  Photo = "photo",
  Video = "video",
  VideoNote = "video_note",
  Voice = "voice",
  Audio = "audio",
  Document = "document",
  Sticker = "sticker",
  Animation = "animation",
  Contact = "contact",
  Location = "location",
  Poll = "poll",
  Other = "other",
}

export interface PublicControllerGetItemImageParams {
  /**
   * Steam market hash name of the item
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
}

export interface PublicControllerGetCaseImageParams {
  /** Return thumbnail version (320x320) */
  thumbnail?: boolean;
  /**
   * UUID of the case
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  caseId: string;
}

export interface PartnerPublicControllerGetPartnerDailyStatsParams {
  /** Start date (YYYY-MM-DD) */
  fromDate: string;
  /** End date (YYYY-MM-DD) */
  toDate: string;
  /** Page number (default: 1) */
  page?: number;
  /** Page size (default: 20) */
  limit?: number;
  /** Partner ID */
  id: string;
}

export interface PartnerPublicControllerListPartnerWithdrawalsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Page size (default: 20) */
  limit?: number;
  /** Partner ID */
  id: string;
}

export interface PartnerPublicControllerGetPartnerTransactionsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Page size (default: 20) */
  limit?: number;
  /** Start date (YYYY-MM-DD) */
  fromDate?: string;
  /** End date (YYYY-MM-DD) */
  toDate?: string;
  /** Partner ID */
  id: string;
}

export interface RedirectControllerRedirectParams {
  /** Redirect target: app (default) or bot */
  target?: string;
  /** Referral telegram ID */
  ref?: string;
  /** Yandex Click ID (auto-appended by Yandex Direct) */
  yclid?: string;
  /** Campaign ID from Yandex Direct */
  cid?: string;
  /** Ad ID from Yandex Direct */
  aid?: string;
  /** Yandex ad source marker */
  ya?: string;
  /** UTM term (keyword) for Qurvo tracking */
  utm_term?: string;
}

export interface UserControllerGetProfileStatsParams {
  /** User ID to get public profile stats. If not provided, returns own profile stats. */
  userId?: string;
}

export interface UserControllerGetReferralsParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   * @example "20"
   */
  limit?: string;
}

export interface AuctionControllerGetActiveAuctionsParams {
  /** Filter by auction status. Can be a single value or array. If not provided, returns PENDING and ACTIVE auctions by default. */
  status?: StatusEnum[];
}

export enum StatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
}

export enum AuctionControllerGetActiveAuctionsParams1StatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
}

export interface AuctionControllerGetAuctionBidsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Items per page (default: 20) */
  limit?: number;
  auctionId: string;
}

export interface ContractsControllerPreviewContractParams {
  /**
   * Array of inventory item IDs
   * @example ["uuid1","uuid2","uuid3"]
   */
  itemIds: string[];
}

export interface ContractsControllerGetContractHistoryParams {
  /**
   * Page number
   * @default 1
   */
  page?: number;
  /**
   * Items per page
   * @default 20
   */
  limit?: number;
}

export interface UpgradeControllerGetUpgradeHistoryParams {
  /**
   * Page number
   * @min 1
   * @default 1
   * @example 1
   */
  page?: number;
  /**
   * Items per page
   * @min 1
   * @max 100
   * @default 20
   * @example 20
   */
  perPage?: number;
  /** Number of items to take (max 100) */
  take?: number;
  /** Number of items to skip */
  skip?: number;
}

export interface UpgradeControllerGetAvailableUpgradeTargetsParams {
  /** Search term for item name */
  searchTerm?: string;
  /** Filter by item category */
  category?: string;
  /** Filter by item type */
  type?: string;
  /** Filter by weapon name */
  weapon?: string;
  /**
   * Page number (1-based)
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Number of items per page
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  sourceItemId: string;
}

export interface ShopControllerGetShopItemsParams {
  /**
   * Page number (1-based)
   * @default 1
   * @example 1
   */
  page?: number;
  /**
   * Number of items per page
   * @default 20
   * @example 20
   */
  limit?: number;
  /**
   * Filter by exact hashName (single-item lookup)
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName?: string;
  /**
   * Filter by category
   * @example "Rifle"
   */
  category?: string;
  /**
   * Filter by weapon
   * @example "AK-47"
   */
  weapon?: string;
  /**
   * Filter by skin name (part after | in item name)
   * @example "Asiimov"
   */
  skinName?: string;
  /**
   * Filter by type
   * @example "skin"
   */
  type?: TypeEnum;
  /**
   * Filter by wear condition (for skins)
   * @example "Factory New"
   */
  wear?: WearEnum;
  /**
   * Filter by rarity
   * @example "Classified"
   */
  rarity?: string;
  /**
   * Minimum price in credits
   * @example 25000
   */
  minPrice?: number;
  /**
   * Maximum price in credits
   * @example 100000
   */
  maxPrice?: number;
  /**
   * Filter by StatTrak
   * @example true
   */
  statTrak?: boolean;
  /**
   * Sort order
   * @default "volume_desc"
   * @example "volume_desc"
   */
  sortBy?: SortByEnum;
}

/**
 * Filter by type
 * @example "skin"
 */
export enum TypeEnum {
  Skin = "skin",
  Crate = "crate",
  Keychain = "keychain",
  Graffiti = "graffiti",
  Sticker = "sticker",
  Agent = "agent",
}

/**
 * Filter by wear condition (for skins)
 * @example "Factory New"
 */
export enum WearEnum {
  FactoryNew = "Factory New",
  MinimalWear = "Minimal Wear",
  FieldTested = "Field-Tested",
  WellWorn = "Well-Worn",
  BattleScarred = "Battle-Scarred",
}

/**
 * Sort order
 * @default "volume_desc"
 * @example "volume_desc"
 */
export enum SortByEnum {
  VolumeDesc = "volume_desc",
  VolumeAsc = "volume_asc",
  PriceDesc = "price_desc",
  PriceAsc = "price_asc",
}

/**
 * Filter by type
 * @example "skin"
 */
export enum ShopControllerGetShopItemsParams1TypeEnum {
  Skin = "skin",
  Crate = "crate",
  Keychain = "keychain",
  Graffiti = "graffiti",
  Sticker = "sticker",
  Agent = "agent",
}

/**
 * Filter by wear condition (for skins)
 * @example "Factory New"
 */
export enum ShopControllerGetShopItemsParams1WearEnum {
  FactoryNew = "Factory New",
  MinimalWear = "Minimal Wear",
  FieldTested = "Field-Tested",
  WellWorn = "Well-Worn",
  BattleScarred = "Battle-Scarred",
}

/**
 * Sort order
 * @default "volume_desc"
 * @example "volume_desc"
 */
export enum ShopControllerGetShopItemsParams1SortByEnum {
  VolumeDesc = "volume_desc",
  VolumeAsc = "volume_asc",
  PriceDesc = "price_desc",
  PriceAsc = "price_asc",
}

export interface ShopControllerGetShopSkinsParams {
  /**
   * Weapon name to get skins for
   * @example "AK-47"
   */
  weapon: string;
  /**
   * Skin name pattern to filter by
   * @example "Asiimov"
   */
  skinName?: string;
  /**
   * Filter by rarity name
   * @example "Covert"
   */
  rarity?: string;
  /**
   * Minimum price in rubles
   * @example 100
   */
  minPrice?: number;
  /**
   * Maximum price in rubles
   * @example 1000
   */
  maxPrice?: number;
  /** Sort by field */
  sortBy?: GetShopSkinsSortBy;
}

export interface ShopControllerGetMyShopPurchasesParams {
  /** @example 1 */
  page?: number;
  /** @example 20 */
  limit?: number;
}

export interface CaseControllerGetCaseOpeningsParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   * @example "20"
   */
  limit?: string;
}

export interface CaseControllerGetCaseItemDropsParams {
  /** How many drops to return (1-50, default 10) */
  limit?: string;
  /** Case ID */
  caseId: string;
  /** Item hash name */
  hashName: string;
}

export interface InventoryControllerGetInventoryParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   * @example "20"
   */
  limit?: string;
  /**
   * Sort by field
   * @default "acquiredAt"
   */
  sortBy?: SortByEnum1;
  /**
   * Sort order
   * @default "DESC"
   */
  sortOrder?: SortOrderEnum;
  /**
   * Filter by item statuses
   * @example ["AVAILABLE","SOLD"]
   */
  statuses?: StatusesEnum[];
  /**
   * Minimum price filter in credits
   * @example 1000
   */
  minPrice?: number;
  /**
   * Filter by item type
   * @example "skin"
   */
  type?: string;
}

/**
 * Sort by field
 * @default "acquiredAt"
 */
export enum SortByEnum1 {
  AcquiredAt = "acquiredAt",
  AcquiredPrice = "acquiredPrice",
}

/**
 * Sort order
 * @default "DESC"
 */
export enum SortOrderEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export enum StatusesEnum {
  AVAILABLE = "AVAILABLE",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  SOLD = "SOLD",
  CONTRACT_CONSUMED = "CONTRACT_CONSUMED",
  UPGRADE_CONSUMED = "UPGRADE_CONSUMED",
}

/**
 * Sort by field
 * @default "acquiredAt"
 */
export enum InventoryControllerGetInventoryParams1SortByEnum {
  AcquiredAt = "acquiredAt",
  AcquiredPrice = "acquiredPrice",
}

/**
 * Sort order
 * @default "DESC"
 */
export enum InventoryControllerGetInventoryParams1SortOrderEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export enum InventoryControllerGetInventoryParams1StatusesEnum {
  AVAILABLE = "AVAILABLE",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  SOLD = "SOLD",
  CONTRACT_CONSUMED = "CONTRACT_CONSUMED",
  UPGRADE_CONSUMED = "UPGRADE_CONSUMED",
}

export interface InventoryControllerGetRecentInventoryItemsParams {
  limit: string;
}

export interface InventoryControllerGetTopRecentDropsParams {
  limit: string;
}

export interface XpControllerGetXpHistoryParams {
  /**
   * Page number
   * @default "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   */
  limit?: string;
}

export interface XpControllerGetXpLeaderboardParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page (max 100)
   * @default "20"
   * @example "20"
   */
  limit?: string;
}

export interface DrawsControllerGetWinnersHistoryParams {
  /** Maximum number of winners to return */
  limit?: number;
  /** Filter by draw type */
  type?: TypeEnum1;
}

/** Filter by draw type */
export enum TypeEnum1 {
  Deposit = "deposit",
  Referral = "referral",
  Paid5000 = "paid_5000",
  Paid10000 = "paid_10000",
  Paid25000 = "paid_25000",
}

/** Filter by draw type */
export enum DrawsControllerGetWinnersHistoryParams1TypeEnum {
  Deposit = "deposit",
  Referral = "referral",
  Paid5000 = "paid_5000",
  Paid10000 = "paid_10000",
  Paid25000 = "paid_25000",
}

export interface DrawsControllerGetDrawParticipantsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Items per page (default: 20) */
  limit?: number;
  /** Draw ID */
  id: string;
}

export interface GiveawaysControllerGetParticipantsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Items per page (default: 20) */
  limit?: number;
  /** Giveaway ID */
  id: string;
}

export interface DailyGiveawayControllerGetLeaderboardParams {
  page?: number;
  limit?: number;
  id: string;
}

export interface DailyGiveawayControllerGetWinnersParams {
  page?: number;
  limit?: number;
  id: string;
}

export interface ReferralContestControllerGetLeaderboardParams {
  /** Board entries to skip */
  offset?: number;
}

export interface CaseBattleControllerGetAllCaseBattleHistoryParams {
  /** Number of battles to skip */
  skip?: number;
  /** Number of battles to take */
  take?: number;
}

export interface CaseBattleControllerGetUserCaseBattleHistoryParams {
  /** Number of battles to skip */
  skip?: number;
  /** Number of battles to take */
  take?: number;
}

export interface RushMidControllerHistoryParams {
  skip?: number;
  take?: number;
}

export interface RushMidControllerRatingParams {
  /** Team size (1/2/5); defaults to 1 */
  mode?: ModeEnum;
}

/** Team size (1/2/5); defaults to 1 */
export enum ModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Team size (1/2/5); defaults to 1 */
export enum RushMidControllerRatingParams1ModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export interface RouletteControllerHistoryParams {
  limit?: number;
  /** Opaque cursor from a previous page's nextCursor */
  cursor?: string;
}

export interface RouletteControllerFeedParams {
  limit?: number;
  /** Opaque cursor from a previous page's nextCursor */
  cursor?: string;
}

export interface BandRaceControllerGetLeaderboardParams {
  /** @default 1 */
  page?: number;
  /** @default 10 */
  limit?: number;
}

export interface BandRaceControllerGetWinnersParams {
  /** @default 1 */
  page?: number;
  /** @default 10 */
  limit?: number;
}

export interface AchievementsControllerGetMyParams {
  onlyUnlocked?: boolean;
  hideLockedSecrets?: boolean;
}

export interface AchievementsControllerGetForUserParams {
  onlyUnlocked?: boolean;
  hideLockedSecrets?: boolean;
  userId: string;
}

export interface SurveyControllerMyStatusParams {
  /** Which survey to check. Omit for the original 'default' survey. */
  slug?: string;
}

export interface SteamAuthControllerInitSteamLinkParams {
  source: string;
}

export interface SupportControllerGetMessagesParams {
  /** Opaque cursor from a previous page; walks backwards in time */
  before?: string;
  /**
   * @min 1
   * @max 100
   * @default 50
   */
  limit?: number;
}

export namespace Api {
  /**
   * No description
   * @tags Public
   * @name PublicControllerGetGameStats
   * @summary Get global game statistics counters
   * @request GET:/api/public/game-stats
   * @response `200` `GameStatsResponse` Game statistics
   */
  export namespace PublicControllerGetGameStats {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GameStatsResponse;
  }

  /**
   * @description Returns an item image with a background colored according to its rarity
   * @tags Public
   * @name PublicControllerGetItemImage
   * @summary Get item image with rarity background
   * @request GET:/api/public/item-image
   * @response `200` `File` Item image with rarity background
   * @response `400` `void` Invalid parameters or image processing failed
   * @response `404` `void` Item not found
   */
  export namespace PublicControllerGetItemImage {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Steam market hash name of the item
       * @example "AK-47 | Redline (Field-Tested)"
       */
      hashName: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * @description Returns a case image with gray background in JPEG format
   * @tags Public
   * @name PublicControllerGetCaseImage
   * @summary Get case image by ID
   * @request GET:/api/public/case-image/{caseId}
   * @response `200` `File` Case image with gray background in JPEG format
   * @response `400` `void` Invalid parameters or image processing failed
   * @response `404` `void` Case not found
   */
  export namespace PublicControllerGetCaseImage {
    export type RequestParams = {
      /**
       * UUID of the case
       * @example "123e4567-e89b-12d3-a456-426614174000"
       */
      caseId: string;
    };
    export type RequestQuery = {
      /** Return thumbnail version (320x320) */
      thumbnail?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * @description Proxies broadcast images from S3 storage
   * @tags Public
   * @name PublicControllerGetBroadcastImage
   * @summary Get broadcast image
   * @request GET:/api/public/broadcast-images/{filename}
   * @response `200` `File` Broadcast image
   * @response `404` `void` Image not found
   */
  export namespace PublicControllerGetBroadcastImage {
    export type RequestParams = {
      /**
       * Filename of the broadcast image
       * @example "123e4567-e89b-12d3-a456-426614174000.jpg"
       */
      filename: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerById
   * @summary Get partner details by ID (public)
   * @request GET:/api/public/partners/{id}
   * @response `200` `Partner` Partner details
   * @response `404` `void` Partner not found
   */
  export namespace PartnerPublicControllerGetPartnerById {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Partner;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerTransferInfo
   * @summary Get the balance and conversion rate for a partner balance transfer (public)
   * @request GET:/api/public/partners/{id}/transfer-info
   * @response `200` `PartnerTransferInfo` Transfer info
   * @response `404` `void` Partner not found
   */
  export namespace PartnerPublicControllerGetPartnerTransferInfo {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PartnerTransferInfo;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerTransferToBalance
   * @summary Transfer partner balance to the account balance of the partner owner (public)
   * @request POST:/api/public/partners/{id}/transfer-to-balance
   * @response `200` `TransferPartnerBalanceResponse` Transfer completed
   * @response `400` `void` Invalid amount
   * @response `402` `void` Transfer amount exceeds the partner balance
   * @response `404` `void` Partner not found
   * @response `422` `void` Partner is inactive
   */
  export namespace PartnerPublicControllerTransferToBalance {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = TransferPartnerBalance;
    export type RequestHeaders = {};
    export type ResponseBody = TransferPartnerBalanceResponse;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerDailyStats
   * @summary Get partner daily statistics (public)
   * @request GET:/api/public/partners/{id}/daily-stats
   * @response `200` `ListPartnerDailyStatsResponse` Daily statistics with pagination
   */
  export namespace PartnerPublicControllerGetPartnerDailyStats {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {
      /** Start date (YYYY-MM-DD) */
      fromDate: string;
      /** End date (YYYY-MM-DD) */
      toDate: string;
      /** Page number (default: 1) */
      page?: number;
      /** Page size (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListPartnerDailyStatsResponse;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerListPartnerWithdrawals
   * @summary Get partner withdrawals and deposits (public)
   * @request GET:/api/public/partners/{id}/withdrawals
   * @response `200` `ListPartnerWithdrawalsResponse` Withdrawals list
   */
  export namespace PartnerPublicControllerListPartnerWithdrawals {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Page size (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListPartnerWithdrawalsResponse;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerTransactions
   * @summary Get partner transactions with pagination and date filters (public)
   * @request GET:/api/public/partners/{id}/transactions
   * @response `200` `ListPartnerTransactionsResponse` Transactions list with pagination
   * @response `404` `void` Partner not found
   */
  export namespace PartnerPublicControllerGetPartnerTransactions {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Page size (default: 20) */
      limit?: number;
      /** Start date (YYYY-MM-DD) */
      fromDate?: string;
      /** End date (YYYY-MM-DD) */
      toDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListPartnerTransactionsResponse;
  }

  /**
   * No description
   * @tags Redirect
   * @name RedirectControllerRedirect
   * @summary Redirect to Telegram bot/app with tracking params
   * @request GET:/api/redirect
   * @response `200` `void`
   */
  export namespace RedirectControllerRedirect {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Redirect target: app (default) or bot */
      target?: string;
      /** Referral telegram ID */
      ref?: string;
      /** Yandex Click ID (auto-appended by Yandex Direct) */
      yclid?: string;
      /** Campaign ID from Yandex Direct */
      cid?: string;
      /** Ad ID from Yandex Direct */
      aid?: string;
      /** Yandex ad source marker */
      ya?: string;
      /** UTM term (keyword) for Qurvo tracking */
      utm_term?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Landing
   * @name LandingControllerGenerateStartParam
   * @summary Generate compressed start param for Telegram deep link
   * @request POST:/api/landing/start-param
   * @response `201` `void`
   */
  export namespace LandingControllerGenerateStartParam {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = StartParam;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Public
   * @name PublicConfigControllerGetConfig
   * @summary Get public application config
   * @request GET:/api/public/config
   * @response `200` `PublicConfigResponse`
   */
  export namespace PublicConfigControllerGetConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PublicConfigResponse;
  }

  /**
   * @description Issues a 302 from our origin so the Referer header matches our domain when the browser navigates to wata.pro.
   * @tags Payment
   * @name WataproRedirectControllerRedirect
   * @summary Redirect to wata.pro hosted payment page
   * @request GET:/api/payment/watapro-sbp/redirect/{invoiceId}
   * @response `200` `void`
   */
  export namespace WataproRedirectControllerRedirect {
    export type RequestParams = {
      invoiceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Health
   * @name HealthControllerCheck
   * @summary Basic health check
   * @request GET:/api/health
   * @response `200` `BasicHealth` Service is healthy
   */
  export namespace HealthControllerCheck {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BasicHealth;
  }

  /**
   * No description
   * @tags Health
   * @name HealthControllerReadiness
   * @summary Readiness check with dependencies
   * @request GET:/api/health/ready
   * @response `200` `ReadinessCheck` Service is ready
   * @response `503` `void` Service is not ready
   */
  export namespace HealthControllerReadiness {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReadinessCheck;
  }

  /**
   * No description
   * @tags Health
   * @name HealthControllerLiveness
   * @summary Liveness check
   * @request GET:/api/health/live
   * @response `200` `HealthCheck` Service is alive
   */
  export namespace HealthControllerLiveness {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthCheck;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerRegister
   * @summary Register a new user (TMA initData auth)
   * @request POST:/api/users/register
   * @secure
   * @response `201` `RegisterResponse` User successfully registered
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerRegister {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RegisterUser;
    export type RequestHeaders = {};
    export type ResponseBody = RegisterResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetProfile
   * @summary Get user profile information
   * @request GET:/api/users/profile
   * @secure
   * @response `200` `UserProfileResponse` User profile retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerGetProfile {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserProfileResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetProfileStats
   * @summary Get user profile statistics (own or public)
   * @request GET:/api/users/profile/stats
   * @response `200` `ProfileStatsResponse` User profile statistics retrieved successfully
   */
  export namespace UserControllerGetProfileStats {
    export type RequestParams = {};
    export type RequestQuery = {
      /** User ID to get public profile stats. If not provided, returns own profile stats. */
      userId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProfileStatsResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetReferrals
   * @summary Get paginated list of referred users
   * @request GET:/api/users/referrals
   * @secure
   * @response `200` `PaginatedReferralsResponse` Referrals retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerGetReferrals {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       * @example "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedReferralsResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetReferralStats
   * @summary Get referral statistics (total referrals, earned credits, bonus progress)
   * @request GET:/api/users/referral-stats
   * @secure
   * @response `200` `ReferralStatsResponse` Referral statistics retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerGetReferralStats {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReferralStatsResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerSavePreparedInlineMessage
   * @summary Save prepared inline message for sharing
   * @request POST:/api/users/save-prepared-inline-message
   * @secure
   * @response `200` `SavePreparedInlineMessageResponse` Prepared inline message saved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerSavePreparedInlineMessage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SavePreparedInlineMessage;
    export type RequestHeaders = {};
    export type ResponseBody = SavePreparedInlineMessageResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerHealthCheck
   * @summary Health check endpoint
   * @request GET:/api/users/health
   * @response `200` `HealthCheckResponse` Service is healthy
   */
  export namespace UserControllerHealthCheck {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthCheckResponse;
  }

  /**
   * No description
   * @tags Home
   * @name HomeControllerGetHome
   * @summary Всё содержимое главного экрана одним запросом
   * @request GET:/api/users/home
   * @secure
   * @response `200` `HomeSnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeControllerGetHome {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HomeSnapshot;
  }

  /**
   * No description
   * @tags Auctions
   * @name AuctionControllerGetActiveAuctions
   * @summary Get auctions with optional status filter
   * @request GET:/api/users/auctions
   * @response `200` `ActiveAuctionsResponse` List of auctions
   */
  export namespace AuctionControllerGetActiveAuctions {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Filter by auction status. Can be a single value or array. If not provided, returns PENDING and ACTIVE auctions by default. */
      status?: AuctionControllerGetActiveAuctionsParams1StatusEnum[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ActiveAuctionsResponse;
  }

  /**
   * No description
   * @tags Auctions
   * @name AuctionControllerGetAuctionDetails
   * @summary Get auction details by ID
   * @request GET:/api/users/auctions/{auctionId}
   * @response `200` `AuctionDetailsResponse` Auction details including bids
   * @response `404` `void` Auction not found
   */
  export namespace AuctionControllerGetAuctionDetails {
    export type RequestParams = {
      auctionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionDetailsResponse;
  }

  /**
   * No description
   * @tags Auctions
   * @name AuctionControllerGetAuctionBids
   * @summary Get paginated bids for an auction
   * @request GET:/api/users/auctions/{auctionId}/bids
   * @response `200` `PaginatedBidsResponse` Paginated list of bids
   * @response `404` `void` Auction not found
   */
  export namespace AuctionControllerGetAuctionBids {
    export type RequestParams = {
      auctionId: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Items per page (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBidsResponse;
  }

  /**
   * No description
   * @tags Auctions
   * @name AuctionControllerPlaceBid
   * @summary Place a bid on an auction
   * @request POST:/api/users/auctions/{auctionId}/bid
   * @secure
   * @response `201` `void` Bid placed successfully
   * @response `400` `void` Invalid bid amount or auction not active
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Auction not found
   */
  export namespace AuctionControllerPlaceBid {
    export type RequestParams = {
      auctionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PlaceBid;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Contracts
   * @name ContractsControllerExecuteContract
   * @summary Execute contract
   * @request POST:/api/users/contracts/execute
   * @secure
   * @response `200` `ContractResult` Contract executed successfully
   * @response `400` `void` Invalid contract parameters
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Items not found or not available
   */
  export namespace ContractsControllerExecuteContract {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ExecuteContract;
    export type RequestHeaders = {};
    export type ResponseBody = ContractResult;
  }

  /**
   * No description
   * @tags Contracts
   * @name ContractsControllerPreviewContract
   * @summary Preview contract price range
   * @request GET:/api/users/contracts/preview
   * @secure
   * @response `200` `ContractPreview` Contract preview calculated successfully
   * @response `400` `void` Invalid preview parameters
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ContractsControllerPreviewContract {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Array of inventory item IDs
       * @example ["uuid1","uuid2","uuid3"]
       */
      itemIds: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractPreview;
  }

  /**
   * No description
   * @tags Contracts
   * @name ContractsControllerGetContractHistory
   * @summary Get user contract history
   * @request GET:/api/users/contracts/history
   * @secure
   * @response `200` `ContractHistory` Contract history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ContractsControllerGetContractHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default 1
       */
      page?: number;
      /**
       * Items per page
       * @default 20
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractHistory;
  }

  /**
   * @description Calculate the probability and coefficient for an upgrade before performing it
   * @tags Upgrades
   * @name UpgradeControllerCalculateProbability
   * @summary Calculate upgrade probability
   * @request POST:/api/users/upgrades/calculate-probability
   * @secure
   * @response `200` `UpgradeProbabilityResponse` Upgrade probability calculated successfully
   * @response `400` `void` Invalid input data
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Item not found
   */
  export namespace UpgradeControllerCalculateProbability {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CalculateProbability;
    export type RequestHeaders = {};
    export type ResponseBody = UpgradeProbabilityResponse;
  }

  /**
   * @description Upgrade one item to a more expensive item
   * @tags Upgrades
   * @name UpgradeControllerPerformItemUpgrade
   * @summary Perform item-to-item upgrade
   * @request POST:/api/users/upgrades/item-to-item
   * @secure
   * @response `201` `UpgradeResult` Upgrade performed successfully
   * @response `400` `void` Invalid upgrade parameters or insufficient item value
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Item not found or not owned
   */
  export namespace UpgradeControllerPerformItemUpgrade {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PerformItemUpgrade;
    export type RequestHeaders = {};
    export type ResponseBody = UpgradeResult;
  }

  /**
   * @description Get paginated list of user's upgrade history
   * @tags Upgrades
   * @name UpgradeControllerGetUpgradeHistory
   * @summary Get upgrade history
   * @request GET:/api/users/upgrades/history
   * @secure
   * @response `200` `UpgradeHistoryResponse` Upgrade history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UpgradeControllerGetUpgradeHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @min 1
       * @default 1
       * @example 1
       */
      page?: number;
      /**
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       * @example 20
       */
      perPage?: number;
      /** Number of items to take (max 100) */
      take?: number;
      /** Number of items to skip */
      skip?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpgradeHistoryResponse;
  }

  /**
   * @description Get all available items that can be targeted for upgrade from a source item
   * @tags Upgrades
   * @name UpgradeControllerGetAvailableUpgradeTargets
   * @summary Get available upgrade targets
   * @request GET:/api/users/upgrades/available-targets/{sourceItemId}
   * @secure
   * @response `200` `AvailableUpgradeTargetsResponse` Available upgrade targets retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Source item not found
   */
  export namespace UpgradeControllerGetAvailableUpgradeTargets {
    export type RequestParams = {
      sourceItemId: string;
    };
    export type RequestQuery = {
      /** Search term for item name */
      searchTerm?: string;
      /** Filter by item category */
      category?: string;
      /** Filter by item type */
      type?: string;
      /** Filter by weapon name */
      weapon?: string;
      /**
       * Page number (1-based)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Number of items per page
       * @min 1
       * @max 100
       * @default 20
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailableUpgradeTargetsResponse;
  }

  /**
 * No description
 * @tags Promocodes
 * @name PromocodeControllerActivatePromocode
 * @summary Activate a promocode
 * @request POST:/api/users/promocodes/activate
 * @secure
 * @response `200` `{
    success?: boolean,
    buffId?: string,

}` Promocode activated successfully
 * @response `400` `void` Invalid promocode or user already has active buff
 * @response `403` `void` Forbidden. User authentication required.
 * @response `404` `void` Promocode not found
*/
  export namespace PromocodeControllerActivatePromocode {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ActivatePromocode;
    export type RequestHeaders = {};
    export type ResponseBody = {
      success?: boolean;
      buffId?: string;
    };
  }

  /**
   * No description
   * @tags Promocodes
   * @name PromocodeControllerGetActivePromocodeBuff
   * @summary Get active promocode buff for current user
   * @request GET:/api/users/promocodes/active-buff
   * @secure
   * @response `200` `ActivePromocodeBuffResponse` Active promocode buff (null if no active buff)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PromocodeControllerGetActivePromocodeBuff {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ActivePromocodeBuffResponse;
  }

  /**
   * No description
   * @tags Promocodes
   * @name PromocodeControllerGetPromocodeHistory
   * @summary Get promocode usage history for current user
   * @request GET:/api/users/promocodes/history
   * @secure
   * @response `200` `PromocodeHistoryResponse` List of used promocodes
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PromocodeControllerGetPromocodeHistory {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PromocodeHistoryResponse;
  }

  /**
   * No description
   * @tags Promocodes
   * @name PromocodeControllerGetGlobalPromocodeBuff
   * @summary Get active global promocode buff
   * @request GET:/api/users/promocodes/global-buff
   * @response `200` `GlobalPromocodeBuffResponse` Active global promocode buff (null if no active buff)
   */
  export namespace PromocodeControllerGetGlobalPromocodeBuff {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GlobalPromocodeBuffResponse;
  }

  /**
   * No description
   * @tags Wheel
   * @name WheelControllerGetWheelStatus
   * @summary Get wheel status for current user
   * @request GET:/api/users/wheel/status
   * @secure
   * @response `200` `WheelStatusResponse` Wheel status including available spins and segments
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace WheelControllerGetWheelStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WheelStatusResponse;
  }

  /**
   * No description
   * @tags Wheel
   * @name WheelControllerSpinWheel
   * @summary Spin the wheel to get a promocode
   * @request POST:/api/users/wheel/spin
   * @secure
   * @response `200` `SpinWheelResponse` Wheel spun successfully
   * @response `400` `void` No spins available or active wheel promocode exists
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace WheelControllerSpinWheel {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SpinWheelResponse;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerActivateTask
   * @summary Activate specific profile task after user setup
   * @request POST:/api/users/profile-task/activate
   * @secure
   * @response `200` `void` Task activated successfully
   * @response `400` `void` Validation failed or task already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerActivateTask {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ActivateProfileTask;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerActivateUsernameTask
   * @summary Activate username in lastName task
   * @request POST:/api/users/profile-task/activate-username
   * @secure
   * @response `200` `void` Username task activated successfully
   * @response `400` `void` Validation failed or task already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerActivateUsernameTask {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerActivateBioTask
   * @summary Activate referral link in bio task
   * @request POST:/api/users/profile-task/activate-bio
   * @secure
   * @response `200` `void` Bio task activated successfully
   * @response `400` `void` Validation failed or task already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerActivateBioTask {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerGetStatus
   * @summary Get user profile task status
   * @request GET:/api/users/profile-task/status
   * @secure
   * @response `200` `ProfileTaskStatusResponse` Profile task status for both tasks
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerGetStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProfileTaskStatusResponse;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerClaimReward
   * @summary Claim daily profile task reward for specific task type
   * @request POST:/api/users/profile-task/claim-reward
   * @secure
   * @response `200` `void` Reward claimed successfully
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerClaimReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ClaimProfileTaskReward;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerClaimUsernameReward
   * @summary Claim daily username task reward
   * @request POST:/api/users/profile-task/claim-username-reward
   * @secure
   * @response `200` `void` Username task reward claimed successfully
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerClaimUsernameReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerClaimBioReward
   * @summary Claim daily bio task reward
   * @request POST:/api/users/profile-task/claim-bio-reward
   * @secure
   * @response `200` `void` Bio task reward claimed successfully
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerClaimBioReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerGetShopItems
   * @summary Get shop items with filters
   * @request GET:/api/users/shop/items
   * @response `200` `GetShopItemsResponse` List of shop items
   */
  export namespace ShopControllerGetShopItems {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number (1-based)
       * @default 1
       * @example 1
       */
      page?: number;
      /**
       * Number of items per page
       * @default 20
       * @example 20
       */
      limit?: number;
      /**
       * Filter by exact hashName (single-item lookup)
       * @example "AK-47 | Redline (Field-Tested)"
       */
      hashName?: string;
      /**
       * Filter by category
       * @example "Rifle"
       */
      category?: string;
      /**
       * Filter by weapon
       * @example "AK-47"
       */
      weapon?: string;
      /**
       * Filter by skin name (part after | in item name)
       * @example "Asiimov"
       */
      skinName?: string;
      /**
       * Filter by type
       * @example "skin"
       */
      type?: ShopControllerGetShopItemsParams1TypeEnum;
      /**
       * Filter by wear condition (for skins)
       * @example "Factory New"
       */
      wear?: ShopControllerGetShopItemsParams1WearEnum;
      /**
       * Filter by rarity
       * @example "Classified"
       */
      rarity?: string;
      /**
       * Minimum price in credits
       * @example 25000
       */
      minPrice?: number;
      /**
       * Maximum price in credits
       * @example 100000
       */
      maxPrice?: number;
      /**
       * Filter by StatTrak
       * @example true
       */
      statTrak?: boolean;
      /**
       * Sort order
       * @default "volume_desc"
       * @example "volume_desc"
       */
      sortBy?: ShopControllerGetShopItemsParams1SortByEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetShopItemsResponse;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerGetShopSkins
   * @summary Get unique skins for a weapon
   * @request GET:/api/users/shop/skins
   * @response `200` `GetShopSkinsResponse` List of unique skins
   */
  export namespace ShopControllerGetShopSkins {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Weapon name to get skins for
       * @example "AK-47"
       */
      weapon: string;
      /**
       * Skin name pattern to filter by
       * @example "Asiimov"
       */
      skinName?: string;
      /**
       * Filter by rarity name
       * @example "Covert"
       */
      rarity?: string;
      /**
       * Minimum price in rubles
       * @example 100
       */
      minPrice?: number;
      /**
       * Maximum price in rubles
       * @example 1000
       */
      maxPrice?: number;
      /** Sort by field */
      sortBy?: GetShopSkinsSortBy;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetShopSkinsResponse;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerCreatePurchaseInvoice
   * @summary Create invoice for purchasing an item from the shop
   * @request POST:/api/users/shop/create-purchase-invoice
   * @secure
   * @response `200` `CreateShopPurchaseInvoiceResponse` Invoice created successfully
   * @response `400` `void` Item not available or invalid payment provider
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Item not found
   */
  export namespace ShopControllerCreatePurchaseInvoice {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateShopPurchaseInvoice;
    export type RequestHeaders = {
      "user-agent": string;
    };
    export type ResponseBody = CreateShopPurchaseInvoiceResponse;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerGetMyShopPurchases
   * @summary Get my shop purchase history
   * @request GET:/api/users/shop/purchases
   * @secure
   * @response `200` `UserShopPurchasesResponse` List of shop purchases
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ShopControllerGetMyShopPurchases {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @example 1 */
      page?: number;
      /** @example 20 */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserShopPurchasesResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseOpenings
   * @summary Get user case opening history
   * @request GET:/api/users/case-openings
   * @secure
   * @response `200` `PaginatedCaseOpeningsResponse` Case openings retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerGetCaseOpenings {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       * @example "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCaseOpeningsResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseOpeningDetails
   * @summary Get details of a specific case opening
   * @request GET:/api/users/case-openings/{id}
   * @secure
   * @response `200` `CaseOpeningDetailsResponse` Case opening details retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerGetCaseOpeningDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseOpeningDetailsResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCases
   * @summary Get all available cases (public — no country/language filter)
   * @request GET:/api/users/cases
   * @response `200` `(CaseResponse)[]` Cases retrieved successfully
   */
  export namespace CaseControllerGetCases {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseResponse[];
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetUniversalCases
   * @summary Get universal cases without country/language restrictions (for battle creation)
   * @request GET:/api/users/cases/universal
   * @secure
   * @response `200` `(CaseResponse)[]` Universal cases retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerGetUniversalCases {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseResponse[];
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseDetails
   * @summary Get case details
   * @request GET:/api/users/cases/{id}
   * @response `200` `CaseDetailsResponse` Case details retrieved successfully
   */
  export namespace CaseControllerGetCaseDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseDetailsResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseItem
   * @summary Get case item details
   * @request GET:/api/users/cases/{caseId}/items/{hashName}
   * @response `200` `CaseItemResponse` Case item details retrieved successfully
   */
  export namespace CaseControllerGetCaseItem {
    export type RequestParams = {
      /** Case ID */
      caseId: string;
      /** Item hash name */
      hashName: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseItemResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseItemDrops
   * @summary Get the most recent players who unboxed this item from this case
   * @request GET:/api/users/cases/{caseId}/items/{hashName}/drops
   * @response `200` `CaseItemDropsResponse` Recent drops retrieved successfully
   */
  export namespace CaseControllerGetCaseItemDrops {
    export type RequestParams = {
      /** Case ID */
      caseId: string;
      /** Item hash name */
      hashName: string;
    };
    export type RequestQuery = {
      /** How many drops to return (1-50, default 10) */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseItemDropsResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerOpenCase
   * @summary Open a case (count times, defaults to 1)
   * @request POST:/api/users/cases/{id}/open
   * @secure
   * @response `200` `(OpenCaseResponse)[]` Case opened successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerOpenCase {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = OpenCaseRequest;
    export type RequestHeaders = {};
    export type ResponseBody = OpenCaseResponse[];
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetInventory
   * @summary Get user inventory with pagination
   * @request GET:/api/users/inventory
   * @secure
   * @response `200` `PaginatedInventoryResponse` Inventory retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerGetInventory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       * @example "20"
       */
      limit?: string;
      /**
       * Sort by field
       * @default "acquiredAt"
       */
      sortBy?: InventoryControllerGetInventoryParams1SortByEnum;
      /**
       * Sort order
       * @default "DESC"
       */
      sortOrder?: InventoryControllerGetInventoryParams1SortOrderEnum;
      /**
       * Filter by item statuses
       * @example ["AVAILABLE","SOLD"]
       */
      statuses?: InventoryControllerGetInventoryParams1StatusesEnum[];
      /**
       * Minimum price filter in credits
       * @example 1000
       */
      minPrice?: number;
      /**
       * Filter by item type
       * @example "skin"
       */
      type?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedInventoryResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetInventoryItemDetails
   * @summary Get details of a specific inventory item (publicly viewable)
   * @request GET:/api/users/inventory/{id}
   * @response `200` `UserInventoryItemResponse` Item details retrieved successfully
   */
  export namespace InventoryControllerGetInventoryItemDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserInventoryItemResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerSellInventoryItem
   * @summary Sell an item from inventory
   * @request POST:/api/users/inventory/{id}/sell
   * @secure
   * @response `200` `SellItemResponse` Item sold successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerSellInventoryItem {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SellItemResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerSellAllInventoryItems
   * @summary Sell all available items from inventory
   * @request POST:/api/users/inventory/sell-all
   * @secure
   * @response `200` `SellAllItemsResponse` All items sold successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerSellAllInventoryItems {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SellAllItemsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerSellInventoryItems
   * @summary Sell selected items from inventory
   * @request POST:/api/users/inventory/sell-batch
   * @secure
   * @response `200` `SellAllItemsResponse` Selected items sold successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerSellInventoryItems {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SellItems;
    export type RequestHeaders = {};
    export type ResponseBody = SellAllItemsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetRecentInventoryItems
   * @summary Get recent items from all users inventories (public)
   * @request GET:/api/users/inventory/recent
   * @response `200` `RecentItemsResponse` Recent items retrieved successfully
   */
  export namespace InventoryControllerGetRecentInventoryItems {
    export type RequestParams = {};
    export type RequestQuery = {
      limit: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RecentItemsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetTopRecentDrops
   * @summary Get top drops from the last 24 hours, sorted by price (public)
   * @request GET:/api/users/inventory/top-recent-drops
   * @response `200` `TopRecentDropsResponse` Top recent drops retrieved successfully
   */
  export namespace InventoryControllerGetTopRecentDrops {
    export type RequestParams = {};
    export type RequestQuery = {
      limit: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TopRecentDropsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerWithdrawItem
   * @summary Withdraw item from inventory to Steam
   * @request POST:/api/users/inventory/{id}/withdraw
   * @secure
   * @response `200` `WithdrawItemResponse` Trade initiated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerWithdrawItem {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = WithdrawItem;
    export type RequestHeaders = {};
    export type ResponseBody = WithdrawItemResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerCheckTradeStatus
   * @summary Check trade status for inventory item
   * @request POST:/api/users/inventory/{id}/check-trade
   * @secure
   * @response `200` `TradeStatusResponse` Trade status checked successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerCheckTradeStatus {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TradeStatusResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerUpdateTradeLink
   * @summary Update Steam trade link
   * @request PUT:/api/users/trade-link
   * @secure
   * @response `200` `UpdateTradeLinkResponse` Trade link updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerUpdateTradeLink {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateTradeLink;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateTradeLinkResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name PaymentControllerCreateInvoice
   * @summary Create payment invoice
   * @request POST:/api/users/create-invoice
   * @secure
   * @response `200` `PaymentResponse` Invoice created successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PaymentControllerCreateInvoice {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateInvoice;
    export type RequestHeaders = {
      "user-agent": string;
    };
    export type ResponseBody = PaymentResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name PaymentControllerGetPaymentSettings
   * @summary Get payment settings
   * @request GET:/api/users/payment-settings
   * @secure
   * @response `200` `PaymentSettingsResponse` Payment settings retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PaymentControllerGetPaymentSettings {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaymentSettingsResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name PaymentControllerGetPaymentProviders
   * @summary Get payment providers (filtered + ordered for current user)
   * @request GET:/api/users/payment-providers
   * @secure
   * @response `200` `PaymentProvidersResponse` OK
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PaymentControllerGetPaymentProviders {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      authorization: string;
    };
    export type ResponseBody = PaymentProvidersResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerList
   * @summary List bound Click cards
   * @request GET:/api/users/click-cards
   * @secure
   * @response `200` `ClickCardListResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClickCardListResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerBind
   * @summary Bind a card — Click sends an SMS code
   * @request POST:/api/users/click-cards
   * @secure
   * @response `200` `BindClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerBind {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BindClickCard;
    export type RequestHeaders = {};
    export type ResponseBody = BindClickCardResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerVerify
   * @summary Confirm a bound card with the SMS code
   * @request POST:/api/users/click-cards/{id}/verify
   * @secure
   * @response `200` `ClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerVerify {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = VerifyClickCard;
    export type RequestHeaders = {};
    export type ResponseBody = ClickCardResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerPay
   * @summary Charge a bound card
   * @request POST:/api/users/click-cards/{id}/pay
   * @secure
   * @response `200` `PayWithClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `409` `void` A charge for this amount is already running
   */
  export namespace ClickCardControllerPay {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PayWithClickCard;
    export type RequestHeaders = {
      "user-agent": string;
    };
    export type ResponseBody = PayWithClickCardResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerRemove
   * @summary Remove a bound card
   * @request DELETE:/api/users/click-cards/{id}
   * @secure
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerRemove {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Profile Settings
   * @name ProfileSettingsControllerUpdateAnimationSetting
   * @summary Update case opening animation setting
   * @request PUT:/api/users/animation-setting
   * @secure
   * @response `200` `UpdateAnimationSettingResponse` Animation setting updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileSettingsControllerUpdateAnimationSetting {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateAnimationSetting;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateAnimationSettingResponse;
  }

  /**
   * No description
   * @tags Profile Settings
   * @name ProfileSettingsControllerToggleNotifications
   * @summary Toggle notifications
   * @request PUT:/api/users/notifications
   * @secure
   * @response `200` `ToggleNotificationsResponse` Notifications setting updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileSettingsControllerToggleNotifications {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ToggleNotifications;
    export type RequestHeaders = {};
    export type ResponseBody = ToggleNotificationsResponse;
  }

  /**
   * No description
   * @tags Profile Settings
   * @name ProfileSettingsControllerUpdateLanguage
   * @summary Update user language preference
   * @request PUT:/api/users/language
   * @secure
   * @response `200` `UpdateLanguageResponse` Language updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileSettingsControllerUpdateLanguage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateLanguage;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateLanguageResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetDailyBonusStatus
   * @summary Get daily bonus status
   * @request GET:/api/users/daily-bonus/status
   * @secure
   * @response `200` `DailyBonusStatusResponse` Daily bonus status retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetDailyBonusStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyBonusStatusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerClaimDailyBonus
   * @summary Claim daily bonus
   * @request POST:/api/users/daily-bonus/claim
   * @secure
   * @response `200` `ClaimDailyBonusResponse` Daily bonus claimed successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerClaimDailyBonus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimDailyBonusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerCheckSubscription
   * @summary Check user subscription to all active Telegram channels and award bonuses
   * @request POST:/api/users/check-subscription
   * @secure
   * @response `204` `void` Subscription checks scheduled successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerCheckSubscription {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetSubscriptionChannels
   * @summary Get list of available subscription channels with user subscription status
   * @request GET:/api/users/subscription-channels
   * @secure
   * @response `200` `SubscriptionChannelsResponse` Subscription channels retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetSubscriptionChannels {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SubscriptionChannelsResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetComebackBonuses
   * @summary Get available comeback bonuses
   * @request GET:/api/users/comeback-bonus
   * @secure
   * @response `200` `ComebackBonusResponse` Comeback bonuses retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetComebackBonuses {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ComebackBonusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerClaimComebackBonus
   * @summary Claim a comeback bonus
   * @request POST:/api/users/comeback-bonus/{id}/claim
   * @secure
   * @response `200` `ClaimComebackBonusResponse` Comeback bonus claimed successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerClaimComebackBonus {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimComebackBonusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetReferralBonusProgress
   * @summary Get progress towards next referral milestone bonus
   * @request GET:/api/users/referral-bonus-progress
   * @secure
   * @response `200` `ReferralBonusProgressResponse` Referral bonus progress retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetReferralBonusProgress {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReferralBonusProgressResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetOnboardingConfig
   * @summary Get onboarding screen configuration (task rewards, referral bonuses, case prices)
   * @request GET:/api/users/onboarding-config
   * @secure
   * @response `200` `OnboardingConfigResponse` Onboarding configuration retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetOnboardingConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OnboardingConfigResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetBoostChannels
   * @summary Get list of boost channels with user status
   * @request GET:/api/users/boost-channels
   * @secure
   * @response `200` `BoostChannelsStatusResponse` Boost channels retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetBoostChannels {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BoostChannelsStatusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerActivateBoost
   * @summary Activate boost for a channel (after user has boosted via Telegram)
   * @request POST:/api/users/boost-channels/{channelId}/activate
   * @secure
   * @response `200` `ActivateBoostResponse` Boost activated successfully
   * @response `400` `void` Validation failed or boost already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerActivateBoost {
    export type RequestParams = {
      channelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ActivateBoostResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerClaimBoostReward
   * @summary Claim daily boost reward
   * @request POST:/api/users/boost-channels/{channelId}/claim
   * @secure
   * @response `200` `ClaimBoostRewardResponse` Boost reward claimed successfully
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerClaimBoostReward {
    export type RequestParams = {
      channelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimBoostRewardResponse;
  }

  /**
   * No description
   * @tags Chicken Reward
   * @name ChickenRewardControllerTickChickenSpawn
   * @summary Probabilistic chicken spawn tick
   * @request POST:/api/users/chicken/tick
   * @secure
   * @response `200` `ChickenTickResponse` Chicken spawn tick evaluated
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ChickenRewardControllerTickChickenSpawn {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ChickenTickResponse;
  }

  /**
   * No description
   * @tags Chicken Reward
   * @name ChickenRewardControllerClaimChickenReward
   * @summary Claim chicken tap reward
   * @request POST:/api/users/chicken/claim
   * @secure
   * @response `200` `ClaimChickenRewardResponse` Chicken reward claimed successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ChickenRewardControllerClaimChickenReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ClaimChickenReward;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimChickenRewardResponse;
  }

  /**
   * @description Resolves avatar via auth_identities: Telegram → Steam → placeholder.
   * @tags Avatar
   * @name AvatarControllerGetUserAvatar
   * @summary Get user avatar by userId
   * @request GET:/api/users/avatar/{userId}
   * @response `200` `void` User avatar image or gray placeholder
   */
  export namespace AvatarControllerGetUserAvatar {
    export type RequestParams = {
      /**
       * User UUID
       * @example "550e8400-e29b-41d4-a716-446655440000"
       */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpStatus
   * @summary Get user XP status
   * @request GET:/api/users/xp/status
   * @secure
   * @response `200` `XpStatusResponse` XP status retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpStatusResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpHistory
   * @summary Get user XP transaction history
   * @request GET:/api/users/xp/history
   * @secure
   * @response `200` `XpHistoryResponse` XP history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpHistoryResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpConfig
   * @summary Get XP configuration
   * @request GET:/api/users/xp/config
   * @secure
   * @response `200` `XpConfigResponse` XP configuration retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpConfigResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetLevelBonusesStatus
   * @summary Get level bonuses status
   * @request GET:/api/users/xp/level-bonuses
   * @secure
   * @response `200` `LevelBonusesStatusResponse` Level bonuses status retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetLevelBonusesStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LevelBonusesStatusResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerClaimLevelBonus
   * @summary Claim level bonus
   * @request POST:/api/users/xp/level-bonuses/{level}/claim
   * @secure
   * @response `200` `ClaimLevelBonusResponse` Level bonus claimed successfully
   * @response `400` `void` Bonus already claimed, forfeit, or level not reached
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerClaimLevelBonus {
    export type RequestParams = {
      /**
       * Level number to claim bonus for
       * @example 5
       */
      level: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimLevelBonusResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpLeaderboard
   * @summary Get XP leaderboard with pagination
   * @request GET:/api/users/xp/leaderboard
   * @secure
   * @response `200` `XpLeaderboardResponse` Leaderboard retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpLeaderboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page (max 100)
       * @default "20"
       * @example "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpLeaderboardResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpLeaderboardNeighbors
   * @summary Get neighboring users in XP leaderboard (3 above + current + 3 below = up to 7 users)
   * @request GET:/api/users/xp/leaderboard/neighbors
   * @secure
   * @response `200` `XpLeaderboardNeighborsResponse` Neighbors retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` User not found
   */
  export namespace XpControllerGetXpLeaderboardNeighbors {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpLeaderboardNeighborsResponse;
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerGetActiveDraws
   * @summary Get active draws with user participation status
   * @request GET:/api/draws
   * @secure
   * @response `200` `ActiveDrawsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace DrawsControllerGetActiveDraws {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ActiveDrawsResponse;
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerGetWinnersHistory
   * @summary Get draws winners history
   * @request GET:/api/draws/winners
   * @response `200` `(DrawWinner)[]`
   */
  export namespace DrawsControllerGetWinnersHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Maximum number of winners to return */
      limit?: number;
      /** Filter by draw type */
      type?: DrawsControllerGetWinnersHistoryParams1TypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DrawWinner[];
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerGetDrawParticipants
   * @summary Get draw participants with pagination
   * @request GET:/api/draws/{id}/participants
   * @response `200` `DrawParticipants`
   */
  export namespace DrawsControllerGetDrawParticipants {
    export type RequestParams = {
      /** Draw ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Items per page (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DrawParticipants;
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerBuyEntry
   * @summary Buy entry to a paid draw
   * @request POST:/api/draws/buy-entry
   * @secure
   * @response `200` `void` Successfully purchased draw entry
   * @response `400` `void` Insufficient balance, already participating, or draw is free
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` No active draw found for the specified type
   */
  export namespace DrawsControllerBuyEntry {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BuyDrawEntry;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Giveaways
   * @name GiveawaysControllerGetGiveaway
   * @summary Get giveaway details with its case
   * @request GET:/api/giveaways/{id}
   * @response `200` `GiveawayDetailsResponse`
   * @response `404` `void` Giveaway not found
   */
  export namespace GiveawaysControllerGetGiveaway {
    export type RequestParams = {
      /** Giveaway ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GiveawayDetailsResponse;
  }

  /**
   * No description
   * @tags Giveaways
   * @name GiveawaysControllerGetParticipants
   * @summary Get giveaway participants with pagination
   * @request GET:/api/giveaways/{id}/participants
   * @response `200` `GiveawayParticipantsResponse`
   */
  export namespace GiveawaysControllerGetParticipants {
    export type RequestParams = {
      /** Giveaway ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Items per page (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GiveawayParticipantsResponse;
  }

  /**
   * No description
   * @tags Giveaways
   * @name GiveawaysControllerJoin
   * @summary Join a giveaway
   * @request POST:/api/giveaways/{id}/join
   * @secure
   * @response `200` `JoinGiveawayResponse`
   * @response `400` `void` Giveaway expired or already completed
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Giveaway not found
   * @response `422` `void` Cannot participate (already participating, no trade URL, no deposit, IP/referral restriction)
   */
  export namespace GiveawaysControllerJoin {
    export type RequestParams = {
      /** Giveaway ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = JoinGiveawayResponse;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetDailyGiveaways
   * @summary Get active daily giveaways (compact — for home cards)
   * @request GET:/api/users/daily-giveaways
   * @response `200` `DailyGiveawaysResponse`
   */
  export namespace DailyGiveawayControllerGetDailyGiveaways {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawaysResponse;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetDailyGiveawayDetails
   * @summary Get one daily giveaway header (prize, case, round, my place)
   * @request GET:/api/users/daily-giveaways/{id}
   * @response `200` `DailyGiveawayDetailResponse`
   * @response `404` `void` Daily giveaway not found
   */
  export namespace DailyGiveawayControllerGetDailyGiveawayDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawayDetailResponse;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetLeaderboard
   * @summary Paginated leaderboard for the current round
   * @request GET:/api/users/daily-giveaways/{id}/leaderboard
   * @response `200` `DailyGiveawayLeaderboardPage`
   */
  export namespace DailyGiveawayControllerGetLeaderboard {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {
      page?: number;
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawayLeaderboardPage;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetWinners
   * @summary Paginated past winners
   * @request GET:/api/users/daily-giveaways/{id}/winners
   * @response `200` `DailyGiveawayWinnersPage`
   * @response `404` `void` Daily giveaway not found
   */
  export namespace DailyGiveawayControllerGetWinners {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {
      page?: number;
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawayWinnersPage;
  }

  /**
   * No description
   * @tags Referral Contest
   * @name ReferralContestControllerGetLeaderboard
   * @summary August referral contest leaderboard (top inviters by activated referrals)
   * @request GET:/api/users/referral-contest/leaderboard
   * @response `200` `ReferralContestLeaderboardResponse`
   */
  export namespace ReferralContestControllerGetLeaderboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Board entries to skip */
      offset?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReferralContestLeaderboardResponse;
  }

  /**
   * @description Receives updates from Telegram when bot is in webhook mode
   * @tags Webhooks
   * @name WebhookControllerHandleTelegramUpdate
   * @summary Telegram bot webhook
   * @request POST:/api/webhooks/telegram
   * @response `200` `void` Update processed successfully
   * @response `403` `void` Invalid secret token
   */
  export namespace WebhookControllerHandleTelegramUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      "x-telegram-bot-api-secret-token": string;
    };
    export type ResponseBody = void;
  }

  /**
   * @description Receives updates from Telegram for the support bot when in webhook mode
   * @tags Webhooks
   * @name WebhookControllerHandleSupportUpdate
   * @summary Support bot webhook
   * @request POST:/api/webhooks/support
   * @response `200` `void` Update processed successfully
   * @response `403` `void` Invalid secret token
   */
  export namespace WebhookControllerHandleSupportUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      "x-telegram-bot-api-secret-token": string;
    };
    export type ResponseBody = void;
  }

  /**
   * @description Handles Skinsback payment notifications when user completes skin deposit
   * @tags Webhooks
   * @name WebhookControllerHandleSkinsbackWebhook
   * @summary Skinsback payment webhook
   * @request POST:/api/webhooks/payment/skinsback
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleSkinsbackWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Handles NOROS P2P payment notifications when user completes payment
   * @tags Webhooks
   * @name WebhookControllerHandleNorosP2PWebhook
   * @summary NOROS P2P payment webhook
   * @request POST:/api/webhooks/payment/noros-p2p
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleNorosP2PWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Handles Wata.pro SBP transaction notifications. Status is re-fetched from API for security.
   * @tags Webhooks
   * @name WebhookControllerHandleWataproSbpWebhook
   * @summary Wata.pro SBP payment webhook
   * @request POST:/api/webhooks/payment/watapro-sbp
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleWataproSbpWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives Safon session state-change notifications. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand.
   * @tags Webhooks
   * @name WebhookControllerHandleSafonWebhook
   * @summary Safon payment webhook
   * @request POST:/api/webhooks/payment/safon
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleSafonWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives RioPay order state-change callbacks. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand. Always answers 200 — RioPay fails the order when the callback is not acknowledged.
   * @tags Webhooks
   * @name WebhookControllerHandleRiopayWebhook
   * @summary RioPay SBP payment callback
   * @request POST:/api/webhooks/payment/riopay
   * @response `200` `void` Callback acknowledged
   */
  export namespace WebhookControllerHandleRiopayWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives Uzum acquiring callbacks. The body carries no signature, so the provider re-fetches the authoritative order state via getOrderStatus before crediting. Always answers 200 — Uzum retries otherwise.
   * @tags Webhooks
   * @name WebhookControllerHandleUzumWebhook
   * @summary Uzum Checkout payment callback
   * @request POST:/api/webhooks/payment/uzum
   * @response `200` `void` Callback acknowledged
   */
  export namespace WebhookControllerHandleUzumWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives 2328.io payment notifications. The body carries an HMAC sign, but the provider still re-fetches the authoritative state via /v1/payment/info before crediting. Always answers 200 — 2328 retries up to 5 times otherwise.
   * @tags Webhooks
   * @name WebhookControllerHandle2328Webhook
   * @summary 2328.io crypto payment webhook
   * @request POST:/api/webhooks/payment/2328
   * @response `200` `void` Webhook acknowledged
   */
  export namespace WebhookControllerHandle2328Webhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives EasyPay Stripe events. The HMAC signature is verified over the raw body before anything is dispatched; an unsigned or stale event is rejected with 401 (EasyPay does not retry 4xx and raises an internal alert instead).
   * @tags Webhooks
   * @name WebhookControllerHandleEasyPayWebhook
   * @summary EasyPay (Stripe USD) payment webhook
   * @request POST:/api/webhooks/payment/easypay
   * @response `200` `void` Webhook processed
   * @response `401` `void` Invalid signature
   */
  export namespace WebhookControllerHandleEasyPayWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Click posts a urlencoded Prepare request to validate and reserve the order. The md5 sign_string is verified and a Click error-code envelope is returned.
   * @tags Webhooks
   * @name WebhookControllerHandleClickPrepare
   * @summary Click.uz SHOP API Prepare (action=0)
   * @request POST:/api/webhooks/payment/click/prepare
   * @response `200` `void` Prepare processed
   */
  export namespace WebhookControllerHandleClickPrepare {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Click posts a urlencoded Complete request confirming funds. The md5 sign_string is verified and, on success, the balance is credited via the shared payment chokepoint (idempotent under retries).
   * @tags Webhooks
   * @name WebhookControllerHandleClickComplete
   * @summary Click.uz SHOP API Complete (action=1)
   * @request POST:/api/webhooks/payment/click/complete
   * @response `200` `void` Complete processed
   */
  export namespace WebhookControllerHandleClickComplete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Realtime
   * @name RealtimeControllerGetToken
   * @summary Get Centrifugo connection token
   * @request GET:/api/users/realtime/token
   * @secure
   * @response `200` `CentrifugoTokenResponse` Token generated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RealtimeControllerGetToken {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CentrifugoTokenResponse;
  }

  /**
   * No description
   * @tags Realtime
   * @name RealtimeControllerHeartbeat
   * @summary Report current presence (online + activity)
   * @request POST:/api/users/realtime/heartbeat
   * @secure
   * @response `200` `HeartbeatResponse` Heartbeat recorded
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RealtimeControllerHeartbeat {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HeartbeatRequest;
    export type RequestHeaders = {};
    export type ResponseBody = HeartbeatResponse;
  }

  /**
   * No description
   * @tags Realtime
   * @name RealtimeControllerGetOnlineCount
   * @summary Get online users count (public)
   * @request GET:/api/users/realtime/online
   * @response `200` `OnlineCountResponse` Online count retrieved
   */
  export namespace RealtimeControllerGetOnlineCount {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OnlineCountResponse;
  }

  /**
   * @description Read-only token limited to drops_feed, online_count and game_stats channels
   * @tags Realtime
   * @name RealtimeControllerGetPublicToken
   * @summary Anonymous Centrifugo connection token (public channels only)
   * @request GET:/api/users/realtime/public-token
   * @response `200` `CentrifugoTokenResponse` Anonymous token generated
   */
  export namespace RealtimeControllerGetPublicToken {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CentrifugoTokenResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerCreateCaseBattle
   * @summary Create a new case battle
   * @request POST:/api/users/case-battles
   * @secure
   * @response `201` `CreateCaseBattleResponse` Case battle created successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerCreateCaseBattle {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCaseBattleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateCaseBattleResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetActiveCaseBattles
   * @summary Get all active (waiting) case battles
   * @request GET:/api/users/case-battles
   * @response `200` `(CaseBattleListItemResponse)[]` Active case battles retrieved successfully
   */
  export namespace CaseBattleControllerGetActiveCaseBattles {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleListItemResponse[];
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetUserActiveBattlesCount
   * @summary Get user active battles count
   * @request GET:/api/users/case-battles/me/active-count
   * @secure
   * @response `200` `UserActiveBattlesCountResponse` User active battles count retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerGetUserActiveBattlesCount {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserActiveBattlesCountResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetAllCaseBattleHistory
   * @summary Get all completed case battles history
   * @request GET:/api/users/case-battles/history/all
   * @response `200` `CaseBattleHistoryPaginatedResponse` All case battles history retrieved successfully
   */
  export namespace CaseBattleControllerGetAllCaseBattleHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Number of battles to skip */
      skip?: number;
      /** Number of battles to take */
      take?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleHistoryPaginatedResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetUserCaseBattleHistory
   * @summary Get user case battle history
   * @request GET:/api/users/case-battles/history
   * @secure
   * @response `200` `CaseBattleHistoryPaginatedResponse` Case battle history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerGetUserCaseBattleHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Number of battles to skip */
      skip?: number;
      /** Number of battles to take */
      take?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleHistoryPaginatedResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetCaseBattleDetails
   * @summary Get case battle details
   * @request GET:/api/users/case-battles/{id}
   * @response `200` `CaseBattleDetailsResponse` Case battle details retrieved successfully
   */
  export namespace CaseBattleControllerGetCaseBattleDetails {
    export type RequestParams = {
      /** Case battle ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleDetailsResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerJoinCaseBattle
   * @summary Join a case battle
   * @request POST:/api/users/case-battles/{id}/join
   * @secure
   * @response `200` `void` Successfully joined the case battle
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerJoinCaseBattle {
    export type RequestParams = {
      /** Case battle ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerLeaveCaseBattle
   * @summary Leave a case battle
   * @request POST:/api/users/case-battles/{id}/leave
   * @secure
   * @response `200` `void` Successfully left the case battle
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerLeaveCaseBattle {
    export type RequestParams = {
      /** Case battle ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerGetConfig
   * @summary Per-user Rush Mid availability (comingSoon = tease the tile, refuse entry)
   * @request GET:/api/users/rush-mid/config
   * @secure
   * @response `200` `RushMidConfigResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerGetConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidConfigResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerCreateOpenGame
   * @summary Create an open game on a side (matchMode 'bots' = solo/party practice — no stake, not listed). When the caller is in a party the ticket/mode/side come from the RATIFIED party row, not the request body — the request config only applies to a solo.
   * @request POST:/api/users/rush-mid/games
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING for a bots practice game)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerCreateOpenGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateOpenGameRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerListOpenGames
   * @summary List every public open (FORMING) game, newest first
   * @request GET:/api/users/rush-mid/games
   * @secure
   * @response `200` `OpenGamesListResponse` Open games list
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerListOpenGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OpenGamesListResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerListLiveGames
   * @summary List every live (PLAYING) match — the «Идут сейчас» spectate list, newest first
   * @request GET:/api/users/rush-mid/games/live
   * @secure
   * @response `200` `LiveGamesListResponse` Live games list
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerListLiveGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LiveGamesListResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerGetOpenGame
   * @summary One open game by id (404 once it fills, starts or closes)
   * @request GET:/api/users/rush-mid/games/{id}
   * @secure
   * @response `200` `OpenGame` Open game
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerGetOpenGame {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OpenGame;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerWatchGame
   * @summary Read-only spectator view of a live match (PLAYING/OVER; 404 while BUYING/not started or once gone)
   * @request GET:/api/users/rush-mid/games/{id}/watch
   * @secure
   * @response `200` `RushMidSpectateView` Spectator view
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerWatchGame {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSpectateView;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerJoinOpenGame
   * @summary Join an open game on a side
   * @request POST:/api/users/rush-mid/games/{id}/join
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING if the join fills the house)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerJoinOpenGame {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = JoinOpenGameRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerLeaveOpenGame
   * @summary Leave the open game (party leader takes the whole party out)
   * @request POST:/api/users/rush-mid/games/leave
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (NONE)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerLeaveOpenGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerCreateParty
   * @summary Create a party (caller becomes leader); returns the PARTY snapshot + code
   * @request POST:/api/users/rush-mid/party/create
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerCreateParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerJoinParty
   * @summary Join a party by its secret code
   * @request POST:/api/users/rush-mid/party/join
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerJoinParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyJoinRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerConfigParty
   * @summary Leader-only: set party mode/ticket/side (mode must fit the party size)
   * @request POST:/api/users/rush-mid/party/config
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerConfigParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyConfigRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerLeaveParty
   * @summary Leave the current party — individual for every role (leader hands off to the freshest survivor); frees the leaver's waiting-game seat with a refund
   * @request POST:/api/users/rush-mid/party/leave
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (NONE)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerLeaveParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerKickParty
   * @summary Leader-only: remove a member from the party (FORMING only)
   * @request POST:/api/users/rush-mid/party/kick
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerKickParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyKickRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSetPartyReady
   * @summary Toggle your own ready flag in the party (leader starts once all ready)
   * @request POST:/api/users/rush-mid/party/ready
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSetPartyReady {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyReadyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSubmitLoadout
   * @summary Submit this player loadout for a match (starts when all players are ready)
   * @request POST:/api/users/rush-mid/match/{id}/loadout
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (BUYING / PLAYING)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSubmitLoadout {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SubmitLoadoutRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSubmitAction
   * @summary Submit this player action for the current round (shoot / grenade / medkit)
   * @request POST:/api/users/rush-mid/match/{id}/action
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (current/next PLAYING round, or OVER)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSubmitAction {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SubmitActionRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerLeaveMatch
   * @summary Dismiss a FINISHED match result screen (a live match cannot be left — an absent player is auto-piloted and settles normally)
   * @request POST:/api/users/rush-mid/match/{id}/leave
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (NONE)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerLeaveMatch {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSnapshot
   * @summary Poll the user's current Rush Mid snapshot (single source of truth)
   * @request GET:/api/users/rush-mid/snapshot
   * @secure
   * @response `200` `RushMidSnapshot` Snapshot
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSnapshot {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerHistory
   * @summary Get the current user recent Rush Mid matches
   * @request GET:/api/users/rush-mid/history
   * @secure
   * @response `200` `RushMidHistoryResponse` Rush Mid history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      skip?: number;
      take?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidHistoryResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerRating
   * @summary The caller's ELO rating + top-50 leaderboard for a mode
   * @request GET:/api/users/rush-mid/rating
   * @secure
   * @response `200` `RushMidRatingResponse` Rating + leaderboard retrieved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerRating {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Team size (1/2/5); defaults to 1 */
      mode?: RushMidControllerRatingParams1ModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidRatingResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerGetSkins
   * @summary The user's saved fighter skin per side (to prefill the lobby picker)
   * @request GET:/api/users/rush-mid/skins
   * @secure
   * @response `200` `RushMidSkinsResponse` Saved skins per side
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerGetSkins {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSkinsResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSaveLobbyConfig
   * @summary Persist the solo lobby config (ticket/mode/side/matchMode) on every change, so the lobby restores it on reopen
   * @request POST:/api/users/rush-mid/lobby-config
   * @secure
   * @response `200` `void` saved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSaveLobbyConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = JoinMatchmakingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSetSkin
   * @summary Save the chosen fighter skin for one side (t / ct)
   * @request PUT:/api/users/rush-mid/skin
   * @secure
   * @response `200` `void` Skin saved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSetSkin {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetRushMidSkinRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSetWeaponSkin
   * @summary Put on (or take off) a weapon skin for one weapon key
   * @request PUT:/api/users/rush-mid/weapon-skin
   * @secure
   * @response `200` `void` Weapon skin saved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSetWeaponSkin {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetRushMidWeaponSkinRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerMatchDetail
   * @summary Full detail + replay of one of the user's past matches
   * @request GET:/api/users/rush-mid/match/{id}/detail
   * @secure
   * @response `200` `RushMidMatchDetail` Match detail retrieved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerMatchDetail {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidMatchDetail;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerReplay
   * @summary Shareable replay of any finished match (any signed-in user)
   * @request GET:/api/users/rush-mid/replay/{id}
   * @secure
   * @response `200` `RushMidReplay` Replay retrieved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerReplay {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidReplay;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerGames
   * @summary Ticket presets plus every live game (OPEN + COUNTDOWN) with its stake, seats and bullets
   * @request GET:/api/users/roulette/games
   * @secure
   * @response `200` `RouletteGames`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteGames;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerCreateGame
   * @summary Create a game with your own ticket, seats and bullets — or seat into an OPEN game with identical parameters
   * @request POST:/api/users/roulette/games
   * @secure
   * @response `201` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerCreateGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouletteCreateGameRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerJoinGame
   * @summary Join THIS specific game (debits the stake) — refused if full, started or the caller is already seated
   * @request POST:/api/users/roulette/games/{id}/join
   * @secure
   * @response `201` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerJoinGame {
    export type RequestParams = {
      /** Match (game) id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerLeaveGame
   * @summary Leave a filling lobby (refunds the stake) — refused once the house is full or the game is live
   * @request POST:/api/users/roulette/games/leave
   * @secure
   * @response `201` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerLeaveGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerState
   * @summary Poll the caller's current roulette status: none | match (lobby, countdown or live game)
   * @request GET:/api/users/roulette/state
   * @secure
   * @response `200` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerState {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerMatch
   * @summary A match snapshot — never leaks the server seed, bullet positions or event log before FINISHED/CANCELLED
   * @request GET:/api/users/roulette/matches/{id}
   * @secure
   * @response `200` `RouletteMatch`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerMatch {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteMatch;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerPull
   * @summary Pull the trigger — only the current shooter may call this
   * @request POST:/api/users/roulette/matches/{id}/pull
   * @secure
   * @response `201` `RouletteMatch`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerPull {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteMatch;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerSkip
   * @summary Skip your turn (debits the skip cost) — only the current shooter, within the per-player limit
   * @request POST:/api/users/roulette/matches/{id}/skip
   * @secure
   * @response `201` `RouletteMatch`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerSkip {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteMatch;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerHistory
   * @summary My finished/cancelled matches, newest first
   * @request GET:/api/users/roulette/history
   * @secure
   * @response `200` `RouletteHistoryResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      limit?: number;
      /** Opaque cursor from a previous page's nextCursor */
      cursor?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteHistoryResponse;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerFeed
   * @summary Global feed of every player's finished matches, newest first — headline winner + the skin they won
   * @request GET:/api/users/roulette/feed
   * @secure
   * @response `200` `RouletteFeedResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerFeed {
    export type RequestParams = {};
    export type RequestQuery = {
      limit?: number;
      /** Opaque cursor from a previous page's nextCursor */
      cursor?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteFeedResponse;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerFairness
   * @summary Provably-fair reveal — server seed, event log and bullet layouts only once FINISHED/CANCELLED
   * @request GET:/api/users/roulette/matches/{id}/fairness
   * @secure
   * @response `200` `RouletteFairness`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerFairness {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteFairness;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetRounds
   * @summary Today's active raffle rounds, one per ticket tier, ticket ASC
   * @request GET:/api/rush-raffle/rounds
   * @secure
   * @response `200` `RushRaffleRoundsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushRaffleControllerGetRounds {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleRoundsResponse;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetRoundDetail
   * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
   * @request GET:/api/rush-raffle/rounds/{id}
   * @secure
   * @response `200` `RushRaffleRoundDetail`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Round not found
   */
  export namespace RushRaffleControllerGetRoundDetail {
    export type RequestParams = {
      /** Round id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleRoundDetail;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetWinners
   * @summary Recent completed raffle rounds with a winner, last 14 days, newest first
   * @request GET:/api/rush-raffle/winners
   * @secure
   * @response `200` `RushRaffleWinnersResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushRaffleControllerGetWinners {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleWinnersResponse;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetMatchAward
   * @summary The caller's raffle ticket award for a finished Rush Mid match (null if none)
   * @request GET:/api/rush-raffle/match/{matchId}/award
   * @secure
   * @response `200` `RushRaffleMatchAward` null when the caller earned no award for this match
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushRaffleControllerGetMatchAward {
    export type RequestParams = {
      /** Match id */
      matchId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleMatchAward;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetStatus
   * @summary SHOT BAND membership status and balances
   * @request GET:/api/users/band/status
   * @secure
   * @response `200` `BandStatusResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandStatusResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetTicketPrices
   * @summary Exact SHOT BAND pass price per available payment provider
   * @request GET:/api/users/band/ticket/prices
   * @secure
   * @response `200` `BandTicketPricesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetTicketPrices {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      authorization: string;
    };
    export type ResponseBody = BandTicketPricesResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerCreateTicketInvoice
   * @summary Create a payment invoice for the SHOT BAND ticket
   * @request POST:/api/users/band/create-ticket-invoice
   * @secure
   * @response `201` `BandTicketInvoiceResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerCreateTicketInvoice {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateBandTicketInvoice;
    export type RequestHeaders = {};
    export type ResponseBody = BandTicketInvoiceResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerPayTicketWithClickCard
   * @summary Charge a bound Click card for SHOT BAND access
   * @request POST:/api/users/band/ticket/pay-with-click-card
   * @secure
   * @response `200` `PayBandTicketWithClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerPayTicketWithClickCard {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PayBandTicketWithClickCard;
    export type RequestHeaders = {};
    export type ResponseBody = PayBandTicketWithClickCardResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerClaimCashback
   * @summary Claim matured SHOT BAND cashback sparks
   * @request POST:/api/users/band/cashback/claim
   * @secure
   * @response `200` `ClaimBandCashbackResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerClaimCashback {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimBandCashbackResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetMembersPreview
   * @summary Active member count and a few freshest member ids for the home promo
   * @request GET:/api/users/band/members-preview
   * @secure
   * @response `200` `BandMembersPreviewResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetMembersPreview {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandMembersPreviewResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetFreeCases
   * @summary Free SHOT BAND case opens unlocked by the day’s wager turnover
   * @request GET:/api/users/band/free-cases
   * @secure
   * @response `200` `BandFreeCasesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetFreeCases {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandFreeCasesResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetQuests
   * @summary Today's SHOT BAND daily quests, progress and streak
   * @request GET:/api/users/band/quests
   * @secure
   * @response `200` `BandQuestsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetQuests {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandQuestsResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerClaimQuest
   * @summary Claim a completed SHOT BAND daily quest
   * @request POST:/api/users/band/quests/{questId}/claim
   * @secure
   * @response `200` `BandQuestsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerClaimQuest {
    export type RequestParams = {
      questId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandQuestsResponse;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerGetRound
   * @summary This week's knife raffle — prize, live pot, caller stats and ticket balance
   * @request GET:/api/users/band-raffle/round
   * @secure
   * @response `200` `BandRaffleRoundResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaffleControllerGetRound {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaffleRoundResponse;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerInvest
   * @summary Invest raffle tickets into the round — irreversible, members only
   * @request POST:/api/users/band-raffle/round/{id}/invest
   * @secure
   * @response `200` `InvestBandRaffleTicketsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Round not found
   */
  export namespace BandRaffleControllerInvest {
    export type RequestParams = {
      /** Round id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = InvestBandRaffleTickets;
    export type RequestHeaders = {};
    export type ResponseBody = InvestBandRaffleTicketsResponse;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerGetRoundDetail
   * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
   * @request GET:/api/users/band-raffle/round/{id}
   * @secure
   * @response `200` `BandRaffleRoundDetail`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Round not found
   */
  export namespace BandRaffleControllerGetRoundDetail {
    export type RequestParams = {
      /** Round id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaffleRoundDetail;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerGetWinners
   * @summary Completed weekly rounds with a winner, last 30 days, newest first
   * @request GET:/api/users/band-raffle/winners
   * @secure
   * @response `200` `BandRaffleWinnersResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaffleControllerGetWinners {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaffleWinnersResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandRaceControllerGetDetails
   * @summary Today's SHOT BAND wager race: prize, timer, my place
   * @request GET:/api/users/band/race/details
   * @secure
   * @response `200` `BandRaceDetailsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaceControllerGetDetails {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaceDetailsResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandRaceControllerGetLeaderboard
   * @summary Today's race leaderboard page
   * @request GET:/api/users/band/race/leaderboard
   * @secure
   * @response `200` `BandRaceLeaderboardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaceControllerGetLeaderboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @default 1 */
      page?: number;
      /** @default 10 */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaceLeaderboardResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandRaceControllerGetWinners
   * @summary Past race winners, newest first
   * @request GET:/api/users/band/race/winners
   * @secure
   * @response `200` `BandRaceWinnersResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaceControllerGetWinners {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @default 1 */
      page?: number;
      /** @default 10 */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaceWinnersResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetCatalog
   * @summary Full achievement catalog with viewer-aware redaction of hidden rules. Response carries all locales — client picks display lang.
   * @request GET:/api/achievements/catalog
   * @response `200` `CatalogResponse`
   */
  export namespace AchievementsControllerGetCatalog {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CatalogResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetMy
   * @summary Authenticated user's merged catalog + unlock + progress view
   * @request GET:/api/users/me/achievements
   * @secure
   * @response `200` `MergedAchievementsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerGetMy {
    export type RequestParams = {};
    export type RequestQuery = {
      onlyUnlocked?: boolean;
      hideLockedSecrets?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MergedAchievementsResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetClaimableRewards
   * @summary Sum of rewards for the user's unlocked-but-uncredited achievements (snapshot=0), plus whether they have a payment in the last 30 days and whether the claim endpoint may be called.
   * @request GET:/api/achievements/claimable-rewards
   * @secure
   * @response `200` `ClaimableAchievementRewards`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerGetClaimableRewards {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimableAchievementRewards;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerClaimRewards
   * @summary Credit the user's unlocked-but-uncredited achievements (snapshot=0). All-time deposits must cover 100% of the claimable bonus (all-or-nothing). Idempotent — re-claim grants nothing.
   * @request POST:/api/achievements/claim-rewards
   * @secure
   * @response `200` `ClaimAchievementRewardsResult`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerClaimRewards {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimAchievementRewardsResult;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetForUser
   * @summary Public profile view of another user's achievements; hidden+target-locked redact
   * @request GET:/api/users/{userId}/achievements
   * @response `200` `MergedAchievementsResponse`
   */
  export namespace AchievementsControllerGetForUser {
    export type RequestParams = {
      userId: string;
    };
    export type RequestQuery = {
      onlyUnlocked?: boolean;
      hideLockedSecrets?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MergedAchievementsResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetStats
   * @summary Per-key unlock count (Redis-cached 60s) + active-user denominator (Redis-cached 1h). Anon sees 404 for hidden rules.
   * @request GET:/api/achievements/{key}/stats
   * @response `200` `AchievementStats`
   */
  export namespace AchievementsControllerGetStats {
    export type RequestParams = {
      key: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AchievementStats;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetRecentReceivers
   * @summary Newest 10 unlocks for a key plus totalReceivers, both served from the Redis cache maintained by the 30-min refresh job. Anti-scrape: requires auth.
   * @request GET:/api/achievements/{key}/recent-receivers
   * @secure
   * @response `200` `RecentReceiversResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerGetRecentReceivers {
    export type RequestParams = {
      key: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RecentReceiversResponse;
  }

  /**
   * No description
   * @tags Survey
   * @name SurveyControllerSubmit
   * @summary Submit the product survey. One response per user — 409 if already submitted.
   * @request POST:/api/survey/response
   * @secure
   * @response `201` `SubmitSurveyResult`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SurveyControllerSubmit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SubmitSurveyResponse;
    export type RequestHeaders = {};
    export type ResponseBody = SubmitSurveyResult;
  }

  /**
   * No description
   * @tags Survey
   * @name SurveyControllerSaveDraft
   * @summary Upsert partial survey progress. 409 if the survey is already submitted.
   * @request PUT:/api/survey/draft
   * @secure
   * @response `200` `SaveSurveyDraftResult`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SurveyControllerSaveDraft {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SaveSurveyDraft;
    export type RequestHeaders = {};
    export type ResponseBody = SaveSurveyDraftResult;
  }

  /**
   * No description
   * @tags Survey
   * @name SurveyControllerMyStatus
   * @summary Whether the authenticated user has already submitted a survey (slug, default 'default').
   * @request GET:/api/survey/me/status
   * @secure
   * @response `200` `SurveyStatus`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SurveyControllerMyStatus {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which survey to check. Omit for the original 'default' survey. */
      slug?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SurveyStatus;
  }

  /**
 * No description
 * @tags Device Signal
 * @name DeviceSignalControllerReport
 * @summary Report device fingerprint signal
 * @request POST:/api/users/device-signal
 * @secure
 * @response `200` `{
    success?: boolean,

}` Signal recorded
 * @response `403` `void` Forbidden. User authentication required.
*/
  export namespace DeviceSignalControllerReport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReportDeviceSignal;
    export type RequestHeaders = {};
    export type ResponseBody = {
      success?: boolean;
    };
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerTma
   * @summary Authenticate via Telegram Mini App initData. Idempotent — safe to call on every cold open.
   * @request POST:/api/auth/tma
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerTma {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TmaAuth;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerTelegramWidget
   * @summary Authenticate via Telegram Login Widget (browser web flow)
   * @request POST:/api/auth/telegram-widget
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerTelegramWidget {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TelegramLogin;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerLogout
   * @summary Destroy session and clear cookie
   * @request POST:/api/auth/logout
   * @response `200` `void`
   */
  export namespace AuthControllerLogout {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerWebHandoffInit
   * @summary Issue a single-use opaque token (Redis, TTL 60s) bound to the caller. Used by the TMA "Open in browser" flow to hand auth off to the web shell without putting initData into a URL hash.
   * @request POST:/api/auth/web-handoff/init
   * @secure
   * @response `200` `WebHandoffInitResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AuthControllerWebHandoffInit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WebHandoffInitResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerWebHandoffRedeem
   * @summary Atomically GETDEL the handoff token, create a session cookie, return the session principal.
   * @request POST:/api/auth/web-handoff/redeem
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerWebHandoffRedeem {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = WebHandoffRedeem;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerMe
   * @summary Return current session principal, or 401 if no valid cookie
   * @request GET:/api/auth/me
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerMe {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerInitSteamLink
   * @summary Start Steam linking flow — returns redirect URL
   * @request POST:/api/users/link/steam/init
   * @secure
   * @response `200` `SteamLinkInitResponse` Redirect URL for Steam OpenID
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SteamAuthControllerInitSteamLink {
    export type RequestParams = {};
    export type RequestQuery = {
      source: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SteamLinkInitResponse;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerLoginSteam
   * @summary Redirect to Steam OpenID for login
   * @request GET:/api/users/login/steam
   * @response `200` `void`
   */
  export namespace SteamAuthControllerLoginSteam {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerSteamCallback
   * @summary Steam OpenID callback (both link and login flows)
   * @request GET:/api/users/auth/steam/callback
   * @response `200` `void`
   */
  export namespace SteamAuthControllerSteamCallback {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerConnectSteamToTelegram
   * @summary Connect pending Steam to existing Telegram account
   * @request POST:/api/users/connect/steam
   * @response `200` `AuthSessionResponse` Steam linked, session created
   */
  export namespace SteamAuthControllerConnectSteamToTelegram {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SteamConnect;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerRegisterWithSteam
   * @summary Register new account with pending Steam data
   * @request POST:/api/users/register/steam
   * @response `200` `AuthSessionResponse` New account created, session created
   */
  export namespace SteamAuthControllerRegisterWithSteam {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SteamRegister;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Telegram Link
   * @name TelegramLinkControllerLinkTelegram
   * @summary Link Telegram account to existing user
   * @request POST:/api/users/link/telegram
   * @secure
   * @response `200` `LinkTelegramResponse` Telegram linked successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace TelegramLinkControllerLinkTelegram {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TelegramLogin;
    export type RequestHeaders = {};
    export type ResponseBody = LinkTelegramResponse;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerGetSummary
   * @summary Whether support has an unread answer for the caller
   * @request GET:/api/users/support/summary
   * @secure
   * @response `200` `SupportUserSummary`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerGetSummary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserSummary;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerGetMessages
   * @summary The caller’s own conversation, oldest first, paging backwards in time
   * @request GET:/api/users/support/messages
   * @secure
   * @response `200` `SupportUserMessageList`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerGetMessages {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Opaque cursor from a previous page; walks backwards in time */
      before?: string;
      /**
       * @min 1
       * @max 100
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserMessageList;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerSendMessage
   * @summary Write to support; the first message opens the conversation
   * @request POST:/api/users/support/messages
   * @secure
   * @response `201` `SupportUserMessage`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerSendMessage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SendSupportMessage;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserMessage;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerSendAttachment
   * @summary Attach a file to the conversation. Global upload limit is 5 MB.
   * @request POST:/api/users/support/attachments
   * @secure
   * @response `201` `SupportUserMessage`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerSendAttachment {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserMessage;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerMarkRead
   * @summary Mark support answers as read and clear the badge
   * @request POST:/api/users/support/read
   * @secure
   * @response `200` `SupportUserSummary`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerMarkRead {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserSummary;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerGetAttachmentContent
   * @summary Stream one attachment from the caller’s own conversation
   * @request GET:/api/users/support/attachments/{id}/content
   * @secure
   * @response `200` `void` The attachment content
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerGetAttachmentContent {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data.data;
    });
  };
}

/**
 * @title SHOT User API
 * @version 1.0
 * @contact
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Public
     * @name PublicControllerGetGameStats
     * @summary Get global game statistics counters
     * @request GET:/api/public/game-stats
     * @response `200` `GameStatsResponse` Game statistics
     */
    publicControllerGetGameStats: (params: RequestParams = {}) =>
      this.request<GameStatsResponse, any>({
        path: `/api/public/game-stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns an item image with a background colored according to its rarity
     *
     * @tags Public
     * @name PublicControllerGetItemImage
     * @summary Get item image with rarity background
     * @request GET:/api/public/item-image
     * @response `200` `File` Item image with rarity background
     * @response `400` `void` Invalid parameters or image processing failed
     * @response `404` `void` Item not found
     */
    publicControllerGetItemImage: (
      query: PublicControllerGetItemImageParams,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/api/public/item-image`,
        method: "GET",
        query: query,
        format: "blob",
        ...params,
      }),

    /**
     * @description Returns a case image with gray background in JPEG format
     *
     * @tags Public
     * @name PublicControllerGetCaseImage
     * @summary Get case image by ID
     * @request GET:/api/public/case-image/{caseId}
     * @response `200` `File` Case image with gray background in JPEG format
     * @response `400` `void` Invalid parameters or image processing failed
     * @response `404` `void` Case not found
     */
    publicControllerGetCaseImage: (
      { caseId, ...query }: PublicControllerGetCaseImageParams,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/api/public/case-image/${caseId}`,
        method: "GET",
        query: query,
        format: "blob",
        ...params,
      }),

    /**
     * @description Proxies broadcast images from S3 storage
     *
     * @tags Public
     * @name PublicControllerGetBroadcastImage
     * @summary Get broadcast image
     * @request GET:/api/public/broadcast-images/{filename}
     * @response `200` `File` Broadcast image
     * @response `404` `void` Image not found
     */
    publicControllerGetBroadcastImage: (
      filename: string,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/api/public/broadcast-images/${filename}`,
        method: "GET",
        format: "blob",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerById
     * @summary Get partner details by ID (public)
     * @request GET:/api/public/partners/{id}
     * @response `200` `Partner` Partner details
     * @response `404` `void` Partner not found
     */
    partnerPublicControllerGetPartnerById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<Partner, void>({
        path: `/api/public/partners/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerTransferInfo
     * @summary Get the balance and conversion rate for a partner balance transfer (public)
     * @request GET:/api/public/partners/{id}/transfer-info
     * @response `200` `PartnerTransferInfo` Transfer info
     * @response `404` `void` Partner not found
     */
    partnerPublicControllerGetPartnerTransferInfo: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PartnerTransferInfo, void>({
        path: `/api/public/partners/${id}/transfer-info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerTransferToBalance
     * @summary Transfer partner balance to the account balance of the partner owner (public)
     * @request POST:/api/public/partners/{id}/transfer-to-balance
     * @response `200` `TransferPartnerBalanceResponse` Transfer completed
     * @response `400` `void` Invalid amount
     * @response `402` `void` Transfer amount exceeds the partner balance
     * @response `404` `void` Partner not found
     * @response `422` `void` Partner is inactive
     */
    partnerPublicControllerTransferToBalance: (
      id: string,
      data: TransferPartnerBalance,
      params: RequestParams = {},
    ) =>
      this.request<TransferPartnerBalanceResponse, void>({
        path: `/api/public/partners/${id}/transfer-to-balance`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerDailyStats
     * @summary Get partner daily statistics (public)
     * @request GET:/api/public/partners/{id}/daily-stats
     * @response `200` `ListPartnerDailyStatsResponse` Daily statistics with pagination
     */
    partnerPublicControllerGetPartnerDailyStats: (
      { id, ...query }: PartnerPublicControllerGetPartnerDailyStatsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPartnerDailyStatsResponse, any>({
        path: `/api/public/partners/${id}/daily-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerListPartnerWithdrawals
     * @summary Get partner withdrawals and deposits (public)
     * @request GET:/api/public/partners/{id}/withdrawals
     * @response `200` `ListPartnerWithdrawalsResponse` Withdrawals list
     */
    partnerPublicControllerListPartnerWithdrawals: (
      { id, ...query }: PartnerPublicControllerListPartnerWithdrawalsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPartnerWithdrawalsResponse, any>({
        path: `/api/public/partners/${id}/withdrawals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerTransactions
     * @summary Get partner transactions with pagination and date filters (public)
     * @request GET:/api/public/partners/{id}/transactions
     * @response `200` `ListPartnerTransactionsResponse` Transactions list with pagination
     * @response `404` `void` Partner not found
     */
    partnerPublicControllerGetPartnerTransactions: (
      { id, ...query }: PartnerPublicControllerGetPartnerTransactionsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPartnerTransactionsResponse, void>({
        path: `/api/public/partners/${id}/transactions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Redirect
     * @name RedirectControllerRedirect
     * @summary Redirect to Telegram bot/app with tracking params
     * @request GET:/api/redirect
     * @response `200` `void`
     */
    redirectControllerRedirect: (
      query: RedirectControllerRedirectParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/redirect`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Landing
     * @name LandingControllerGenerateStartParam
     * @summary Generate compressed start param for Telegram deep link
     * @request POST:/api/landing/start-param
     * @response `201` `void`
     */
    landingControllerGenerateStartParam: (
      data: StartParam,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/landing/start-param`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public
     * @name PublicConfigControllerGetConfig
     * @summary Get public application config
     * @request GET:/api/public/config
     * @response `200` `PublicConfigResponse`
     */
    publicConfigControllerGetConfig: (params: RequestParams = {}) =>
      this.request<PublicConfigResponse, any>({
        path: `/api/public/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Issues a 302 from our origin so the Referer header matches our domain when the browser navigates to wata.pro.
     *
     * @tags Payment
     * @name WataproRedirectControllerRedirect
     * @summary Redirect to wata.pro hosted payment page
     * @request GET:/api/payment/watapro-sbp/redirect/{invoiceId}
     * @response `200` `void`
     */
    wataproRedirectControllerRedirect: (
      invoiceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/payment/watapro-sbp/redirect/${invoiceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerCheck
     * @summary Basic health check
     * @request GET:/api/health
     * @response `200` `BasicHealth` Service is healthy
     */
    healthControllerCheck: (params: RequestParams = {}) =>
      this.request<BasicHealth, any>({
        path: `/api/health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerReadiness
     * @summary Readiness check with dependencies
     * @request GET:/api/health/ready
     * @response `200` `ReadinessCheck` Service is ready
     * @response `503` `void` Service is not ready
     */
    healthControllerReadiness: (params: RequestParams = {}) =>
      this.request<ReadinessCheck, void>({
        path: `/api/health/ready`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerLiveness
     * @summary Liveness check
     * @request GET:/api/health/live
     * @response `200` `HealthCheck` Service is alive
     */
    healthControllerLiveness: (params: RequestParams = {}) =>
      this.request<HealthCheck, any>({
        path: `/api/health/live`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerRegister
     * @summary Register a new user (TMA initData auth)
     * @request POST:/api/users/register
     * @secure
     * @response `201` `RegisterResponse` User successfully registered
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerRegister: (data: RegisterUser, params: RequestParams = {}) =>
      this.request<RegisterResponse, void>({
        path: `/api/users/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetProfile
     * @summary Get user profile information
     * @request GET:/api/users/profile
     * @secure
     * @response `200` `UserProfileResponse` User profile retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerGetProfile: (params: RequestParams = {}) =>
      this.request<UserProfileResponse, void>({
        path: `/api/users/profile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetProfileStats
     * @summary Get user profile statistics (own or public)
     * @request GET:/api/users/profile/stats
     * @response `200` `ProfileStatsResponse` User profile statistics retrieved successfully
     */
    userControllerGetProfileStats: (
      query: UserControllerGetProfileStatsParams,
      params: RequestParams = {},
    ) =>
      this.request<ProfileStatsResponse, any>({
        path: `/api/users/profile/stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetReferrals
     * @summary Get paginated list of referred users
     * @request GET:/api/users/referrals
     * @secure
     * @response `200` `PaginatedReferralsResponse` Referrals retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerGetReferrals: (
      query: UserControllerGetReferralsParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReferralsResponse, void>({
        path: `/api/users/referrals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetReferralStats
     * @summary Get referral statistics (total referrals, earned credits, bonus progress)
     * @request GET:/api/users/referral-stats
     * @secure
     * @response `200` `ReferralStatsResponse` Referral statistics retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerGetReferralStats: (params: RequestParams = {}) =>
      this.request<ReferralStatsResponse, void>({
        path: `/api/users/referral-stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerSavePreparedInlineMessage
     * @summary Save prepared inline message for sharing
     * @request POST:/api/users/save-prepared-inline-message
     * @secure
     * @response `200` `SavePreparedInlineMessageResponse` Prepared inline message saved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerSavePreparedInlineMessage: (
      data: SavePreparedInlineMessage,
      params: RequestParams = {},
    ) =>
      this.request<SavePreparedInlineMessageResponse, void>({
        path: `/api/users/save-prepared-inline-message`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerHealthCheck
     * @summary Health check endpoint
     * @request GET:/api/users/health
     * @response `200` `HealthCheckResponse` Service is healthy
     */
    userControllerHealthCheck: (params: RequestParams = {}) =>
      this.request<HealthCheckResponse, any>({
        path: `/api/users/health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name HomeControllerGetHome
     * @summary Всё содержимое главного экрана одним запросом
     * @request GET:/api/users/home
     * @secure
     * @response `200` `HomeSnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeControllerGetHome: (params: RequestParams = {}) =>
      this.request<HomeSnapshot, void>({
        path: `/api/users/home`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auctions
     * @name AuctionControllerGetActiveAuctions
     * @summary Get auctions with optional status filter
     * @request GET:/api/users/auctions
     * @response `200` `ActiveAuctionsResponse` List of auctions
     */
    auctionControllerGetActiveAuctions: (
      query: AuctionControllerGetActiveAuctionsParams,
      params: RequestParams = {},
    ) =>
      this.request<ActiveAuctionsResponse, any>({
        path: `/api/users/auctions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auctions
     * @name AuctionControllerGetAuctionDetails
     * @summary Get auction details by ID
     * @request GET:/api/users/auctions/{auctionId}
     * @response `200` `AuctionDetailsResponse` Auction details including bids
     * @response `404` `void` Auction not found
     */
    auctionControllerGetAuctionDetails: (
      auctionId: string,
      params: RequestParams = {},
    ) =>
      this.request<AuctionDetailsResponse, void>({
        path: `/api/users/auctions/${auctionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auctions
     * @name AuctionControllerGetAuctionBids
     * @summary Get paginated bids for an auction
     * @request GET:/api/users/auctions/{auctionId}/bids
     * @response `200` `PaginatedBidsResponse` Paginated list of bids
     * @response `404` `void` Auction not found
     */
    auctionControllerGetAuctionBids: (
      { auctionId, ...query }: AuctionControllerGetAuctionBidsParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBidsResponse, void>({
        path: `/api/users/auctions/${auctionId}/bids`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auctions
     * @name AuctionControllerPlaceBid
     * @summary Place a bid on an auction
     * @request POST:/api/users/auctions/{auctionId}/bid
     * @secure
     * @response `201` `void` Bid placed successfully
     * @response `400` `void` Invalid bid amount or auction not active
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Auction not found
     */
    auctionControllerPlaceBid: (
      auctionId: string,
      data: PlaceBid,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/auctions/${auctionId}/bid`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name ContractsControllerExecuteContract
     * @summary Execute contract
     * @request POST:/api/users/contracts/execute
     * @secure
     * @response `200` `ContractResult` Contract executed successfully
     * @response `400` `void` Invalid contract parameters
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Items not found or not available
     */
    contractsControllerExecuteContract: (
      data: ExecuteContract,
      params: RequestParams = {},
    ) =>
      this.request<ContractResult, void>({
        path: `/api/users/contracts/execute`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name ContractsControllerPreviewContract
     * @summary Preview contract price range
     * @request GET:/api/users/contracts/preview
     * @secure
     * @response `200` `ContractPreview` Contract preview calculated successfully
     * @response `400` `void` Invalid preview parameters
     * @response `403` `void` Forbidden. User authentication required.
     */
    contractsControllerPreviewContract: (
      query: ContractsControllerPreviewContractParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractPreview, void>({
        path: `/api/users/contracts/preview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name ContractsControllerGetContractHistory
     * @summary Get user contract history
     * @request GET:/api/users/contracts/history
     * @secure
     * @response `200` `ContractHistory` Contract history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    contractsControllerGetContractHistory: (
      query: ContractsControllerGetContractHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractHistory, void>({
        path: `/api/users/contracts/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Calculate the probability and coefficient for an upgrade before performing it
     *
     * @tags Upgrades
     * @name UpgradeControllerCalculateProbability
     * @summary Calculate upgrade probability
     * @request POST:/api/users/upgrades/calculate-probability
     * @secure
     * @response `200` `UpgradeProbabilityResponse` Upgrade probability calculated successfully
     * @response `400` `void` Invalid input data
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Item not found
     */
    upgradeControllerCalculateProbability: (
      data: CalculateProbability,
      params: RequestParams = {},
    ) =>
      this.request<UpgradeProbabilityResponse, void>({
        path: `/api/users/upgrades/calculate-probability`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Upgrade one item to a more expensive item
     *
     * @tags Upgrades
     * @name UpgradeControllerPerformItemUpgrade
     * @summary Perform item-to-item upgrade
     * @request POST:/api/users/upgrades/item-to-item
     * @secure
     * @response `201` `UpgradeResult` Upgrade performed successfully
     * @response `400` `void` Invalid upgrade parameters or insufficient item value
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Item not found or not owned
     */
    upgradeControllerPerformItemUpgrade: (
      data: PerformItemUpgrade,
      params: RequestParams = {},
    ) =>
      this.request<UpgradeResult, void>({
        path: `/api/users/upgrades/item-to-item`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get paginated list of user's upgrade history
     *
     * @tags Upgrades
     * @name UpgradeControllerGetUpgradeHistory
     * @summary Get upgrade history
     * @request GET:/api/users/upgrades/history
     * @secure
     * @response `200` `UpgradeHistoryResponse` Upgrade history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    upgradeControllerGetUpgradeHistory: (
      query: UpgradeControllerGetUpgradeHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<UpgradeHistoryResponse, void>({
        path: `/api/users/upgrades/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all available items that can be targeted for upgrade from a source item
     *
     * @tags Upgrades
     * @name UpgradeControllerGetAvailableUpgradeTargets
     * @summary Get available upgrade targets
     * @request GET:/api/users/upgrades/available-targets/{sourceItemId}
     * @secure
     * @response `200` `AvailableUpgradeTargetsResponse` Available upgrade targets retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Source item not found
     */
    upgradeControllerGetAvailableUpgradeTargets: (
      {
        sourceItemId,
        ...query
      }: UpgradeControllerGetAvailableUpgradeTargetsParams,
      params: RequestParams = {},
    ) =>
      this.request<AvailableUpgradeTargetsResponse, void>({
        path: `/api/users/upgrades/available-targets/${sourceItemId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Promocodes
 * @name PromocodeControllerActivatePromocode
 * @summary Activate a promocode
 * @request POST:/api/users/promocodes/activate
 * @secure
 * @response `200` `{
    success?: boolean,
    buffId?: string,

}` Promocode activated successfully
 * @response `400` `void` Invalid promocode or user already has active buff
 * @response `403` `void` Forbidden. User authentication required.
 * @response `404` `void` Promocode not found
 */
    promocodeControllerActivatePromocode: (
      data: ActivatePromocode,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          buffId?: string;
        },
        void
      >({
        path: `/api/users/promocodes/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promocodes
     * @name PromocodeControllerGetActivePromocodeBuff
     * @summary Get active promocode buff for current user
     * @request GET:/api/users/promocodes/active-buff
     * @secure
     * @response `200` `ActivePromocodeBuffResponse` Active promocode buff (null if no active buff)
     * @response `403` `void` Forbidden. User authentication required.
     */
    promocodeControllerGetActivePromocodeBuff: (params: RequestParams = {}) =>
      this.request<ActivePromocodeBuffResponse, void>({
        path: `/api/users/promocodes/active-buff`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promocodes
     * @name PromocodeControllerGetPromocodeHistory
     * @summary Get promocode usage history for current user
     * @request GET:/api/users/promocodes/history
     * @secure
     * @response `200` `PromocodeHistoryResponse` List of used promocodes
     * @response `403` `void` Forbidden. User authentication required.
     */
    promocodeControllerGetPromocodeHistory: (params: RequestParams = {}) =>
      this.request<PromocodeHistoryResponse, void>({
        path: `/api/users/promocodes/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promocodes
     * @name PromocodeControllerGetGlobalPromocodeBuff
     * @summary Get active global promocode buff
     * @request GET:/api/users/promocodes/global-buff
     * @response `200` `GlobalPromocodeBuffResponse` Active global promocode buff (null if no active buff)
     */
    promocodeControllerGetGlobalPromocodeBuff: (params: RequestParams = {}) =>
      this.request<GlobalPromocodeBuffResponse, any>({
        path: `/api/users/promocodes/global-buff`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wheel
     * @name WheelControllerGetWheelStatus
     * @summary Get wheel status for current user
     * @request GET:/api/users/wheel/status
     * @secure
     * @response `200` `WheelStatusResponse` Wheel status including available spins and segments
     * @response `403` `void` Forbidden. User authentication required.
     */
    wheelControllerGetWheelStatus: (params: RequestParams = {}) =>
      this.request<WheelStatusResponse, void>({
        path: `/api/users/wheel/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wheel
     * @name WheelControllerSpinWheel
     * @summary Spin the wheel to get a promocode
     * @request POST:/api/users/wheel/spin
     * @secure
     * @response `200` `SpinWheelResponse` Wheel spun successfully
     * @response `400` `void` No spins available or active wheel promocode exists
     * @response `403` `void` Forbidden. User authentication required.
     */
    wheelControllerSpinWheel: (params: RequestParams = {}) =>
      this.request<SpinWheelResponse, void>({
        path: `/api/users/wheel/spin`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerActivateTask
     * @summary Activate specific profile task after user setup
     * @request POST:/api/users/profile-task/activate
     * @secure
     * @response `200` `void` Task activated successfully
     * @response `400` `void` Validation failed or task already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerActivateTask: (
      data: ActivateProfileTask,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/profile-task/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerActivateUsernameTask
     * @summary Activate username in lastName task
     * @request POST:/api/users/profile-task/activate-username
     * @secure
     * @response `200` `void` Username task activated successfully
     * @response `400` `void` Validation failed or task already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerActivateUsernameTask: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/activate-username`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerActivateBioTask
     * @summary Activate referral link in bio task
     * @request POST:/api/users/profile-task/activate-bio
     * @secure
     * @response `200` `void` Bio task activated successfully
     * @response `400` `void` Validation failed or task already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerActivateBioTask: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/activate-bio`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerGetStatus
     * @summary Get user profile task status
     * @request GET:/api/users/profile-task/status
     * @secure
     * @response `200` `ProfileTaskStatusResponse` Profile task status for both tasks
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerGetStatus: (params: RequestParams = {}) =>
      this.request<ProfileTaskStatusResponse, void>({
        path: `/api/users/profile-task/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerClaimReward
     * @summary Claim daily profile task reward for specific task type
     * @request POST:/api/users/profile-task/claim-reward
     * @secure
     * @response `200` `void` Reward claimed successfully
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerClaimReward: (
      data: ClaimProfileTaskReward,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/profile-task/claim-reward`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerClaimUsernameReward
     * @summary Claim daily username task reward
     * @request POST:/api/users/profile-task/claim-username-reward
     * @secure
     * @response `200` `void` Username task reward claimed successfully
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerClaimUsernameReward: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/claim-username-reward`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerClaimBioReward
     * @summary Claim daily bio task reward
     * @request POST:/api/users/profile-task/claim-bio-reward
     * @secure
     * @response `200` `void` Bio task reward claimed successfully
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerClaimBioReward: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/claim-bio-reward`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerGetShopItems
     * @summary Get shop items with filters
     * @request GET:/api/users/shop/items
     * @response `200` `GetShopItemsResponse` List of shop items
     */
    shopControllerGetShopItems: (
      query: ShopControllerGetShopItemsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetShopItemsResponse, any>({
        path: `/api/users/shop/items`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerGetShopSkins
     * @summary Get unique skins for a weapon
     * @request GET:/api/users/shop/skins
     * @response `200` `GetShopSkinsResponse` List of unique skins
     */
    shopControllerGetShopSkins: (
      query: ShopControllerGetShopSkinsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetShopSkinsResponse, any>({
        path: `/api/users/shop/skins`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerCreatePurchaseInvoice
     * @summary Create invoice for purchasing an item from the shop
     * @request POST:/api/users/shop/create-purchase-invoice
     * @secure
     * @response `200` `CreateShopPurchaseInvoiceResponse` Invoice created successfully
     * @response `400` `void` Item not available or invalid payment provider
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Item not found
     */
    shopControllerCreatePurchaseInvoice: (
      data: CreateShopPurchaseInvoice,
      params: RequestParams = {},
    ) =>
      this.request<CreateShopPurchaseInvoiceResponse, void>({
        path: `/api/users/shop/create-purchase-invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerGetMyShopPurchases
     * @summary Get my shop purchase history
     * @request GET:/api/users/shop/purchases
     * @secure
     * @response `200` `UserShopPurchasesResponse` List of shop purchases
     * @response `403` `void` Forbidden. User authentication required.
     */
    shopControllerGetMyShopPurchases: (
      query: ShopControllerGetMyShopPurchasesParams,
      params: RequestParams = {},
    ) =>
      this.request<UserShopPurchasesResponse, void>({
        path: `/api/users/shop/purchases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseOpenings
     * @summary Get user case opening history
     * @request GET:/api/users/case-openings
     * @secure
     * @response `200` `PaginatedCaseOpeningsResponse` Case openings retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerGetCaseOpenings: (
      query: CaseControllerGetCaseOpeningsParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCaseOpeningsResponse, void>({
        path: `/api/users/case-openings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseOpeningDetails
     * @summary Get details of a specific case opening
     * @request GET:/api/users/case-openings/{id}
     * @secure
     * @response `200` `CaseOpeningDetailsResponse` Case opening details retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerGetCaseOpeningDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CaseOpeningDetailsResponse, void>({
        path: `/api/users/case-openings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCases
     * @summary Get all available cases (public — no country/language filter)
     * @request GET:/api/users/cases
     * @response `200` `(CaseResponse)[]` Cases retrieved successfully
     */
    caseControllerGetCases: (params: RequestParams = {}) =>
      this.request<CaseResponse[], any>({
        path: `/api/users/cases`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetUniversalCases
     * @summary Get universal cases without country/language restrictions (for battle creation)
     * @request GET:/api/users/cases/universal
     * @secure
     * @response `200` `(CaseResponse)[]` Universal cases retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerGetUniversalCases: (params: RequestParams = {}) =>
      this.request<CaseResponse[], void>({
        path: `/api/users/cases/universal`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseDetails
     * @summary Get case details
     * @request GET:/api/users/cases/{id}
     * @response `200` `CaseDetailsResponse` Case details retrieved successfully
     */
    caseControllerGetCaseDetails: (id: string, params: RequestParams = {}) =>
      this.request<CaseDetailsResponse, any>({
        path: `/api/users/cases/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseItem
     * @summary Get case item details
     * @request GET:/api/users/cases/{caseId}/items/{hashName}
     * @response `200` `CaseItemResponse` Case item details retrieved successfully
     */
    caseControllerGetCaseItem: (
      caseId: string,
      hashName: string,
      params: RequestParams = {},
    ) =>
      this.request<CaseItemResponse, any>({
        path: `/api/users/cases/${caseId}/items/${hashName}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseItemDrops
     * @summary Get the most recent players who unboxed this item from this case
     * @request GET:/api/users/cases/{caseId}/items/{hashName}/drops
     * @response `200` `CaseItemDropsResponse` Recent drops retrieved successfully
     */
    caseControllerGetCaseItemDrops: (
      { caseId, hashName, ...query }: CaseControllerGetCaseItemDropsParams,
      params: RequestParams = {},
    ) =>
      this.request<CaseItemDropsResponse, any>({
        path: `/api/users/cases/${caseId}/items/${hashName}/drops`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerOpenCase
     * @summary Open a case (count times, defaults to 1)
     * @request POST:/api/users/cases/{id}/open
     * @secure
     * @response `200` `(OpenCaseResponse)[]` Case opened successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerOpenCase: (
      id: string,
      data: OpenCaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<OpenCaseResponse[], void>({
        path: `/api/users/cases/${id}/open`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetInventory
     * @summary Get user inventory with pagination
     * @request GET:/api/users/inventory
     * @secure
     * @response `200` `PaginatedInventoryResponse` Inventory retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerGetInventory: (
      query: InventoryControllerGetInventoryParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInventoryResponse, void>({
        path: `/api/users/inventory`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetInventoryItemDetails
     * @summary Get details of a specific inventory item (publicly viewable)
     * @request GET:/api/users/inventory/{id}
     * @response `200` `UserInventoryItemResponse` Item details retrieved successfully
     */
    inventoryControllerGetInventoryItemDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<UserInventoryItemResponse, any>({
        path: `/api/users/inventory/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerSellInventoryItem
     * @summary Sell an item from inventory
     * @request POST:/api/users/inventory/{id}/sell
     * @secure
     * @response `200` `SellItemResponse` Item sold successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerSellInventoryItem: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<SellItemResponse, void>({
        path: `/api/users/inventory/${id}/sell`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerSellAllInventoryItems
     * @summary Sell all available items from inventory
     * @request POST:/api/users/inventory/sell-all
     * @secure
     * @response `200` `SellAllItemsResponse` All items sold successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerSellAllInventoryItems: (params: RequestParams = {}) =>
      this.request<SellAllItemsResponse, void>({
        path: `/api/users/inventory/sell-all`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerSellInventoryItems
     * @summary Sell selected items from inventory
     * @request POST:/api/users/inventory/sell-batch
     * @secure
     * @response `200` `SellAllItemsResponse` Selected items sold successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerSellInventoryItems: (
      data: SellItems,
      params: RequestParams = {},
    ) =>
      this.request<SellAllItemsResponse, void>({
        path: `/api/users/inventory/sell-batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetRecentInventoryItems
     * @summary Get recent items from all users inventories (public)
     * @request GET:/api/users/inventory/recent
     * @response `200` `RecentItemsResponse` Recent items retrieved successfully
     */
    inventoryControllerGetRecentInventoryItems: (
      query: InventoryControllerGetRecentInventoryItemsParams,
      params: RequestParams = {},
    ) =>
      this.request<RecentItemsResponse, any>({
        path: `/api/users/inventory/recent`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetTopRecentDrops
     * @summary Get top drops from the last 24 hours, sorted by price (public)
     * @request GET:/api/users/inventory/top-recent-drops
     * @response `200` `TopRecentDropsResponse` Top recent drops retrieved successfully
     */
    inventoryControllerGetTopRecentDrops: (
      query: InventoryControllerGetTopRecentDropsParams,
      params: RequestParams = {},
    ) =>
      this.request<TopRecentDropsResponse, any>({
        path: `/api/users/inventory/top-recent-drops`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerWithdrawItem
     * @summary Withdraw item from inventory to Steam
     * @request POST:/api/users/inventory/{id}/withdraw
     * @secure
     * @response `200` `WithdrawItemResponse` Trade initiated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerWithdrawItem: (
      id: string,
      data: WithdrawItem,
      params: RequestParams = {},
    ) =>
      this.request<WithdrawItemResponse, void>({
        path: `/api/users/inventory/${id}/withdraw`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerCheckTradeStatus
     * @summary Check trade status for inventory item
     * @request POST:/api/users/inventory/{id}/check-trade
     * @secure
     * @response `200` `TradeStatusResponse` Trade status checked successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerCheckTradeStatus: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TradeStatusResponse, void>({
        path: `/api/users/inventory/${id}/check-trade`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerUpdateTradeLink
     * @summary Update Steam trade link
     * @request PUT:/api/users/trade-link
     * @secure
     * @response `200` `UpdateTradeLinkResponse` Trade link updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerUpdateTradeLink: (
      data: UpdateTradeLink,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTradeLinkResponse, void>({
        path: `/api/users/trade-link`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerCreateInvoice
     * @summary Create payment invoice
     * @request POST:/api/users/create-invoice
     * @secure
     * @response `200` `PaymentResponse` Invoice created successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    paymentControllerCreateInvoice: (
      data: CreateInvoice,
      params: RequestParams = {},
    ) =>
      this.request<PaymentResponse, void>({
        path: `/api/users/create-invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerGetPaymentSettings
     * @summary Get payment settings
     * @request GET:/api/users/payment-settings
     * @secure
     * @response `200` `PaymentSettingsResponse` Payment settings retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    paymentControllerGetPaymentSettings: (params: RequestParams = {}) =>
      this.request<PaymentSettingsResponse, void>({
        path: `/api/users/payment-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerGetPaymentProviders
     * @summary Get payment providers (filtered + ordered for current user)
     * @request GET:/api/users/payment-providers
     * @secure
     * @response `200` `PaymentProvidersResponse` OK
     * @response `403` `void` Forbidden. User authentication required.
     */
    paymentControllerGetPaymentProviders: (params: RequestParams = {}) =>
      this.request<PaymentProvidersResponse, void>({
        path: `/api/users/payment-providers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerList
     * @summary List bound Click cards
     * @request GET:/api/users/click-cards
     * @secure
     * @response `200` `ClickCardListResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerList: (params: RequestParams = {}) =>
      this.request<ClickCardListResponse, void>({
        path: `/api/users/click-cards`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerBind
     * @summary Bind a card — Click sends an SMS code
     * @request POST:/api/users/click-cards
     * @secure
     * @response `200` `BindClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerBind: (
      data: BindClickCard,
      params: RequestParams = {},
    ) =>
      this.request<BindClickCardResponse, void>({
        path: `/api/users/click-cards`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerVerify
     * @summary Confirm a bound card with the SMS code
     * @request POST:/api/users/click-cards/{id}/verify
     * @secure
     * @response `200` `ClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerVerify: (
      id: string,
      data: VerifyClickCard,
      params: RequestParams = {},
    ) =>
      this.request<ClickCardResponse, void>({
        path: `/api/users/click-cards/${id}/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerPay
     * @summary Charge a bound card
     * @request POST:/api/users/click-cards/{id}/pay
     * @secure
     * @response `200` `PayWithClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `409` `void` A charge for this amount is already running
     */
    clickCardControllerPay: (
      id: string,
      data: PayWithClickCard,
      params: RequestParams = {},
    ) =>
      this.request<PayWithClickCardResponse, void>({
        path: `/api/users/click-cards/${id}/pay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerRemove
     * @summary Remove a bound card
     * @request DELETE:/api/users/click-cards/{id}
     * @secure
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/api/users/click-cards/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Settings
     * @name ProfileSettingsControllerUpdateAnimationSetting
     * @summary Update case opening animation setting
     * @request PUT:/api/users/animation-setting
     * @secure
     * @response `200` `UpdateAnimationSettingResponse` Animation setting updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileSettingsControllerUpdateAnimationSetting: (
      data: UpdateAnimationSetting,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAnimationSettingResponse, void>({
        path: `/api/users/animation-setting`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Settings
     * @name ProfileSettingsControllerToggleNotifications
     * @summary Toggle notifications
     * @request PUT:/api/users/notifications
     * @secure
     * @response `200` `ToggleNotificationsResponse` Notifications setting updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileSettingsControllerToggleNotifications: (
      data: ToggleNotifications,
      params: RequestParams = {},
    ) =>
      this.request<ToggleNotificationsResponse, void>({
        path: `/api/users/notifications`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Settings
     * @name ProfileSettingsControllerUpdateLanguage
     * @summary Update user language preference
     * @request PUT:/api/users/language
     * @secure
     * @response `200` `UpdateLanguageResponse` Language updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileSettingsControllerUpdateLanguage: (
      data: UpdateLanguage,
      params: RequestParams = {},
    ) =>
      this.request<UpdateLanguageResponse, void>({
        path: `/api/users/language`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetDailyBonusStatus
     * @summary Get daily bonus status
     * @request GET:/api/users/daily-bonus/status
     * @secure
     * @response `200` `DailyBonusStatusResponse` Daily bonus status retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetDailyBonusStatus: (params: RequestParams = {}) =>
      this.request<DailyBonusStatusResponse, void>({
        path: `/api/users/daily-bonus/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerClaimDailyBonus
     * @summary Claim daily bonus
     * @request POST:/api/users/daily-bonus/claim
     * @secure
     * @response `200` `ClaimDailyBonusResponse` Daily bonus claimed successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerClaimDailyBonus: (params: RequestParams = {}) =>
      this.request<ClaimDailyBonusResponse, void>({
        path: `/api/users/daily-bonus/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerCheckSubscription
     * @summary Check user subscription to all active Telegram channels and award bonuses
     * @request POST:/api/users/check-subscription
     * @secure
     * @response `204` `void` Subscription checks scheduled successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerCheckSubscription: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/check-subscription`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetSubscriptionChannels
     * @summary Get list of available subscription channels with user subscription status
     * @request GET:/api/users/subscription-channels
     * @secure
     * @response `200` `SubscriptionChannelsResponse` Subscription channels retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetSubscriptionChannels: (params: RequestParams = {}) =>
      this.request<SubscriptionChannelsResponse, void>({
        path: `/api/users/subscription-channels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetComebackBonuses
     * @summary Get available comeback bonuses
     * @request GET:/api/users/comeback-bonus
     * @secure
     * @response `200` `ComebackBonusResponse` Comeback bonuses retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetComebackBonuses: (params: RequestParams = {}) =>
      this.request<ComebackBonusResponse, void>({
        path: `/api/users/comeback-bonus`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerClaimComebackBonus
     * @summary Claim a comeback bonus
     * @request POST:/api/users/comeback-bonus/{id}/claim
     * @secure
     * @response `200` `ClaimComebackBonusResponse` Comeback bonus claimed successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerClaimComebackBonus: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ClaimComebackBonusResponse, void>({
        path: `/api/users/comeback-bonus/${id}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetReferralBonusProgress
     * @summary Get progress towards next referral milestone bonus
     * @request GET:/api/users/referral-bonus-progress
     * @secure
     * @response `200` `ReferralBonusProgressResponse` Referral bonus progress retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetReferralBonusProgress: (params: RequestParams = {}) =>
      this.request<ReferralBonusProgressResponse, void>({
        path: `/api/users/referral-bonus-progress`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetOnboardingConfig
     * @summary Get onboarding screen configuration (task rewards, referral bonuses, case prices)
     * @request GET:/api/users/onboarding-config
     * @secure
     * @response `200` `OnboardingConfigResponse` Onboarding configuration retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetOnboardingConfig: (params: RequestParams = {}) =>
      this.request<OnboardingConfigResponse, void>({
        path: `/api/users/onboarding-config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetBoostChannels
     * @summary Get list of boost channels with user status
     * @request GET:/api/users/boost-channels
     * @secure
     * @response `200` `BoostChannelsStatusResponse` Boost channels retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetBoostChannels: (params: RequestParams = {}) =>
      this.request<BoostChannelsStatusResponse, void>({
        path: `/api/users/boost-channels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerActivateBoost
     * @summary Activate boost for a channel (after user has boosted via Telegram)
     * @request POST:/api/users/boost-channels/{channelId}/activate
     * @secure
     * @response `200` `ActivateBoostResponse` Boost activated successfully
     * @response `400` `void` Validation failed or boost already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerActivateBoost: (
      channelId: string,
      params: RequestParams = {},
    ) =>
      this.request<ActivateBoostResponse, void>({
        path: `/api/users/boost-channels/${channelId}/activate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerClaimBoostReward
     * @summary Claim daily boost reward
     * @request POST:/api/users/boost-channels/{channelId}/claim
     * @secure
     * @response `200` `ClaimBoostRewardResponse` Boost reward claimed successfully
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerClaimBoostReward: (
      channelId: string,
      params: RequestParams = {},
    ) =>
      this.request<ClaimBoostRewardResponse, void>({
        path: `/api/users/boost-channels/${channelId}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chicken Reward
     * @name ChickenRewardControllerTickChickenSpawn
     * @summary Probabilistic chicken spawn tick
     * @request POST:/api/users/chicken/tick
     * @secure
     * @response `200` `ChickenTickResponse` Chicken spawn tick evaluated
     * @response `403` `void` Forbidden. User authentication required.
     */
    chickenRewardControllerTickChickenSpawn: (params: RequestParams = {}) =>
      this.request<ChickenTickResponse, void>({
        path: `/api/users/chicken/tick`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chicken Reward
     * @name ChickenRewardControllerClaimChickenReward
     * @summary Claim chicken tap reward
     * @request POST:/api/users/chicken/claim
     * @secure
     * @response `200` `ClaimChickenRewardResponse` Chicken reward claimed successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    chickenRewardControllerClaimChickenReward: (
      data: ClaimChickenReward,
      params: RequestParams = {},
    ) =>
      this.request<ClaimChickenRewardResponse, void>({
        path: `/api/users/chicken/claim`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Resolves avatar via auth_identities: Telegram → Steam → placeholder.
     *
     * @tags Avatar
     * @name AvatarControllerGetUserAvatar
     * @summary Get user avatar by userId
     * @request GET:/api/users/avatar/{userId}
     * @response `200` `void` User avatar image or gray placeholder
     */
    avatarControllerGetUserAvatar: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/users/avatar/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpStatus
     * @summary Get user XP status
     * @request GET:/api/users/xp/status
     * @secure
     * @response `200` `XpStatusResponse` XP status retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpStatus: (params: RequestParams = {}) =>
      this.request<XpStatusResponse, void>({
        path: `/api/users/xp/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpHistory
     * @summary Get user XP transaction history
     * @request GET:/api/users/xp/history
     * @secure
     * @response `200` `XpHistoryResponse` XP history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpHistory: (
      query: XpControllerGetXpHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<XpHistoryResponse, void>({
        path: `/api/users/xp/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpConfig
     * @summary Get XP configuration
     * @request GET:/api/users/xp/config
     * @secure
     * @response `200` `XpConfigResponse` XP configuration retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpConfig: (params: RequestParams = {}) =>
      this.request<XpConfigResponse, void>({
        path: `/api/users/xp/config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetLevelBonusesStatus
     * @summary Get level bonuses status
     * @request GET:/api/users/xp/level-bonuses
     * @secure
     * @response `200` `LevelBonusesStatusResponse` Level bonuses status retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetLevelBonusesStatus: (params: RequestParams = {}) =>
      this.request<LevelBonusesStatusResponse, void>({
        path: `/api/users/xp/level-bonuses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerClaimLevelBonus
     * @summary Claim level bonus
     * @request POST:/api/users/xp/level-bonuses/{level}/claim
     * @secure
     * @response `200` `ClaimLevelBonusResponse` Level bonus claimed successfully
     * @response `400` `void` Bonus already claimed, forfeit, or level not reached
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerClaimLevelBonus: (level: number, params: RequestParams = {}) =>
      this.request<ClaimLevelBonusResponse, void>({
        path: `/api/users/xp/level-bonuses/${level}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpLeaderboard
     * @summary Get XP leaderboard with pagination
     * @request GET:/api/users/xp/leaderboard
     * @secure
     * @response `200` `XpLeaderboardResponse` Leaderboard retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpLeaderboard: (
      query: XpControllerGetXpLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<XpLeaderboardResponse, void>({
        path: `/api/users/xp/leaderboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpLeaderboardNeighbors
     * @summary Get neighboring users in XP leaderboard (3 above + current + 3 below = up to 7 users)
     * @request GET:/api/users/xp/leaderboard/neighbors
     * @secure
     * @response `200` `XpLeaderboardNeighborsResponse` Neighbors retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` User not found
     */
    xpControllerGetXpLeaderboardNeighbors: (params: RequestParams = {}) =>
      this.request<XpLeaderboardNeighborsResponse, void>({
        path: `/api/users/xp/leaderboard/neighbors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerGetActiveDraws
     * @summary Get active draws with user participation status
     * @request GET:/api/draws
     * @secure
     * @response `200` `ActiveDrawsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    drawsControllerGetActiveDraws: (params: RequestParams = {}) =>
      this.request<ActiveDrawsResponse, void>({
        path: `/api/draws`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerGetWinnersHistory
     * @summary Get draws winners history
     * @request GET:/api/draws/winners
     * @response `200` `(DrawWinner)[]`
     */
    drawsControllerGetWinnersHistory: (
      query: DrawsControllerGetWinnersHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<DrawWinner[], any>({
        path: `/api/draws/winners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerGetDrawParticipants
     * @summary Get draw participants with pagination
     * @request GET:/api/draws/{id}/participants
     * @response `200` `DrawParticipants`
     */
    drawsControllerGetDrawParticipants: (
      { id, ...query }: DrawsControllerGetDrawParticipantsParams,
      params: RequestParams = {},
    ) =>
      this.request<DrawParticipants, any>({
        path: `/api/draws/${id}/participants`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerBuyEntry
     * @summary Buy entry to a paid draw
     * @request POST:/api/draws/buy-entry
     * @secure
     * @response `200` `void` Successfully purchased draw entry
     * @response `400` `void` Insufficient balance, already participating, or draw is free
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` No active draw found for the specified type
     */
    drawsControllerBuyEntry: (data: BuyDrawEntry, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/draws/buy-entry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Giveaways
     * @name GiveawaysControllerGetGiveaway
     * @summary Get giveaway details with its case
     * @request GET:/api/giveaways/{id}
     * @response `200` `GiveawayDetailsResponse`
     * @response `404` `void` Giveaway not found
     */
    giveawaysControllerGetGiveaway: (id: string, params: RequestParams = {}) =>
      this.request<GiveawayDetailsResponse, void>({
        path: `/api/giveaways/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Giveaways
     * @name GiveawaysControllerGetParticipants
     * @summary Get giveaway participants with pagination
     * @request GET:/api/giveaways/{id}/participants
     * @response `200` `GiveawayParticipantsResponse`
     */
    giveawaysControllerGetParticipants: (
      { id, ...query }: GiveawaysControllerGetParticipantsParams,
      params: RequestParams = {},
    ) =>
      this.request<GiveawayParticipantsResponse, any>({
        path: `/api/giveaways/${id}/participants`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Giveaways
     * @name GiveawaysControllerJoin
     * @summary Join a giveaway
     * @request POST:/api/giveaways/{id}/join
     * @secure
     * @response `200` `JoinGiveawayResponse`
     * @response `400` `void` Giveaway expired or already completed
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Giveaway not found
     * @response `422` `void` Cannot participate (already participating, no trade URL, no deposit, IP/referral restriction)
     */
    giveawaysControllerJoin: (id: string, params: RequestParams = {}) =>
      this.request<JoinGiveawayResponse, void>({
        path: `/api/giveaways/${id}/join`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetDailyGiveaways
     * @summary Get active daily giveaways (compact — for home cards)
     * @request GET:/api/users/daily-giveaways
     * @response `200` `DailyGiveawaysResponse`
     */
    dailyGiveawayControllerGetDailyGiveaways: (params: RequestParams = {}) =>
      this.request<DailyGiveawaysResponse, any>({
        path: `/api/users/daily-giveaways`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetDailyGiveawayDetails
     * @summary Get one daily giveaway header (prize, case, round, my place)
     * @request GET:/api/users/daily-giveaways/{id}
     * @response `200` `DailyGiveawayDetailResponse`
     * @response `404` `void` Daily giveaway not found
     */
    dailyGiveawayControllerGetDailyGiveawayDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DailyGiveawayDetailResponse, void>({
        path: `/api/users/daily-giveaways/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetLeaderboard
     * @summary Paginated leaderboard for the current round
     * @request GET:/api/users/daily-giveaways/{id}/leaderboard
     * @response `200` `DailyGiveawayLeaderboardPage`
     */
    dailyGiveawayControllerGetLeaderboard: (
      { id, ...query }: DailyGiveawayControllerGetLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<DailyGiveawayLeaderboardPage, any>({
        path: `/api/users/daily-giveaways/${id}/leaderboard`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetWinners
     * @summary Paginated past winners
     * @request GET:/api/users/daily-giveaways/{id}/winners
     * @response `200` `DailyGiveawayWinnersPage`
     * @response `404` `void` Daily giveaway not found
     */
    dailyGiveawayControllerGetWinners: (
      { id, ...query }: DailyGiveawayControllerGetWinnersParams,
      params: RequestParams = {},
    ) =>
      this.request<DailyGiveawayWinnersPage, void>({
        path: `/api/users/daily-giveaways/${id}/winners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Referral Contest
     * @name ReferralContestControllerGetLeaderboard
     * @summary August referral contest leaderboard (top inviters by activated referrals)
     * @request GET:/api/users/referral-contest/leaderboard
     * @response `200` `ReferralContestLeaderboardResponse`
     */
    referralContestControllerGetLeaderboard: (
      query: ReferralContestControllerGetLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<ReferralContestLeaderboardResponse, any>({
        path: `/api/users/referral-contest/leaderboard`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Receives updates from Telegram when bot is in webhook mode
     *
     * @tags Webhooks
     * @name WebhookControllerHandleTelegramUpdate
     * @summary Telegram bot webhook
     * @request POST:/api/webhooks/telegram
     * @response `200` `void` Update processed successfully
     * @response `403` `void` Invalid secret token
     */
    webhookControllerHandleTelegramUpdate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/webhooks/telegram`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives updates from Telegram for the support bot when in webhook mode
     *
     * @tags Webhooks
     * @name WebhookControllerHandleSupportUpdate
     * @summary Support bot webhook
     * @request POST:/api/webhooks/support
     * @response `200` `void` Update processed successfully
     * @response `403` `void` Invalid secret token
     */
    webhookControllerHandleSupportUpdate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/webhooks/support`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Handles Skinsback payment notifications when user completes skin deposit
     *
     * @tags Webhooks
     * @name WebhookControllerHandleSkinsbackWebhook
     * @summary Skinsback payment webhook
     * @request POST:/api/webhooks/payment/skinsback
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleSkinsbackWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/skinsback`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Handles NOROS P2P payment notifications when user completes payment
     *
     * @tags Webhooks
     * @name WebhookControllerHandleNorosP2PWebhook
     * @summary NOROS P2P payment webhook
     * @request POST:/api/webhooks/payment/noros-p2p
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleNorosP2PWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/noros-p2p`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Handles Wata.pro SBP transaction notifications. Status is re-fetched from API for security.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleWataproSbpWebhook
     * @summary Wata.pro SBP payment webhook
     * @request POST:/api/webhooks/payment/watapro-sbp
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleWataproSbpWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/watapro-sbp`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives Safon session state-change notifications. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleSafonWebhook
     * @summary Safon payment webhook
     * @request POST:/api/webhooks/payment/safon
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleSafonWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/safon`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives RioPay order state-change callbacks. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand. Always answers 200 — RioPay fails the order when the callback is not acknowledged.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleRiopayWebhook
     * @summary RioPay SBP payment callback
     * @request POST:/api/webhooks/payment/riopay
     * @response `200` `void` Callback acknowledged
     */
    webhookControllerHandleRiopayWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/riopay`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives Uzum acquiring callbacks. The body carries no signature, so the provider re-fetches the authoritative order state via getOrderStatus before crediting. Always answers 200 — Uzum retries otherwise.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleUzumWebhook
     * @summary Uzum Checkout payment callback
     * @request POST:/api/webhooks/payment/uzum
     * @response `200` `void` Callback acknowledged
     */
    webhookControllerHandleUzumWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/uzum`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives 2328.io payment notifications. The body carries an HMAC sign, but the provider still re-fetches the authoritative state via /v1/payment/info before crediting. Always answers 200 — 2328 retries up to 5 times otherwise.
     *
     * @tags Webhooks
     * @name WebhookControllerHandle2328Webhook
     * @summary 2328.io crypto payment webhook
     * @request POST:/api/webhooks/payment/2328
     * @response `200` `void` Webhook acknowledged
     */
    webhookControllerHandle2328Webhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/2328`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives EasyPay Stripe events. The HMAC signature is verified over the raw body before anything is dispatched; an unsigned or stale event is rejected with 401 (EasyPay does not retry 4xx and raises an internal alert instead).
     *
     * @tags Webhooks
     * @name WebhookControllerHandleEasyPayWebhook
     * @summary EasyPay (Stripe USD) payment webhook
     * @request POST:/api/webhooks/payment/easypay
     * @response `200` `void` Webhook processed
     * @response `401` `void` Invalid signature
     */
    webhookControllerHandleEasyPayWebhook: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/webhooks/payment/easypay`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Click posts a urlencoded Prepare request to validate and reserve the order. The md5 sign_string is verified and a Click error-code envelope is returned.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleClickPrepare
     * @summary Click.uz SHOP API Prepare (action=0)
     * @request POST:/api/webhooks/payment/click/prepare
     * @response `200` `void` Prepare processed
     */
    webhookControllerHandleClickPrepare: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/click/prepare`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Click posts a urlencoded Complete request confirming funds. The md5 sign_string is verified and, on success, the balance is credited via the shared payment chokepoint (idempotent under retries).
     *
     * @tags Webhooks
     * @name WebhookControllerHandleClickComplete
     * @summary Click.uz SHOP API Complete (action=1)
     * @request POST:/api/webhooks/payment/click/complete
     * @response `200` `void` Complete processed
     */
    webhookControllerHandleClickComplete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/click/complete`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Realtime
     * @name RealtimeControllerGetToken
     * @summary Get Centrifugo connection token
     * @request GET:/api/users/realtime/token
     * @secure
     * @response `200` `CentrifugoTokenResponse` Token generated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    realtimeControllerGetToken: (params: RequestParams = {}) =>
      this.request<CentrifugoTokenResponse, void>({
        path: `/api/users/realtime/token`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Realtime
     * @name RealtimeControllerHeartbeat
     * @summary Report current presence (online + activity)
     * @request POST:/api/users/realtime/heartbeat
     * @secure
     * @response `200` `HeartbeatResponse` Heartbeat recorded
     * @response `403` `void` Forbidden. User authentication required.
     */
    realtimeControllerHeartbeat: (
      data: HeartbeatRequest,
      params: RequestParams = {},
    ) =>
      this.request<HeartbeatResponse, void>({
        path: `/api/users/realtime/heartbeat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Realtime
     * @name RealtimeControllerGetOnlineCount
     * @summary Get online users count (public)
     * @request GET:/api/users/realtime/online
     * @response `200` `OnlineCountResponse` Online count retrieved
     */
    realtimeControllerGetOnlineCount: (params: RequestParams = {}) =>
      this.request<OnlineCountResponse, any>({
        path: `/api/users/realtime/online`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Read-only token limited to drops_feed, online_count and game_stats channels
     *
     * @tags Realtime
     * @name RealtimeControllerGetPublicToken
     * @summary Anonymous Centrifugo connection token (public channels only)
     * @request GET:/api/users/realtime/public-token
     * @response `200` `CentrifugoTokenResponse` Anonymous token generated
     */
    realtimeControllerGetPublicToken: (params: RequestParams = {}) =>
      this.request<CentrifugoTokenResponse, any>({
        path: `/api/users/realtime/public-token`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerCreateCaseBattle
     * @summary Create a new case battle
     * @request POST:/api/users/case-battles
     * @secure
     * @response `201` `CreateCaseBattleResponse` Case battle created successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerCreateCaseBattle: (
      data: CreateCaseBattleRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateCaseBattleResponse, void>({
        path: `/api/users/case-battles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetActiveCaseBattles
     * @summary Get all active (waiting) case battles
     * @request GET:/api/users/case-battles
     * @response `200` `(CaseBattleListItemResponse)[]` Active case battles retrieved successfully
     */
    caseBattleControllerGetActiveCaseBattles: (params: RequestParams = {}) =>
      this.request<CaseBattleListItemResponse[], any>({
        path: `/api/users/case-battles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetUserActiveBattlesCount
     * @summary Get user active battles count
     * @request GET:/api/users/case-battles/me/active-count
     * @secure
     * @response `200` `UserActiveBattlesCountResponse` User active battles count retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerGetUserActiveBattlesCount: (
      params: RequestParams = {},
    ) =>
      this.request<UserActiveBattlesCountResponse, void>({
        path: `/api/users/case-battles/me/active-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetAllCaseBattleHistory
     * @summary Get all completed case battles history
     * @request GET:/api/users/case-battles/history/all
     * @response `200` `CaseBattleHistoryPaginatedResponse` All case battles history retrieved successfully
     */
    caseBattleControllerGetAllCaseBattleHistory: (
      query: CaseBattleControllerGetAllCaseBattleHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<CaseBattleHistoryPaginatedResponse, any>({
        path: `/api/users/case-battles/history/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetUserCaseBattleHistory
     * @summary Get user case battle history
     * @request GET:/api/users/case-battles/history
     * @secure
     * @response `200` `CaseBattleHistoryPaginatedResponse` Case battle history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerGetUserCaseBattleHistory: (
      query: CaseBattleControllerGetUserCaseBattleHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<CaseBattleHistoryPaginatedResponse, void>({
        path: `/api/users/case-battles/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetCaseBattleDetails
     * @summary Get case battle details
     * @request GET:/api/users/case-battles/{id}
     * @response `200` `CaseBattleDetailsResponse` Case battle details retrieved successfully
     */
    caseBattleControllerGetCaseBattleDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CaseBattleDetailsResponse, any>({
        path: `/api/users/case-battles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerJoinCaseBattle
     * @summary Join a case battle
     * @request POST:/api/users/case-battles/{id}/join
     * @secure
     * @response `200` `void` Successfully joined the case battle
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerJoinCaseBattle: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/case-battles/${id}/join`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerLeaveCaseBattle
     * @summary Leave a case battle
     * @request POST:/api/users/case-battles/{id}/leave
     * @secure
     * @response `200` `void` Successfully left the case battle
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerLeaveCaseBattle: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/case-battles/${id}/leave`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerGetConfig
     * @summary Per-user Rush Mid availability (comingSoon = tease the tile, refuse entry)
     * @request GET:/api/users/rush-mid/config
     * @secure
     * @response `200` `RushMidConfigResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerGetConfig: (params: RequestParams = {}) =>
      this.request<RushMidConfigResponse, void>({
        path: `/api/users/rush-mid/config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerCreateOpenGame
     * @summary Create an open game on a side (matchMode 'bots' = solo/party practice — no stake, not listed). When the caller is in a party the ticket/mode/side come from the RATIFIED party row, not the request body — the request config only applies to a solo.
     * @request POST:/api/users/rush-mid/games
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING for a bots practice game)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerCreateOpenGame: (
      data: CreateOpenGameRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/games`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerListOpenGames
     * @summary List every public open (FORMING) game, newest first
     * @request GET:/api/users/rush-mid/games
     * @secure
     * @response `200` `OpenGamesListResponse` Open games list
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerListOpenGames: (params: RequestParams = {}) =>
      this.request<OpenGamesListResponse, void>({
        path: `/api/users/rush-mid/games`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerListLiveGames
     * @summary List every live (PLAYING) match — the «Идут сейчас» spectate list, newest first
     * @request GET:/api/users/rush-mid/games/live
     * @secure
     * @response `200` `LiveGamesListResponse` Live games list
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerListLiveGames: (params: RequestParams = {}) =>
      this.request<LiveGamesListResponse, void>({
        path: `/api/users/rush-mid/games/live`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerGetOpenGame
     * @summary One open game by id (404 once it fills, starts or closes)
     * @request GET:/api/users/rush-mid/games/{id}
     * @secure
     * @response `200` `OpenGame` Open game
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerGetOpenGame: (id: string, params: RequestParams = {}) =>
      this.request<OpenGame, void>({
        path: `/api/users/rush-mid/games/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerWatchGame
     * @summary Read-only spectator view of a live match (PLAYING/OVER; 404 while BUYING/not started or once gone)
     * @request GET:/api/users/rush-mid/games/{id}/watch
     * @secure
     * @response `200` `RushMidSpectateView` Spectator view
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerWatchGame: (id: string, params: RequestParams = {}) =>
      this.request<RushMidSpectateView, void>({
        path: `/api/users/rush-mid/games/${id}/watch`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerJoinOpenGame
     * @summary Join an open game on a side
     * @request POST:/api/users/rush-mid/games/{id}/join
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING if the join fills the house)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerJoinOpenGame: (
      id: string,
      data: JoinOpenGameRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/games/${id}/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerLeaveOpenGame
     * @summary Leave the open game (party leader takes the whole party out)
     * @request POST:/api/users/rush-mid/games/leave
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (NONE)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerLeaveOpenGame: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/games/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerCreateParty
     * @summary Create a party (caller becomes leader); returns the PARTY snapshot + code
     * @request POST:/api/users/rush-mid/party/create
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerCreateParty: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/create`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerJoinParty
     * @summary Join a party by its secret code
     * @request POST:/api/users/rush-mid/party/join
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerJoinParty: (
      data: PartyJoinRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerConfigParty
     * @summary Leader-only: set party mode/ticket/side (mode must fit the party size)
     * @request POST:/api/users/rush-mid/party/config
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerConfigParty: (
      data: PartyConfigRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/config`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerLeaveParty
     * @summary Leave the current party — individual for every role (leader hands off to the freshest survivor); frees the leaver's waiting-game seat with a refund
     * @request POST:/api/users/rush-mid/party/leave
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (NONE)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerLeaveParty: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerKickParty
     * @summary Leader-only: remove a member from the party (FORMING only)
     * @request POST:/api/users/rush-mid/party/kick
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerKickParty: (
      data: PartyKickRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/kick`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSetPartyReady
     * @summary Toggle your own ready flag in the party (leader starts once all ready)
     * @request POST:/api/users/rush-mid/party/ready
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSetPartyReady: (
      data: PartyReadyRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/ready`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSubmitLoadout
     * @summary Submit this player loadout for a match (starts when all players are ready)
     * @request POST:/api/users/rush-mid/match/{id}/loadout
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (BUYING / PLAYING)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSubmitLoadout: (
      id: string,
      data: SubmitLoadoutRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/match/${id}/loadout`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSubmitAction
     * @summary Submit this player action for the current round (shoot / grenade / medkit)
     * @request POST:/api/users/rush-mid/match/{id}/action
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (current/next PLAYING round, or OVER)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSubmitAction: (
      id: string,
      data: SubmitActionRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/match/${id}/action`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerLeaveMatch
     * @summary Dismiss a FINISHED match result screen (a live match cannot be left — an absent player is auto-piloted and settles normally)
     * @request POST:/api/users/rush-mid/match/{id}/leave
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (NONE)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerLeaveMatch: (id: string, params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/match/${id}/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSnapshot
     * @summary Poll the user's current Rush Mid snapshot (single source of truth)
     * @request GET:/api/users/rush-mid/snapshot
     * @secure
     * @response `200` `RushMidSnapshot` Snapshot
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSnapshot: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/snapshot`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerHistory
     * @summary Get the current user recent Rush Mid matches
     * @request GET:/api/users/rush-mid/history
     * @secure
     * @response `200` `RushMidHistoryResponse` Rush Mid history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerHistory: (
      query: RushMidControllerHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<RushMidHistoryResponse, void>({
        path: `/api/users/rush-mid/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerRating
     * @summary The caller's ELO rating + top-50 leaderboard for a mode
     * @request GET:/api/users/rush-mid/rating
     * @secure
     * @response `200` `RushMidRatingResponse` Rating + leaderboard retrieved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerRating: (
      query: RushMidControllerRatingParams,
      params: RequestParams = {},
    ) =>
      this.request<RushMidRatingResponse, void>({
        path: `/api/users/rush-mid/rating`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerGetSkins
     * @summary The user's saved fighter skin per side (to prefill the lobby picker)
     * @request GET:/api/users/rush-mid/skins
     * @secure
     * @response `200` `RushMidSkinsResponse` Saved skins per side
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerGetSkins: (params: RequestParams = {}) =>
      this.request<RushMidSkinsResponse, void>({
        path: `/api/users/rush-mid/skins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSaveLobbyConfig
     * @summary Persist the solo lobby config (ticket/mode/side/matchMode) on every change, so the lobby restores it on reopen
     * @request POST:/api/users/rush-mid/lobby-config
     * @secure
     * @response `200` `void` saved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSaveLobbyConfig: (
      data: JoinMatchmakingRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/rush-mid/lobby-config`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSetSkin
     * @summary Save the chosen fighter skin for one side (t / ct)
     * @request PUT:/api/users/rush-mid/skin
     * @secure
     * @response `200` `void` Skin saved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSetSkin: (
      data: SetRushMidSkinRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/rush-mid/skin`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSetWeaponSkin
     * @summary Put on (or take off) a weapon skin for one weapon key
     * @request PUT:/api/users/rush-mid/weapon-skin
     * @secure
     * @response `200` `void` Weapon skin saved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSetWeaponSkin: (
      data: SetRushMidWeaponSkinRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/rush-mid/weapon-skin`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerMatchDetail
     * @summary Full detail + replay of one of the user's past matches
     * @request GET:/api/users/rush-mid/match/{id}/detail
     * @secure
     * @response `200` `RushMidMatchDetail` Match detail retrieved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerMatchDetail: (id: string, params: RequestParams = {}) =>
      this.request<RushMidMatchDetail, void>({
        path: `/api/users/rush-mid/match/${id}/detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerReplay
     * @summary Shareable replay of any finished match (any signed-in user)
     * @request GET:/api/users/rush-mid/replay/{id}
     * @secure
     * @response `200` `RushMidReplay` Replay retrieved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerReplay: (id: string, params: RequestParams = {}) =>
      this.request<RushMidReplay, void>({
        path: `/api/users/rush-mid/replay/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerGames
     * @summary Ticket presets plus every live game (OPEN + COUNTDOWN) with its stake, seats and bullets
     * @request GET:/api/users/roulette/games
     * @secure
     * @response `200` `RouletteGames`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerGames: (params: RequestParams = {}) =>
      this.request<RouletteGames, void>({
        path: `/api/users/roulette/games`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerCreateGame
     * @summary Create a game with your own ticket, seats and bullets — or seat into an OPEN game with identical parameters
     * @request POST:/api/users/roulette/games
     * @secure
     * @response `201` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerCreateGame: (
      data: RouletteCreateGameRequest,
      params: RequestParams = {},
    ) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/games`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerJoinGame
     * @summary Join THIS specific game (debits the stake) — refused if full, started or the caller is already seated
     * @request POST:/api/users/roulette/games/{id}/join
     * @secure
     * @response `201` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerJoinGame: (id: string, params: RequestParams = {}) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/games/${id}/join`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerLeaveGame
     * @summary Leave a filling lobby (refunds the stake) — refused once the house is full or the game is live
     * @request POST:/api/users/roulette/games/leave
     * @secure
     * @response `201` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerLeaveGame: (params: RequestParams = {}) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/games/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerState
     * @summary Poll the caller's current roulette status: none | match (lobby, countdown or live game)
     * @request GET:/api/users/roulette/state
     * @secure
     * @response `200` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerState: (params: RequestParams = {}) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/state`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerMatch
     * @summary A match snapshot — never leaks the server seed, bullet positions or event log before FINISHED/CANCELLED
     * @request GET:/api/users/roulette/matches/{id}
     * @secure
     * @response `200` `RouletteMatch`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerMatch: (id: string, params: RequestParams = {}) =>
      this.request<RouletteMatch, void>({
        path: `/api/users/roulette/matches/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerPull
     * @summary Pull the trigger — only the current shooter may call this
     * @request POST:/api/users/roulette/matches/{id}/pull
     * @secure
     * @response `201` `RouletteMatch`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerPull: (id: string, params: RequestParams = {}) =>
      this.request<RouletteMatch, void>({
        path: `/api/users/roulette/matches/${id}/pull`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerSkip
     * @summary Skip your turn (debits the skip cost) — only the current shooter, within the per-player limit
     * @request POST:/api/users/roulette/matches/{id}/skip
     * @secure
     * @response `201` `RouletteMatch`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerSkip: (id: string, params: RequestParams = {}) =>
      this.request<RouletteMatch, void>({
        path: `/api/users/roulette/matches/${id}/skip`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerHistory
     * @summary My finished/cancelled matches, newest first
     * @request GET:/api/users/roulette/history
     * @secure
     * @response `200` `RouletteHistoryResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerHistory: (
      query: RouletteControllerHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<RouletteHistoryResponse, void>({
        path: `/api/users/roulette/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerFeed
     * @summary Global feed of every player's finished matches, newest first — headline winner + the skin they won
     * @request GET:/api/users/roulette/feed
     * @secure
     * @response `200` `RouletteFeedResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerFeed: (
      query: RouletteControllerFeedParams,
      params: RequestParams = {},
    ) =>
      this.request<RouletteFeedResponse, void>({
        path: `/api/users/roulette/feed`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerFairness
     * @summary Provably-fair reveal — server seed, event log and bullet layouts only once FINISHED/CANCELLED
     * @request GET:/api/users/roulette/matches/{id}/fairness
     * @secure
     * @response `200` `RouletteFairness`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerFairness: (id: string, params: RequestParams = {}) =>
      this.request<RouletteFairness, void>({
        path: `/api/users/roulette/matches/${id}/fairness`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetRounds
     * @summary Today's active raffle rounds, one per ticket tier, ticket ASC
     * @request GET:/api/rush-raffle/rounds
     * @secure
     * @response `200` `RushRaffleRoundsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushRaffleControllerGetRounds: (params: RequestParams = {}) =>
      this.request<RushRaffleRoundsResponse, void>({
        path: `/api/rush-raffle/rounds`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetRoundDetail
     * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
     * @request GET:/api/rush-raffle/rounds/{id}
     * @secure
     * @response `200` `RushRaffleRoundDetail`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Round not found
     */
    rushRaffleControllerGetRoundDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<RushRaffleRoundDetail, void>({
        path: `/api/rush-raffle/rounds/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetWinners
     * @summary Recent completed raffle rounds with a winner, last 14 days, newest first
     * @request GET:/api/rush-raffle/winners
     * @secure
     * @response `200` `RushRaffleWinnersResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushRaffleControllerGetWinners: (params: RequestParams = {}) =>
      this.request<RushRaffleWinnersResponse, void>({
        path: `/api/rush-raffle/winners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetMatchAward
     * @summary The caller's raffle ticket award for a finished Rush Mid match (null if none)
     * @request GET:/api/rush-raffle/match/{matchId}/award
     * @secure
     * @response `200` `RushRaffleMatchAward` null when the caller earned no award for this match
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushRaffleControllerGetMatchAward: (
      matchId: string,
      params: RequestParams = {},
    ) =>
      this.request<RushRaffleMatchAward, void>({
        path: `/api/rush-raffle/match/${matchId}/award`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetStatus
     * @summary SHOT BAND membership status and balances
     * @request GET:/api/users/band/status
     * @secure
     * @response `200` `BandStatusResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetStatus: (params: RequestParams = {}) =>
      this.request<BandStatusResponse, void>({
        path: `/api/users/band/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetTicketPrices
     * @summary Exact SHOT BAND pass price per available payment provider
     * @request GET:/api/users/band/ticket/prices
     * @secure
     * @response `200` `BandTicketPricesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetTicketPrices: (params: RequestParams = {}) =>
      this.request<BandTicketPricesResponse, void>({
        path: `/api/users/band/ticket/prices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerCreateTicketInvoice
     * @summary Create a payment invoice for the SHOT BAND ticket
     * @request POST:/api/users/band/create-ticket-invoice
     * @secure
     * @response `201` `BandTicketInvoiceResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerCreateTicketInvoice: (
      data: CreateBandTicketInvoice,
      params: RequestParams = {},
    ) =>
      this.request<BandTicketInvoiceResponse, void>({
        path: `/api/users/band/create-ticket-invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerPayTicketWithClickCard
     * @summary Charge a bound Click card for SHOT BAND access
     * @request POST:/api/users/band/ticket/pay-with-click-card
     * @secure
     * @response `200` `PayBandTicketWithClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerPayTicketWithClickCard: (
      data: PayBandTicketWithClickCard,
      params: RequestParams = {},
    ) =>
      this.request<PayBandTicketWithClickCardResponse, void>({
        path: `/api/users/band/ticket/pay-with-click-card`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerClaimCashback
     * @summary Claim matured SHOT BAND cashback sparks
     * @request POST:/api/users/band/cashback/claim
     * @secure
     * @response `200` `ClaimBandCashbackResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerClaimCashback: (params: RequestParams = {}) =>
      this.request<ClaimBandCashbackResponse, void>({
        path: `/api/users/band/cashback/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetMembersPreview
     * @summary Active member count and a few freshest member ids for the home promo
     * @request GET:/api/users/band/members-preview
     * @secure
     * @response `200` `BandMembersPreviewResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetMembersPreview: (params: RequestParams = {}) =>
      this.request<BandMembersPreviewResponse, void>({
        path: `/api/users/band/members-preview`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetFreeCases
     * @summary Free SHOT BAND case opens unlocked by the day’s wager turnover
     * @request GET:/api/users/band/free-cases
     * @secure
     * @response `200` `BandFreeCasesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetFreeCases: (params: RequestParams = {}) =>
      this.request<BandFreeCasesResponse, void>({
        path: `/api/users/band/free-cases`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetQuests
     * @summary Today's SHOT BAND daily quests, progress and streak
     * @request GET:/api/users/band/quests
     * @secure
     * @response `200` `BandQuestsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetQuests: (params: RequestParams = {}) =>
      this.request<BandQuestsResponse, void>({
        path: `/api/users/band/quests`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerClaimQuest
     * @summary Claim a completed SHOT BAND daily quest
     * @request POST:/api/users/band/quests/{questId}/claim
     * @secure
     * @response `200` `BandQuestsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerClaimQuest: (questId: string, params: RequestParams = {}) =>
      this.request<BandQuestsResponse, void>({
        path: `/api/users/band/quests/${questId}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerGetRound
     * @summary This week's knife raffle — prize, live pot, caller stats and ticket balance
     * @request GET:/api/users/band-raffle/round
     * @secure
     * @response `200` `BandRaffleRoundResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaffleControllerGetRound: (params: RequestParams = {}) =>
      this.request<BandRaffleRoundResponse, void>({
        path: `/api/users/band-raffle/round`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerInvest
     * @summary Invest raffle tickets into the round — irreversible, members only
     * @request POST:/api/users/band-raffle/round/{id}/invest
     * @secure
     * @response `200` `InvestBandRaffleTicketsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Round not found
     */
    bandRaffleControllerInvest: (
      id: string,
      data: InvestBandRaffleTickets,
      params: RequestParams = {},
    ) =>
      this.request<InvestBandRaffleTicketsResponse, void>({
        path: `/api/users/band-raffle/round/${id}/invest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerGetRoundDetail
     * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
     * @request GET:/api/users/band-raffle/round/{id}
     * @secure
     * @response `200` `BandRaffleRoundDetail`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Round not found
     */
    bandRaffleControllerGetRoundDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<BandRaffleRoundDetail, void>({
        path: `/api/users/band-raffle/round/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerGetWinners
     * @summary Completed weekly rounds with a winner, last 30 days, newest first
     * @request GET:/api/users/band-raffle/winners
     * @secure
     * @response `200` `BandRaffleWinnersResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaffleControllerGetWinners: (params: RequestParams = {}) =>
      this.request<BandRaffleWinnersResponse, void>({
        path: `/api/users/band-raffle/winners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandRaceControllerGetDetails
     * @summary Today's SHOT BAND wager race: prize, timer, my place
     * @request GET:/api/users/band/race/details
     * @secure
     * @response `200` `BandRaceDetailsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaceControllerGetDetails: (params: RequestParams = {}) =>
      this.request<BandRaceDetailsResponse, void>({
        path: `/api/users/band/race/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandRaceControllerGetLeaderboard
     * @summary Today's race leaderboard page
     * @request GET:/api/users/band/race/leaderboard
     * @secure
     * @response `200` `BandRaceLeaderboardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaceControllerGetLeaderboard: (
      query: BandRaceControllerGetLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<BandRaceLeaderboardResponse, void>({
        path: `/api/users/band/race/leaderboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandRaceControllerGetWinners
     * @summary Past race winners, newest first
     * @request GET:/api/users/band/race/winners
     * @secure
     * @response `200` `BandRaceWinnersResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaceControllerGetWinners: (
      query: BandRaceControllerGetWinnersParams,
      params: RequestParams = {},
    ) =>
      this.request<BandRaceWinnersResponse, void>({
        path: `/api/users/band/race/winners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetCatalog
     * @summary Full achievement catalog with viewer-aware redaction of hidden rules. Response carries all locales — client picks display lang.
     * @request GET:/api/achievements/catalog
     * @response `200` `CatalogResponse`
     */
    achievementsControllerGetCatalog: (params: RequestParams = {}) =>
      this.request<CatalogResponse, any>({
        path: `/api/achievements/catalog`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetMy
     * @summary Authenticated user's merged catalog + unlock + progress view
     * @request GET:/api/users/me/achievements
     * @secure
     * @response `200` `MergedAchievementsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerGetMy: (
      query: AchievementsControllerGetMyParams,
      params: RequestParams = {},
    ) =>
      this.request<MergedAchievementsResponse, void>({
        path: `/api/users/me/achievements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetClaimableRewards
     * @summary Sum of rewards for the user's unlocked-but-uncredited achievements (snapshot=0), plus whether they have a payment in the last 30 days and whether the claim endpoint may be called.
     * @request GET:/api/achievements/claimable-rewards
     * @secure
     * @response `200` `ClaimableAchievementRewards`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerGetClaimableRewards: (params: RequestParams = {}) =>
      this.request<ClaimableAchievementRewards, void>({
        path: `/api/achievements/claimable-rewards`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerClaimRewards
     * @summary Credit the user's unlocked-but-uncredited achievements (snapshot=0). All-time deposits must cover 100% of the claimable bonus (all-or-nothing). Idempotent — re-claim grants nothing.
     * @request POST:/api/achievements/claim-rewards
     * @secure
     * @response `200` `ClaimAchievementRewardsResult`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerClaimRewards: (params: RequestParams = {}) =>
      this.request<ClaimAchievementRewardsResult, void>({
        path: `/api/achievements/claim-rewards`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetForUser
     * @summary Public profile view of another user's achievements; hidden+target-locked redact
     * @request GET:/api/users/{userId}/achievements
     * @response `200` `MergedAchievementsResponse`
     */
    achievementsControllerGetForUser: (
      { userId, ...query }: AchievementsControllerGetForUserParams,
      params: RequestParams = {},
    ) =>
      this.request<MergedAchievementsResponse, any>({
        path: `/api/users/${userId}/achievements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetStats
     * @summary Per-key unlock count (Redis-cached 60s) + active-user denominator (Redis-cached 1h). Anon sees 404 for hidden rules.
     * @request GET:/api/achievements/{key}/stats
     * @response `200` `AchievementStats`
     */
    achievementsControllerGetStats: (key: string, params: RequestParams = {}) =>
      this.request<AchievementStats, any>({
        path: `/api/achievements/${key}/stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetRecentReceivers
     * @summary Newest 10 unlocks for a key plus totalReceivers, both served from the Redis cache maintained by the 30-min refresh job. Anti-scrape: requires auth.
     * @request GET:/api/achievements/{key}/recent-receivers
     * @secure
     * @response `200` `RecentReceiversResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerGetRecentReceivers: (
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<RecentReceiversResponse, void>({
        path: `/api/achievements/${key}/recent-receivers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyControllerSubmit
     * @summary Submit the product survey. One response per user — 409 if already submitted.
     * @request POST:/api/survey/response
     * @secure
     * @response `201` `SubmitSurveyResult`
     * @response `403` `void` Forbidden. User authentication required.
     */
    surveyControllerSubmit: (
      data: SubmitSurveyResponse,
      params: RequestParams = {},
    ) =>
      this.request<SubmitSurveyResult, void>({
        path: `/api/survey/response`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyControllerSaveDraft
     * @summary Upsert partial survey progress. 409 if the survey is already submitted.
     * @request PUT:/api/survey/draft
     * @secure
     * @response `200` `SaveSurveyDraftResult`
     * @response `403` `void` Forbidden. User authentication required.
     */
    surveyControllerSaveDraft: (
      data: SaveSurveyDraft,
      params: RequestParams = {},
    ) =>
      this.request<SaveSurveyDraftResult, void>({
        path: `/api/survey/draft`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyControllerMyStatus
     * @summary Whether the authenticated user has already submitted a survey (slug, default 'default').
     * @request GET:/api/survey/me/status
     * @secure
     * @response `200` `SurveyStatus`
     * @response `403` `void` Forbidden. User authentication required.
     */
    surveyControllerMyStatus: (
      query: SurveyControllerMyStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<SurveyStatus, void>({
        path: `/api/survey/me/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Device Signal
 * @name DeviceSignalControllerReport
 * @summary Report device fingerprint signal
 * @request POST:/api/users/device-signal
 * @secure
 * @response `200` `{
    success?: boolean,

}` Signal recorded
 * @response `403` `void` Forbidden. User authentication required.
 */
    deviceSignalControllerReport: (
      data: ReportDeviceSignal,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
        },
        void
      >({
        path: `/api/users/device-signal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTma
     * @summary Authenticate via Telegram Mini App initData. Idempotent — safe to call on every cold open.
     * @request POST:/api/auth/tma
     * @response `200` `AuthSessionResponse`
     */
    authControllerTma: (data: TmaAuth, params: RequestParams = {}) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/tma`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTelegramWidget
     * @summary Authenticate via Telegram Login Widget (browser web flow)
     * @request POST:/api/auth/telegram-widget
     * @response `200` `AuthSessionResponse`
     */
    authControllerTelegramWidget: (
      data: TelegramLogin,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/telegram-widget`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogout
     * @summary Destroy session and clear cookie
     * @request POST:/api/auth/logout
     * @response `200` `void`
     */
    authControllerLogout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/logout`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerWebHandoffInit
     * @summary Issue a single-use opaque token (Redis, TTL 60s) bound to the caller. Used by the TMA "Open in browser" flow to hand auth off to the web shell without putting initData into a URL hash.
     * @request POST:/api/auth/web-handoff/init
     * @secure
     * @response `200` `WebHandoffInitResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    authControllerWebHandoffInit: (params: RequestParams = {}) =>
      this.request<WebHandoffInitResponse, void>({
        path: `/api/auth/web-handoff/init`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerWebHandoffRedeem
     * @summary Atomically GETDEL the handoff token, create a session cookie, return the session principal.
     * @request POST:/api/auth/web-handoff/redeem
     * @response `200` `AuthSessionResponse`
     */
    authControllerWebHandoffRedeem: (
      data: WebHandoffRedeem,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/web-handoff/redeem`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerMe
     * @summary Return current session principal, or 401 if no valid cookie
     * @request GET:/api/auth/me
     * @response `200` `AuthSessionResponse`
     */
    authControllerMe: (params: RequestParams = {}) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerInitSteamLink
     * @summary Start Steam linking flow — returns redirect URL
     * @request POST:/api/users/link/steam/init
     * @secure
     * @response `200` `SteamLinkInitResponse` Redirect URL for Steam OpenID
     * @response `403` `void` Forbidden. User authentication required.
     */
    steamAuthControllerInitSteamLink: (
      query: SteamAuthControllerInitSteamLinkParams,
      params: RequestParams = {},
    ) =>
      this.request<SteamLinkInitResponse, void>({
        path: `/api/users/link/steam/init`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerLoginSteam
     * @summary Redirect to Steam OpenID for login
     * @request GET:/api/users/login/steam
     * @response `200` `void`
     */
    steamAuthControllerLoginSteam: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/users/login/steam`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerSteamCallback
     * @summary Steam OpenID callback (both link and login flows)
     * @request GET:/api/users/auth/steam/callback
     * @response `200` `void`
     */
    steamAuthControllerSteamCallback: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/users/auth/steam/callback`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerConnectSteamToTelegram
     * @summary Connect pending Steam to existing Telegram account
     * @request POST:/api/users/connect/steam
     * @response `200` `AuthSessionResponse` Steam linked, session created
     */
    steamAuthControllerConnectSteamToTelegram: (
      data: SteamConnect,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/users/connect/steam`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerRegisterWithSteam
     * @summary Register new account with pending Steam data
     * @request POST:/api/users/register/steam
     * @response `200` `AuthSessionResponse` New account created, session created
     */
    steamAuthControllerRegisterWithSteam: (
      data: SteamRegister,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/users/register/steam`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Telegram Link
     * @name TelegramLinkControllerLinkTelegram
     * @summary Link Telegram account to existing user
     * @request POST:/api/users/link/telegram
     * @secure
     * @response `200` `LinkTelegramResponse` Telegram linked successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    telegramLinkControllerLinkTelegram: (
      data: TelegramLogin,
      params: RequestParams = {},
    ) =>
      this.request<LinkTelegramResponse, void>({
        path: `/api/users/link/telegram`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerGetSummary
     * @summary Whether support has an unread answer for the caller
     * @request GET:/api/users/support/summary
     * @secure
     * @response `200` `SupportUserSummary`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerGetSummary: (params: RequestParams = {}) =>
      this.request<SupportUserSummary, void>({
        path: `/api/users/support/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerGetMessages
     * @summary The caller’s own conversation, oldest first, paging backwards in time
     * @request GET:/api/users/support/messages
     * @secure
     * @response `200` `SupportUserMessageList`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerGetMessages: (
      query: SupportControllerGetMessagesParams,
      params: RequestParams = {},
    ) =>
      this.request<SupportUserMessageList, void>({
        path: `/api/users/support/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerSendMessage
     * @summary Write to support; the first message opens the conversation
     * @request POST:/api/users/support/messages
     * @secure
     * @response `201` `SupportUserMessage`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerSendMessage: (
      data: SendSupportMessage,
      params: RequestParams = {},
    ) =>
      this.request<SupportUserMessage, void>({
        path: `/api/users/support/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerSendAttachment
     * @summary Attach a file to the conversation. Global upload limit is 5 MB.
     * @request POST:/api/users/support/attachments
     * @secure
     * @response `201` `SupportUserMessage`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerSendAttachment: (params: RequestParams = {}) =>
      this.request<SupportUserMessage, void>({
        path: `/api/users/support/attachments`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerMarkRead
     * @summary Mark support answers as read and clear the badge
     * @request POST:/api/users/support/read
     * @secure
     * @response `200` `SupportUserSummary`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerMarkRead: (params: RequestParams = {}) =>
      this.request<SupportUserSummary, void>({
        path: `/api/users/support/read`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerGetAttachmentContent
     * @summary Stream one attachment from the caller’s own conversation
     * @request GET:/api/users/support/attachments/{id}/content
     * @secure
     * @response `200` `void` The attachment content
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerGetAttachmentContent: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/support/attachments/${id}/content`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}
